var data = {
  "AM General": {
    "Hummer": {
      "1996": {
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "981A0010-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "981A0010-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "981A0010-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "981A0010-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "981A0014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "981A0014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "981A0014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    }
  },
  "Acura": {
    "ADX": {
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "CL": {
      "1997": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "3.2L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "3.2L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "3.2L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "CSX": {
      "2006": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "EL": {
      "1997": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "1.7L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "1.7L I4": {
          "Message": null,
          "PID": "BE1FA811-90000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "1.7L I4": {
          "Message": null,
          "PID": "BE3EB811-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "1.7L I4": {
          "Message": null,
          "PID": "BE3EA811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "1.7L I4": {
          "Message": null,
          "PID": "BE3EA811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "ILX": {
      "2013": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD08020-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "98188003-801FF011-FAD08020-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-9007E011-FAD08001-00000001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-A007F011-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-B007E011-FAD08001-00000001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.4L I4": {
          "Message": null,
          "PID": "B63CA813-B007E011-F2C08C01-07100001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.4L I4": {
          "Message": null,
          "PID": "B63CA813-B007A011-F2C2AC01-67114001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.4L I4": {
          "Message": null,
          "PID": "B63CA813-B007A011-F2C2AC01-67114001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.4L I4": {
          "Message": null,
          "PID": "B63CA813-B007A011-F2C2AC01-67114001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "2.4L I4": {
          "Message": null,
          "PID": "B63CA813-B007A011-F2C2AC01-67114001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Integra": {
      "1996": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "B63DA813-A007B011-FED08401-63004001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "B63DA813-A007B011-FED08401-63004001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "B63DA813-A007B011-FED08401-63004001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "MDX": {
      "2001": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA891-80021101-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA891-80021101-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA891-80021101-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA891-80021101-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-A01FF119-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-A01FF119-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-A01FF119-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.0L V6 Hybrid": {
          "Message": null,
          "PID": "BFBCA893-911FE019-F2C08F21-07100001-00000042",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-B11FE019-FAD08001-00000001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.0L V6 Hybrid": {
          "Message": null,
          "PID": "BFBCA893-911FE019-F2C08F21-07100001-00000042",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBCA893-B11FE019-FAC08F01-07100001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.0L V6 Hybrid": {
          "Message": null,
          "PID": "BFBCA893-911FE019-F2C08F21-07100001-00000042",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "B7BCA893-B11FE019-F2C08F01-07100001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.0L V6 Hybrid": {
          "Message": null,
          "PID": "BFBCA893-911FE019-F2C08F21-07100001-00000042",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBCA893-B11FE019-FAC08F01-07100001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BF9DA813-A007B111-FAD0AC01-63114001-0204000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BF9DA813-A007B111-FAD0AC01-63114001-0204000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BF9DA813-A007B111-FAD0AC01-63114001-0204000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BF9DA813-A007B111-FAD0AC01-63114001-0204000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "NSX": {
      "1996": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFBEA891-80001101-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "3.5L V6 Twin Turbo Hybrid": {
          "Message": null,
          "PID": "BFBCA893-B107E019-F3E08F21-07114001-00000042",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.5L V6 Twin Turbo Hybrid": {
          "Message": null,
          "PID": "BFBCA893-B107E019-F3E08F21-07114001-00000042",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.5L V6 Twin Turbo Hybrid": {
          "Message": null,
          "PID": "BFBCA893-B107E019-F3E08F21-07114001-00000042",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.5L V6 Twin Turbo Hybrid": {
          "Message": null,
          "PID": "BFBCA893-B107E019-F3E08F21-07114001-00000042",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BFBCA893-B107E019-F3E08F21-67114001-0004004F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBCA893-B107E019-F3E08F21-67114001-0004004F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "RDX": {
      "2007": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-801FF119-FAC08F01-07100001-07100001",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.5L V6": {
          "Message": null,
          "PID": "B7BCA893-911FE019-F2C08F01-07100001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "B63CA813-B007E011-F2C28C01-67114001-0004000E",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "B63CA813-B007E011-F2C28C01-67114001-0004000E",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "B63CA813-B007E011-F2C28C01-67114001-0004000E",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "B63CA813-B007A011-F2C28C01-67114001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "B63CA813-B007A011-F2C28C01-67114001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "B63CA813-B007A011-F2C28C01-67114001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "B63CA813-B007A011-F2C28C01-67114001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "RL": {
      "1996": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB910-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB910-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB910-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB910-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA891-80001101-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA891-80001101-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA891-80001101-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "RLX": {
      "2014": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-00000001-A01FF119-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BFBFA893-A01FF119-FAD08020-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-A01FF119-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-A01FF119-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BFBFA893-A01FF119-FAD08020-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-801FF119-FAC08F01-07100001-07100001",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BFBFA893-A01FF119-FAD08020-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.5L V6": {
          "Message": null,
          "PID": "B7BCA893-B11FE019-F2C08F01-07100001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BFBFA893-A01FF119-FAD08020-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.5L V6": {
          "Message": null,
          "PID": "B7BCA893-B11FE019-F2C08F01-07100001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BFBFA893-A01FF119-FAD08020-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.5L V6": {
          "Message": null,
          "PID": "B7BCA893-B11FE019-F2C08F01-07100001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "B7BCA893-B11FE019-F2C08F01-07100001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "RSX": {
      "2002": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA811-80001001-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA811-80001001-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "SLX": {
      "1996": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEB910-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "TL": {
      "1996": {
        "2.5L I5": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEB910-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "2.5L I5": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEB910-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "2.5L I5": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEB910-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.2L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.2L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.2L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEB995-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.2L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEA891-80001101-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEA891-80001101-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-00000001-A01FF119-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "TLX": {
      "2015": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-A007F011-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-A01FF119-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-A007F011-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-A01FF119-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.4L I4": {
          "Message": null,
          "PID": "B63CA813-B007E011-F2C08C01-07100001-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-B11FE019-FAD08001-00000001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.4L I4": {
          "Message": null,
          "PID": "B63CA813-B007E011-F2C08C01-07100001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBCA893-B11FE019-FAC08F01-07100001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.4L I4": {
          "Message": null,
          "PID": "B63CA813-B007A011-F2C2AC01-67114001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBCA893-B11FE019-FAC08F01-07100001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.4L I4": {
          "Message": null,
          "PID": "B63CA813-B007E011-F2C08C01-07100001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBCA893-B11FE019-FAC08F01-07100001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "B79DA813-A007B111-FAD0AC01-63114001-0204000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "B79DA813-A007B111-FAD0AC01-63114001-0204000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "B79DA813-A007B111-FAD0AC01-63114001-0204000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "B79DA813-A007B111-FAD0AC01-63114001-0204000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "TSX": {
      "2004": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA811-80001001-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA811-80001001-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA811-80001001-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-00000001-A01FF119-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "ZDX": {
      "2010": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    }
  },
  "Alfa Romeo": {
    "4C": {
      "2015": {
        "1.7L I4 Turbo": {
          "Message": null,
          "PID": "BE3DA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "1.7L I4 Turbo": {
          "Message": null,
          "PID": "BE3DA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "1.7L I4 Turbo": {
          "Message": null,
          "PID": "BE3DA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "1.7L I4 Turbo": {
          "Message": null,
          "PID": "BE3DA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "1.7L I4 Turbo": {
          "Message": null,
          "PID": "BE3DA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "1.7L I4 Turbo": {
          "Message": null,
          "PID": "BE3DA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Giulia": {
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3DA813-801FB011-FED09081-01214200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.9L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B111-F7C28541-00110001-00080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3DA813-801FB011-FED09081-01214000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.9L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B111-F7C28541-00110001-00080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3DA813-801FB011-FED09081-01214000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.9L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B111-F7C28541-00110001-00080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3DA813-801FB011-FED09081-01214000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.9L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE3DA813-801FB011-FED09081-01214000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3DA813-801FB011-FED09081-01214000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007B119-F7C38555-68110201-000C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007B119-F7C38555-68110201-000C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007B119-F7C38555-68110201-000C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007B119-F7C38555-68110201-000C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Stelvio": {
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3DA813-801FB011-FED09081-01214000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.9L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B111-F7C28541-00110001-00080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3DA813-801FB011-FED09081-01214000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.9L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B111-F7C28541-00110001-00080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3DA813-801FB011-FED09081-01214000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.9L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE3DA813-801FB011-FED09081-01214000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3DA813-801FB011-FED09081-01214000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007B119-F7C38555-68110201-000C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007B119-F7C38555-68110201-000C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007B119-F7C38555-68110201-000C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007B119-F7C38555-68110201-000C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Tonale": {
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    }
  },
  "Aston Martin": {
    "DB11": {
      "2017": {
        "5.2L V12 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.2L V12 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9EA893-8007B119-F7C08541-01190001-02080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.2L V12 Twin Turbo": {
          "Message": null,
          "PID": "BF9EA893-8007B119-F7C08541-01190001-02080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9EA893-8007B119-F7C08541-01190001-02080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.2L V12 Twin Turbo": {
          "Message": null,
          "PID": "BF9EA893-8007B119-F7C08541-01190001-02080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "DB12": {
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "DB7": {
      "1997": {
        "3.2L I6 Supercharged": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "3.2L I6 Supercharged": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "5.9L V12": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "5.9L V12": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "5.9L V12": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "5.9L V12": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "DB9": {
      "2005": {
        "5.9L V12": {
          "Message": null,
          "PID": "BF9FB993-C003A019-FEC00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "5.9L V12": {
          "Message": null,
          "PID": "BF9FB993-C003A019-FEC00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "5.9L V12": {
          "Message": null,
          "PID": "BF9FB993-C003A019-FEC00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "5.9L V12": {
          "Message": null,
          "PID": "BF9FB993-C003A019-FEC00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "5.9L V12": {
          "Message": null,
          "PID": "BF9FB993-C003A019-FEC00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "5.9L V12": {
          "Message": null,
          "PID": "BF9FB993-C003A019-FEC00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "5.9L V12": {
          "Message": null,
          "PID": "BF9FB993-C003A019-FEC00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "5.9L V12": {
          "Message": null,
          "PID": "BF9FB993-C007A019-FEC00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "5.9L V12": {
          "Message": null,
          "PID": "BF9FB993-C007A019-FEC00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "5.9L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "5.9L V12": {
          "Message": null,
          "PID": "BF9D8ABB-C007B559-F7C08501-01100001-00080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "5.9L V12": {
          "Message": null,
          "PID": "BF9FB993-C007A019-FEC00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "DBS": {
      "2008": {
        "5.9L V12": {
          "Message": null,
          "PID": "BF9FB993-C003A019-FEC00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "5.9L V12": {
          "Message": null,
          "PID": "BF9FB993-C003A019-FEC00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "5.9L V12": {
          "Message": null,
          "PID": "BF9FB993-C003A019-FEC00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "5.9L V12": {
          "Message": null,
          "PID": "BF9FB993-C003A019-FEC00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "5.9L V12": {
          "Message": null,
          "PID": "BF9FB993-C007A019-FEC00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "5.2L V12 Twin Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "DBX": {
      "2021": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Rapide": {
      "2010": {
        "5.9L V12": {
          "Message": null,
          "PID": "BF9FB993-C003A019-FEC00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "5.9L V12": {
          "Message": null,
          "PID": "BF9FB993-C003A019-FEC00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "5.9L V12": {
          "Message": null,
          "PID": "BF9FB993-C007A019-FEC00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "5.9L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "5.9L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "5.9L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "5.9L V12": {
          "Message": null,
          "PID": "BF9FB993-C007A019-FEC00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Vanquish": {
      "2002": {
        "5.9L V12": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "5.9L V12": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "5.9L V12": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "5.9L V12": {
          "Message": null,
          "PID": "BF9FB991-C0000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "5.9L V12": {
          "Message": null,
          "PID": "BF9FB991-C0000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "5.9L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "5.9L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "5.9L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "5.9L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "5.9L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Vantage": {
      "2006": {
        "4.3L V8": {
          "Message": null,
          "PID": "BFBFF993-C01BA019-FEE00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "4.3L V8": {
          "Message": null,
          "PID": "BFBFF993-C01BA019-FEE00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "4.3L V8": {
          "Message": null,
          "PID": "BFBFF993-C01BA019-FEE00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "4.3L V8": {
          "Message": null,
          "PID": "BFBFF993-C01BA019-FEE00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "4.7L V8": {
          "Message": null,
          "PID": "BFBFF993-C01BA019-FEE00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "4.7L V8": {
          "Message": null,
          "PID": "BFBFF993-C01BA019-FEE00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V12": {
          "Message": null,
          "PID": "BFBFF993-C01BA019-FEE00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "4.7L V8": {
          "Message": null,
          "PID": "BFBFF993-C01BA019-FEE00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V12": {
          "Message": null,
          "PID": "BFBFF993-C01BA019-FEE00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "4.7L V8": {
          "Message": null,
          "PID": "BFBFF993-C01BA019-FEE00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "4.7L V8": {
          "Message": null,
          "PID": "BFBFF993-C01BA019-FEE00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "4.7L V8": {
          "Message": null,
          "PID": "BFBFF993-C01BA019-FEE00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V12": {
          "Message": null,
          "PID": "BFBFF993-C01BA019-FEE00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FF993-C007A019-FEE00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V12": {
          "Message": null,
          "PID": "BF9FF993-C007A019-FEE00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "5.9L V12": {
          "Message": null,
          "PID": "BF9FB993-C007A019-FEC00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9EA893-8007B119-F7C08541-01190001-02080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9EA893-8007B119-F7C08541-01190001-02080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9EA893-8007B119-F7C08541-01190001-02080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Valour": {
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Virage": {
      "2012": {
        "5.9L V12": {
          "Message": null,
          "PID": "BF9FB993-C007A019-FEC00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    }
  },
  "Audi": {
    "80 Cabriolet": {
      "1996": {
        "2.8L V6": {
          "Message": null,
          "PID": "BF9DB990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "2.8L V6": {
          "Message": null,
          "PID": "BF9DB990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "2.8L V6": {
          "Message": null,
          "PID": "BF9DB990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "A3/S3": {
      "2006": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BF9FE893-8005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BF9FE893-8005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BF9FE893-8005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BF9FE893-8005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "98192013-9801A011-C4D2800D-EAA9A343-C0A00000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FEC13-A005B015-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "98192013-9801A011-C4D2800D-EAA9A343-C0A00000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FEC13-A005B015-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "98192013-9801A011-C4D2800D-EAA9A343-C0A00000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "98192013-9801A011-C4D2800D-EAA9A343-C0A00000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "9819A013-8001B015-CCD2800D-EAA9A343-E9A00000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.4L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3EE813-8007B011-FED09421-00090A00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "9819A013-8001B015-CCD2800D-EAA9A343-E9A00000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.4L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3EE813-8007B011-FED09421-00090A01-00000040",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007B011-FED08401-00090001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.4L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3EE813-8007B011-FED09421-00090A01-00000040",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-A007B011-FED08401-02010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007B011-FED08401-00090001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-A007B011-FED08401-6A010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007B011-FED08401-00090001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-A007B011-FED08401-6A010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "A4 Allroad": {
      "2013": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED0C400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A005B119-FED08501-03030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A007B011-FED0C400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A007B011-FED0C400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A007B011-FED0C400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-A007B011-FED08401-6A010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-A007B011-FED08401-6A010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE1EA813-A007B011-FED09401-62010001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE1EA813-A007B011-FED09401-62010001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE1EA813-A007B011-FED09401-62010001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE1EA813-A007B011-FED09401-62010001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "A4/S4": {
      "1996": {
        "2.8L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BF9DB990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE891-00001101-00000500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEA893-A005B119-FED00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEA893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE893-8005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFFEB993-A07FB199-FEFA3581-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEA893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE893-8005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEA893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE893-8005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A005B119-FED00501-01030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A005B119-FED00501-01030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A005B119-FED00501-01030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A005B119-FED08501-03030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A007B011-FED0C400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A007B119-FED08501-03030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A007B119-FED08501-03030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A007B011-FED0C400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A007B119-FED08501-03030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "BE1CA813-8007B011-FED08401-03090201-02000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "BE1CA813-8007B011-FED08401-03090201-02000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-A007B011-FED08401-6A010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-A007B011-FED08401-6A010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "983BA013-B019A001-CCD20000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "983BA013-B019A001-CCD20000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "983BA013-B019A001-CCD20000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "983BA013-B019A001-CCD20000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "A5/S5": {
      "2008": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEE893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEE893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A005B119-FED00501-01030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEE893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A005B119-FED00501-01030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A005B119-FED00501-01030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED0C400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A005B119-FED08501-03030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BFBEE893-A007B119-F7C08501-00100001-00080000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A007B011-FED0C400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A007B119-FED08501-03030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BFBEE893-A007B119-F7C08501-00100001-00080000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A007B011-FED0C400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A007B119-FED08501-03030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BFBEE893-A005B119-F7C08501-00100001-00080000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A007B011-FED0C400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A007B119-FED08501-03030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A007B011-FED0C400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A007B119-FED08501-03030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.9L V6 Twin Turbo": {
          "Message": null,
          "PID": "BF9CA893-8007B119-FED08501-6B090201-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "BE1CA813-8007B011-FED08401-03090201-02000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.9L V6 Twin Turbo": {
          "Message": null,
          "PID": "BF9CA893-8007B119-FED08501-6B090201-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "BE1CA813-8007B011-FED08401-03090201-02000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.9L V6 Twin Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE1EA813-A007B011-FED09401-62010001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE1EA813-A007B011-FED09401-62010001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE1EA813-A007B011-FED09401-62010001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE1EA813-A007B011-FED09401-62010001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "A6 Allroad": {
      "2001": {
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.0L V6 Turbo (MHEV)": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "3.0L V6 Turbo (MHEV)": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "A6/S6": {
      "1996": {
        "2.8L V6": {
          "Message": null,
          "PID": "BF9DB990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "2.8L V6": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "2.8L V6": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "2.8L V6": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": null
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": null
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": null
        }
      },
      "2002": {
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "88188000-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.2L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEA893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE893-8005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEA893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE893-8005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEA893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE893-A005B11F-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.2L V10": {
          "Message": null,
          "PID": "BF9FCABB-A005B559-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEA893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.2L V10": {
          "Message": null,
          "PID": "BF9FCABB-A005B559-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A005B119-FED00501-01030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEA893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.2L V10": {
          "Message": null,
          "PID": "BF9FCABB-A005B559-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A005B119-FED00501-01030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEE893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.2L V10": {
          "Message": null,
          "PID": "BF9FE813-A005B011-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A005B119-FED00501-01030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEE893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.2L V10": {
          "Message": null,
          "PID": "BF9FE893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A005B119-FED08501-03030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A005B119-FED08501-03030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBCE893-8005B119-FED08501-02090E00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A007B119-FED08501-03030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "981BA013-9001A015-CCD2801D-EAA98143-E9220000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBCE893-8007B119-FED08501-02090E00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A007B119-FED08501-03030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "981BA013-9001A015-CCD2801D-EAA98143-E9220000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBCE893-8007B119-FED08501-02090E00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A007B119-FED08501-03030201-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "981BA013-9001A015-CCD2801D-EAA98143-E9220000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBCE893-8007B119-FED08501-02090E00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A007B119-FED08501-03030201-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBCE893-8007B119-FED08501-02090E00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A007B119-FED08501-03030201-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBCE893-8007B119-FED08501-02090E00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo (MHEV)": {
          "Message": null,
          "PID": "BE1CA813-8007B011-FED08401-6B090201-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.9L V6 Twin Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Turbo (MHEV)": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-60010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.9L V6 Twin Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Turbo (MHEV)": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-60010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V8 Twin Turbo (MHEV)": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-60010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A005B119-FED00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A005B119-FED00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A005B119-FED00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "A7/S7": {
      "2012": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A005B119-FED08501-03030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBCE893-8005B119-FED08501-02090E00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A007B119-FED08501-03030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "981BA013-9001A015-CCD2801D-EAA98143-E9220000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBCE893-8007B119-FED08501-02090E00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A007B119-FED08501-03030201-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "981BA013-9001A015-CCD2801D-EAA98143-E9220000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBCE893-8007B119-FED08501-02090E00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A007B119-FED08501-03030201-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "981BA013-9001A015-CCD2801D-EAA98143-E9220000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBCE893-8007B119-FED08501-02090E00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A007B119-FED08501-03030201-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBCE893-8007B119-FED08501-02090E00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A007B119-FED08501-03030201-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBCE893-8007B119-FED08501-02090E00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.0L V6 Turbo (MHEV)": {
          "Message": null,
          "PID": "BE1CA813-8007B011-FED08401-6B090201-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.9L V6 Twin Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Turbo (MHEV)": {
          "Message": null,
          "PID": "BE1CA813-8007B011-FED08401-6B090201-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.9L V6 Twin Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Turbo (MHEV)": {
          "Message": null,
          "PID": "BE1CA813-8007B011-FED08401-6B090201-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V8 Twin Turbo (MHEV)": {
          "Message": null,
          "PID": "BE1CA813-8007B011-FED08401-6B090201-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE1CA813-8007B011-FED08401-6B090201-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE1CA813-8007B011-FED08401-6B090201-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE1CA813-8007B011-FED08401-6B090201-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE1CA813-8007B011-FED08401-6B090201-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "A8/S8": {
      "1997": {
        "3.7L V8": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "3.7L V8": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.2L V8": {
          "Message": null,
          "PID": "88188000-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "3.7L V8": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE891-80001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L W12": {
          "Message": null,
          "PID": "BF9FCABB-8005B559-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE891-00001101-00000500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L W12": {
          "Message": null,
          "PID": "BF9FCABB-8005B559-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE893-A005B11F-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.2L V10": {
          "Message": null,
          "PID": "BF9FCABB-A005B559-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L W12": {
          "Message": null,
          "PID": "BF9FCABB-8005B559-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.2L V10": {
          "Message": null,
          "PID": "BF9FCABB-A005B559-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L W12": {
          "Message": null,
          "PID": "BF9FCABB-8005B559-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.2L V10": {
          "Message": null,
          "PID": "BF9FCABB-A005B559-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L W12": {
          "Message": null,
          "PID": "BF9FCABB-8005B559-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "4.2L V8": {
          "Message": null,
          "PID": "BFBEE893-A005B119-FED00501-02000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "4.2L V8": {
          "Message": null,
          "PID": "BFBEE893-A005B119-FED00501-02000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "4.2L V8": {
          "Message": null,
          "PID": "BFBEE893-A005B119-FED00501-02000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.3L W12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A005B119-FED08501-03030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBCE893-8005B119-FED08501-02090E00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.3L W12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A005B119-FED08501-03030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "981BA013-9001A015-CCD2801D-EAA98143-E9220000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBCE893-8005B119-FED08501-02090E00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.3L W12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A007B119-FED08501-03030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "981BA013-9001A015-CCD2801D-EAA98143-E9220000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBCE893-8007B119-FED08501-02090E00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.3L W12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A007B119-FED08501-03030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "981BA013-9001A015-CCD2801D-EAA98143-E9220000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBCE893-8007B119-FED08501-02090E00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.3L W12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A007B119-FED08501-03030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBCE893-8007B119-FED08501-02090E00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A007B119-FED08501-03030201-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBCE893-8007B119-FED08501-02090E00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.0L V6 Turbo (MHEV)": {
          "Message": null,
          "PID": "BE1CA813-8007B011-FED08401-6B090201-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V8 Twin Turbo (MHEV)": {
          "Message": null,
          "PID": "BE1CA813-8007B011-FED08401-63090201-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.0L V6 Turbo (MHEV)": {
          "Message": null,
          "PID": "BE1CA813-8007B011-FED08401-63090201-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V8 Twin Turbo (MHEV)": {
          "Message": null,
          "PID": "BE1CA813-8007B011-FED08401-63090201-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "3.0L V6 Turbo (MHEV)": {
          "Message": null,
          "PID": "BE1CA813-8007B011-FED08401-63090201-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V8 Twin Turbo (MHEV)": {
          "Message": null,
          "PID": "BE1CA813-8007B011-FED08401-63090201-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BF9FE891-80001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BF9FE891-80001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BF9FE891-80001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BF9FE891-80001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "E-Tron GT": {
      "2021": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2022": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2023": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2024": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "Q3": {
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-A007B011-FED08401-68010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-A007B011-FED08401-68010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-A007B011-FED08401-68010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-A007B011-FED08401-68010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3EE813-A007B011-FED08401-62010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3EE813-A007B011-FED08401-62010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3EE813-A007B011-FED08401-62010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3EE813-A007B011-FED08401-62010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Q4/SQ4": {
      "2022": {
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2023": {
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2024": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Q5/SQ5": {
      "2009": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEE893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEE893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEE893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEE893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED0C400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE1FE813-A005B011-FED08420-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A005B119-FED08501-03030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A007B011-FED0C400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE1FE813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A007B119-FED08501-03030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "981BA013-9001A015-CCD2801D-EAA98143-E9220000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A005B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE1FE813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A007B119-FED08501-03030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "981BA013-9001A015-CCD2801D-EAA98143-E9220000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A007B011-FED0C400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE1FE813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A007B119-FED08501-03030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "981BA013-9001A015-CCD2801D-EAA98143-E9220000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A007B011-FED0C400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A007B119-FED08501-03030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "BE1CA813-8007B011-FED08401-03090201-02000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-68010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "BE1CA813-8007B011-FED08401-6B090201-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo (MHEV)": {
          "Message": null,
          "PID": "BE1EA813-A007B011-FED08401-62010001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE1EA813-A007B011-FED08401-62010001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE1EA813-A007B011-FED08401-62010001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE1EA813-A007B011-FED08401-62010001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE1EA813-A007B011-FED08401-62010001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Q6": {
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Q7/SQ7": {
      "2007": {
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "981B2013-9001A015-C4D2000D-EA898141-20000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "981B2013-9001A015-C4D2000D-EA898141-20000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A005B119-FED00501-01030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "981B2013-9001A015-C4D2000D-EA898143-E9000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A005B119-FED00501-01030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "981B2013-9001A015-C4D2000D-EA898143-E9000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A005B119-FED08501-01030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "981BA013-9001A015-CCD2801D-EAA98143-E9220000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A005B119-FED08501-01030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "981BA013-9001A015-CCD2801D-EAA98143-E9220000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BF9CE893-A005B119-FED08501-01030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "981BA013-9001A015-CCD2801D-EAA98143-E9220000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "BF9CE893-A007B119-FED08501-03030201-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "BF9CE893-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "BF9CE893-A007B119-FED08501-03030201-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Turbo (MHEV)": {
          "Message": null,
          "PID": "BE1CA813-8007B011-FED08401-63090201-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V8 Twin Turbo (MHEV)": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-61190201-020C000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Turbo (MHEV)": {
          "Message": null,
          "PID": "BE1CA813-8007B011-FED08401-63090201-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V8 Twin Turbo (MHEV)": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-61190201-020C000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE1CA813-8007B011-FED08401-63090201-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE1CA813-8007B011-FED08401-63090201-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE1CA813-8007B011-FED08401-63090201-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE1CA813-8007B011-FED08401-63090201-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Q8/SQ8": {
      "2019": {
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "BE1CA813-8007B011-FED08401-6B090201-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2020": {
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V8 Twin Turbo (MHEV)": {
          "Message": null,
          "PID": "BE1CA813-8007B011-FED08401-63090201-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2021": {
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V8 Twin Turbo (MHEV)": {
          "Message": null,
          "PID": "BE1CA813-8007B011-FED08421-63090201-0204004D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2022": {
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2023": {
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2024": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "R8": {
      "2008": {
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.2L V10": {
          "Message": null,
          "PID": "BF9FE813-A005B011-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.2L V10": {
          "Message": null,
          "PID": "BF9FE813-A005B011-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.2L V10": {
          "Message": null,
          "PID": "BF9FE893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.2L V10": {
          "Message": null,
          "PID": "BF9FE893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE893-A005B119-FED08500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.2L V10": {
          "Message": null,
          "PID": "BF9FE893-A005B119-FED08500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE893-A005B119-FED08500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.2L V10": {
          "Message": null,
          "PID": "BF9EE893-8007B119-F7C08501-06180001-00080002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "5.2L V10": {
          "Message": null,
          "PID": "BF9EE893-8007B119-F7C08501-06180001-00080002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "5.2L V10": {
          "Message": null,
          "PID": "BF9EE893-8007B119-F7C08501-06180001-00080002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "5.2L V10": {
          "Message": null,
          "PID": "BF9EE893-8007B119-F7C08501-06180001-00080002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BF9EE893-8007B119-F7C08501-06180001-00080002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BF9EE893-8007B119-F7C08501-06180001-00080002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BF9EE893-8007B119-F7C08501-06180001-00080002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "TT": {
      "2000": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BF9FE891-80001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BF9FE891-80001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BF9FE891-80001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BF9FE893-8005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BF9FE893-8005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A005B015-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A005B015-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-A007B011-FED08401-02010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007B011-FED08401-00090001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-A007B011-FED08401-6A010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007B011-FED08401-00090001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-A007B011-FED08401-6A010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE3FE813-A007B011-FED08401-6A010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-A007B011-FED08401-6A010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE3FE813-A007B011-FED08401-6A010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    }
  },
  "BMW": {
    "1 Series": {
      "2008": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "2 Series": {
      "2014": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA811-90000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08415-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08415-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08415-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08415-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "3 Series": {
      "1996": {
        "1.9L I4": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L I6": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "1.9L I4": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L I6": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "1.9L I4": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I6": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L I6": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "1.9L I4 (Coupe/Convertible/Hatch)": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I6 (Coupe/Convertible/Hatch)": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I6 (Sedan)": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L I6 (Coupe/Convertible/Hatch)": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L I6 (Sedan)": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.5L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.2L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.2L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.2L I6": {
          "Message": null,
          "PID": "BE1FE810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.2L I6": {
          "Message": null,
          "PID": "BE1FE810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I6": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.2L I6": {
          "Message": null,
          "PID": "BE1FE810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I6": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.5L I6 (Coupe/Convertible)": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I6 (Sedan)": {
          "Message": null,
          "PID": "BF9FA891-00001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 (Coupe/Convertible)": {
          "Message": null,
          "PID": "BF9FA891-00001101-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L I6 (Sedan)": {
          "Message": null,
          "PID": "BF9FE891-80001101-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "2.5L I6": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FE891-80001101-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA891-20001101-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "2.5L I6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.5L I6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981BA013-9011A001-CCD00005-C0896343-A0000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.5L I6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981BA013-9011A001-CCD00005-C0896343-A0000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.5L I6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981BA013-9011A001-CCD00005-C0896343-A0000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.0L I4 Turbo (Sedan)": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 (Coupe/Convertible)": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo (Coupe/Convertible)": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo (Sedan)": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Twin Turbo (Coupe/Convertible)": {
          "Message": null,
          "PID": "FFBEA893-A007B119-FED08F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.0L I4 Turbo (Sedan)": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 (Coupe/Convertible)": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo (Coupe/Convertible)": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo (Sedan)": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo Hybrid (Sedan)": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08421-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Twin Turbo (Coupe/Convertible)": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA811-90000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "981B8013-8001A001-CCD0800D-CAA9A343-A9320000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo Hybrid": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08421-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "981B8013-8001A001-CCD0800D-CAA9A343-A9320000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo Hybrid": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08421-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "981B8013-8001A001-CCD0800D-EAA9A343-A9320000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08431-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "981B8013-8001A001-CCD0800D-EAA9A343-A9320000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "981B8013-8001A001-CCD0800D-EAA9A343-A9320000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08431-61000001-0004004D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo (GT/Wagon)": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo (Sedan)": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo (GT/Wagon)": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08415-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08415-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08415-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08415-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "4 Series": {
      "2014": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA811-90000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08415-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08415-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08415-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08415-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "5 Series": {
      "1996": {
        "2.8L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "2.8L I6": {
          "Message": null,
          "PID": "BE1FF811-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BE1FF811-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "2.8L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.8L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.8L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.5L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.5L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.5L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BF9FF991-00000001-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.5L I6": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.5L I6": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FA891-00001101-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "981A2011-00000001-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FE891-80001101-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "981A2011-00000001-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BE1B3013-80022001-44000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo (GT)": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo (GT)": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F01-05000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F01-05000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo Hybrid": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08421-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F01-05000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo Hybrid": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08421-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F01-05000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA811-90000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981BA013-9011A001-CCD08005-C0A96343-A9200000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo Hybrid": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08421-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08501-07000001-02000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981B8013-8001A001-CCD0800D-CAA9A343-A9320000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo Hybrid": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08421-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08501-07000001-02000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo Diesel": {
          "Message": null,
          "PID": "98188001-80002001-C4000001-C0000101-09000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo Hybrid": {
          "Message": null,
          "PID": "981BA013-9011A001-CCD08005-C0A96343-A9200000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08501-07000001-02000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo (GT)": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo (GT)": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08501-07000001-02000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08431-61000001-0004004D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08511-63000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08431-61000001-0004004D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08511-61000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08431-63000001-0004004D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08511-63000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08511-63000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08511-63000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08511-63000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "6 Series": {
      "2004": {
        "4.4L V8": {
          "Message": null,
          "PID": "BF9FE891-80001101-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "4.4L V8": {
          "Message": null,
          "PID": "981A2011-00000001-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "4.8L V8": {
          "Message": null,
          "PID": "981A2011-00000001-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "4.8L V8": {
          "Message": null,
          "PID": "981A2011-00000001-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "4.8L V8": {
          "Message": null,
          "PID": "BE1B3013-80022001-44000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "4.8L V8": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "4.8L V8": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F01-05000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F01-05000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08501-07000001-02000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08501-07000001-02000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08501-07000001-02000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08501-07000001-02000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo (GT)": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08511-63000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo (GT)": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08511-61000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "7 Series": {
      "1996": {
        "4.4L V8": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V12": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "4.4L V8": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V12": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "4.4L V8": {
          "Message": null,
          "PID": "BF9FB980-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V12": {
          "Message": null,
          "PID": "BF9FB980-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "4.4L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V12": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "4.4L V8": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V12": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "4.4L V8": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V12": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "4.4L V8": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "4.4L V8": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V12": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "4.4L V8": {
          "Message": null,
          "PID": "BF9FE891-80001101-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V12": {
          "Message": null,
          "PID": "BF9FE891-80001101-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "4.4L V8": {
          "Message": null,
          "PID": "981A2011-00000001-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V12": {
          "Message": null,
          "PID": "981A2011-00000001-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "4.8L V8": {
          "Message": null,
          "PID": "981A2011-00000001-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V12": {
          "Message": null,
          "PID": "981A2011-00000001-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "4.8L V8": {
          "Message": null,
          "PID": "981A2011-00000001-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V12": {
          "Message": null,
          "PID": "981A2011-00000001-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "4.8L V8": {
          "Message": null,
          "PID": "BE1B3013-80022001-44000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V12": {
          "Message": null,
          "PID": "BE1B3013-80022001-44000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F01-05000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F01-05000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Turbo Hybrid": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED00F01-05000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F01-05000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Turbo Hybrid": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED00F01-05000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F01-05000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo Hybrid": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08421-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F01-05000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo Hybrid": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08421-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08501-07000001-02000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981B8013-8001A001-CCD0800D-CAA9A343-A9320000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo Hybrid": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08421-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08501-07000001-02000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08501-07000001-02000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08501-07000001-02000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08431-61000001-0004004D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08511-63000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08511-67000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08431-61000001-0004004D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08511-61000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08511-67000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V12 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08511-63000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08511-63000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08511-63000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08511-63000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "8 Series": {
      "1996": {
        "4.4L V8": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V12": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.6L V12": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "4.4L V8": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V12": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08511-61000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "M2": {
      "2016": {
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08511-64000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08511-64000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08415-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08415-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08415-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "M3": {
      "1996": {
        "3.2L I6": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.2L I6": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.2L I6": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.2L I6": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.2L I6": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.2L I6": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.2L I6": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.2L I6": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.2L I6": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.2L I6": {
          "Message": null,
          "PID": "BF9FE891-91001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "4.0L V8": {
          "Message": null,
          "PID": "BFFEE893-8007B11F-FCD00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "4.0L V8": {
          "Message": null,
          "PID": "BFFEE893-8007B11F-FCD00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "4.0L V8": {
          "Message": null,
          "PID": "BFFEE893-8007B11F-FCD00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "4.0L V8": {
          "Message": null,
          "PID": "BFFEE893-8007B11F-FCD00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "4.0L V8": {
          "Message": null,
          "PID": "BFFEE893-8007B11F-FCD00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "4.0L V8": {
          "Message": null,
          "PID": "BFFEE893-8007B11F-FCD00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08415-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08415-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08415-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08415-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08415-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "M4": {
      "2015": {
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08511-64000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08415-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08415-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08415-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08415-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08415-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "M5": {
      "2000": {
        "4.9L V8": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "4.9L V8": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "4.9L V8": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "4.9L V8": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "5.0L V10": {
          "Message": null,
          "PID": "BFDFE891-91019101-C0000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "5.0L V10": {
          "Message": null,
          "PID": "BFDFE891-91019101-C0000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "5.0L V10": {
          "Message": null,
          "PID": "BFDFE893-9107B11F-FCD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "5.0L V10": {
          "Message": null,
          "PID": "BFDFE893-9107B11F-FCD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "5.0L V10": {
          "Message": null,
          "PID": "BFDFE893-9107B11F-FCD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F01-05000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F01-05000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08501-07000001-02000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08501-07000001-02000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08501-07000001-02000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08511-63000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "M6": {
      "2006": {
        "5.0L V10": {
          "Message": null,
          "PID": "BFDFE891-91019101-C0000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "5.0L V10": {
          "Message": null,
          "PID": "BFDFE891-91019101-C0000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "5.0L V10": {
          "Message": null,
          "PID": "BFDFE893-9107B11F-FCD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "5.0L V10": {
          "Message": null,
          "PID": "BFDFE893-9107B11F-FCD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "5.0L V10": {
          "Message": null,
          "PID": "BFDFE893-9107B11F-FCD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F01-05000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F01-05000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08501-07000001-02000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08501-07000001-02000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08501-07000001-02000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08501-07000001-02000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08511-63000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08511-61000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "M8": {
      "2020": {
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "X1": {
      "2012": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA811-90000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE7EA813-E007B015-FED08401-63000001-0004200F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE7EA813-E007B015-FED08401-63000001-0004200F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE7EA813-E007B015-FED08401-63000001-0004200F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE7EA813-E007B015-FED08401-63000001-0004200F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "X2": {
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "X3": {
      "2004": {
        "2.5L I6": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.5L I6": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FA891-00001101-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FE891-80001101-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA811-90000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "981B8013-8001A001-CCD0800D-CAA9A343-A9320000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "981B8013-8001A001-CCD0800D-EAA9A343-A9320000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "981B8013-8001A001-CCD0800D-EAA9A343-A9320000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-63000001-0004200D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-63000001-0004200D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-63000001-0004200D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-63000001-0004200D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "X4": {
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08511-64000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08511-64000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08511-64000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "X5": {
      "2000": {
        "4.4L V8": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BF9FE891-80001101-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "981A2011-00000001-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.4L V8": {
          "Message": null,
          "PID": "981A2011-00000001-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "981A2011-00000001-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FA891-00001101-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BF9FA891-00001101-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "981A2011-00000001-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FE891-80001101-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "981A2011-00000001-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BE1B3013-80022001-44000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981BA013-9011A001-CCD00005-C0896343-A0000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981BA013-9011A001-CCD00005-C0896343-A0000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F01-05000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981BA013-9011A001-CCD00005-C0896343-A0000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F01-05000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981BA013-9011A001-CCD00005-C0896341-20000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F01-05000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981BA013-9011A001-CCD08005-C0A96343-A9200000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F01-05000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981BA013-9011A001-CCD08005-C0A96343-A9200000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08501-07000001-02000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981B8013-8001A001-CCD0800D-CAA9A343-A9320000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08501-07000001-02000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08431-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo Diesel": {
          "Message": null,
          "PID": "98188001-80002001-C4000001-C0000101-09000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08501-07000001-02000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981B8013-8001A001-CCD0800D-EAA9A343-A9320000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08501-07000001-02000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08431-61000001-0004004D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981B8013-8001A001-CCD0800D-EAA9A343-A9320000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08511-63000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE7EA813-E007B015-FED08421-63000001-0004204F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE7EA813-E007B015-FED08421-63000001-0004204F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE7EA813-E007B015-FED08421-63000001-0004204F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE7EA813-E007B015-FED08421-63000001-0004204F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "X6": {
      "2008": {
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F01-05000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo Hybrid": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED00F01-05000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F01-05000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo Hybrid": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED00F01-05000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F01-05000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F01-05000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08501-07000001-02000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08501-07000001-02000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08501-07000001-02000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08501-07000001-02000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08511-63000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08511-61000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08511-63000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08511-63000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08511-63000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08511-63000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "X7": {
      "2019": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE7EA813-E007B015-FED08401-63000001-0004200F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE7EA813-E007B015-FED08401-63000001-0004200F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE7EA813-E007B015-FED08401-63000001-0004200F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE7EA813-E007B015-FED08401-63000001-0004200F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Z3": {
      "1996": {
        "1.9L I4": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "1.9L I4": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L I6": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "1.9L I4": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L I6": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L I6": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.5L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.5L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.5L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.5L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Z4": {
      "2003": {
        "2.5L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.5L I6": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.5L I6": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FA891-00001101-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L I6": {
          "Message": null,
          "PID": "BF9FE891-91001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FE891-80001101-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L I6": {
          "Message": null,
          "PID": "BF9FE891-91001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L I6": {
          "Message": null,
          "PID": "BF9FE891-91001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED00F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA811-90000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08411-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08411-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08411-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08411-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Z8": {
      "2000": {
        "4.9L V8": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "4.9L V8": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "4.9L V8": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "4.9L V8": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "i3": {
      "2014": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "EV with Range Extender": {
          "Message": null,
          "PID": "BE3EA813-8007B015-FED08030-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "EV with Range Extender": {
          "Message": null,
          "PID": "BE3EA813-8007B015-FED08030-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "EV with Range Extender": {
          "Message": null,
          "PID": "BE3EA813-8007B015-FED08030-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "EV with Range Extender": {
          "Message": null,
          "PID": "BE3EA813-8007B015-FED08030-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "EV with Range Extender": {
          "Message": null,
          "PID": "BE3EA813-8007B015-FED08030-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "EV with Range Extender": {
          "Message": null,
          "PID": "BE3EA813-8007B015-FED08031-60000001-0004004D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "EV with Range Extender": {
          "Message": null,
          "PID": "BE3EA813-8007B015-FED08031-60000001-0004004D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "EV with Range Extender": {
          "Message": null,
          "PID": "BE3EA813-8007B015-FED08031-60000001-0004004D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "i4": {
      "2022": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2023": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2024": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "i5": {
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "i7": {
      "2023": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2024": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "i8": {
      "2014": {
        "1.5L I3 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08430-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.5L I3 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08430-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.5L I3 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08430-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.5L I3 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08430-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.5L I3 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08431-60000001-0004004D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "1.5L I3 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08431-60000001-0004004D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "iX": {
      "2022": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2023": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2024": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    }
  },
  "Bentley": {
    "Arnage": {
      "1999": {
        "4.4L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9FB980-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "6.75L V8 Twin Turbo": {
          "Message": null,
          "PID": "BC3EF811-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "6.75L V8 Twin Turbo": {
          "Message": null,
          "PID": "BC3EF811-00000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "6.75L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "6.75L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFDFF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "6.75L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFDFF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "6.75L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFDFF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "6.75L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFDFF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "6.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "6.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "6.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Azure": {
      "1996": {
        "6.75L V8 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "6.75L V8 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "6.75L V8 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "6.75L V8 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "6.75L V8 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "6.75L V8 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "6.75L V8 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "6.75L V8 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "6.75L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFDFE893-8007B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "6.75L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFDFE893-8007B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "6.75L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFDFE893-8007B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "6.75L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFDFE893-8007B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Bentayga": {
      "2017": {
        "6.0L W12 Twin Turbo": {
          "Message": null,
          "PID": "BF9FE893-8007B119-F7C0C501-00110C01-00080000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "6.0L W12 Twin Turbo": {
          "Message": null,
          "PID": "BF9FE893-8007B119-F7C0C501-00110C01-00080000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-69190201-020C000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L W12 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-69190201-020C000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-69190201-020C000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-69190201-020C000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-69190201-020C000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Brooklands": {
      "1997": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Continental": {
      "1996": {
        "6.75L V8 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "6.75L V8 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "6.75L V8 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "6.75L V8 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "6.75L V8 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "6.75L V8 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "6.75L V8 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "6.75L V8 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Continental GT": {
      "2004": {
        "6.0L W12 Twin Turbo": {
          "Message": null,
          "PID": "BE1FE811-00001001-00000400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "6.0L W12 Twin Turbo": {
          "Message": null,
          "PID": "BE1FE811-00001001-00000400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "6.0L W12 Twin Turbo": {
          "Message": null,
          "PID": "BE1FE811-00001001-00000400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "6.0L W12 Twin Turbo": {
          "Message": null,
          "PID": "BF9FE891-00001101-00000500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "6.0L W12 Twin Turbo": {
          "Message": null,
          "PID": "BF9FE893-8005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "6.0L W12 Twin Turbo": {
          "Message": null,
          "PID": "BF9FE893-8005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "6.0L W12 Twin Turbo": {
          "Message": null,
          "PID": "BF9FE893-8005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "6.0L W12 Twin Turbo": {
          "Message": null,
          "PID": "BF9FE893-8005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "6.0L W12 Twin Turbo": {
          "Message": null,
          "PID": "BF9FE893-8005B119-FED0C500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBCE893-8005B419-FED08501-02090E00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L W12 Twin Turbo": {
          "Message": null,
          "PID": "BF9FE893-8005B119-FED0C500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBCE893-8005B119-FED08501-02090E00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L W12 Twin Turbo": {
          "Message": null,
          "PID": "BF9FE893-8007B119-F7C0C501-00110C01-00080000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBCE893-8005B119-FED08501-02090E00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L W12 Twin Turbo": {
          "Message": null,
          "PID": "BF9FE893-8007B119-F7C0C501-00110C01-00080000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBCE893-8005B119-FED08501-02090E00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L W12 Twin Turbo": {
          "Message": null,
          "PID": "BF9FE893-8007B119-F7C0C501-00110C01-00080000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBCE893-8007B119-FED08501-02090E00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L W12 Twin Turbo": {
          "Message": null,
          "PID": "BF9FE893-8007B119-F7C0C501-00110C01-00080000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBCE893-8007B119-FED08501-02090E00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L W12 Twin Turbo": {
          "Message": null,
          "PID": "BFBCE893-8007B119-FED08501-02090E00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "6.0L W12 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-69190201-020C000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-69190201-020C000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-69190201-020C000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-69190201-020C000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-69190201-020C000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Flying Spur": {
      "2006": {
        "All": {
          "Message": null,
          "PID": "BF9FE891-00001101-00000500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "All": {
          "Message": null,
          "PID": "BF9FE891-00001101-00000500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "All": {
          "Message": null,
          "PID": "BF9FE891-00001101-00000500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "All": {
          "Message": null,
          "PID": "BF9FE891-00001101-00000500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "All": {
          "Message": null,
          "PID": "BF9FE893-8005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "All": {
          "Message": null,
          "PID": "BF9FE893-8005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "All": {
          "Message": null,
          "PID": "BF9FE893-8005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "All": {
          "Message": null,
          "PID": "BF9FE893-8005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "All": {
          "Message": null,
          "PID": "BFBCE893-8005B119-FED08501-02090E00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "All": {
          "Message": null,
          "PID": "BFBCE893-8005B119-FED08501-02090E00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "All": {
          "Message": null,
          "PID": "BFBCE893-8005B119-FED08501-02090E00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "All": {
          "Message": null,
          "PID": "BFBCE893-8005B119-FED08501-02090E00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "All": {
          "Message": null,
          "PID": "BFBCE893-8005B119-FED08501-02090E00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "All": {
          "Message": null,
          "PID": "BFBCE893-8005B119-FED08501-02090E00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "6.0L W12 Twin Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BFBCE893-8005B119-FED08501-02090E00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBCE893-8005B119-FED08501-02090E00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFBCE893-8005B119-FED08501-02090E00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFBCE893-8005B119-FED08501-02090E00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFBCE893-8005B119-FED08501-02090E00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Mulsanne": {
      "2011": {
        "6.75L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "6.75L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "6.75L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "6.75L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "6.75L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "6.75L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "6.75L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "6.75L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "6.75L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "6.75L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    }
  },
  "Bugatti": {
    "Bolide": {
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Chiron": {
      "2016": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Centodieci": {
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Divo": {
      "2019": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Mistral": {
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Veyron": {
      "2005": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    }
  },
  "Buick": {
    "Allure": {
      "2005": {
        "3.6L V6": {
          "Message": null,
          "PID": "BE1FA813-8007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE1FA813-8007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.6L V6": {
          "Message": null,
          "PID": "BE1FA813-8007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE1FA813-8007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Cascada": {
      "2016": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Century": {
      "1996": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.1L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.1L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.1L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.1L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.1L V6": {
          "Message": null,
          "PID": "BE3FF810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.1L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.1L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.1L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.1L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.1L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Enclave": {
      "2008": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED0C001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Encore": {
      "2013": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Encore GX": {
      "2020": {
        "1.2L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.3L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "1.2L I4 Turbo": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.3L I4 Turbo": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Envision": {
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Envista": {
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "LaCrosse": {
      "2005": {
        "3.6L V6": {
          "Message": null,
          "PID": "BE1FA813-8007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE1FA813-8007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.6L V6": {
          "Message": null,
          "PID": "BE1FA813-8007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE1FA813-8007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.6L V6": {
          "Message": null,
          "PID": "BE1FA813-8007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE1FA813-8007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE1FA813-8007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FF813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3FF813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED00020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4 eAssist": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED00020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED00020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "2.4L I4 eAssist": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED00020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED00020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "2.4L I4 eAssist": {
          "Message": null,
          "PID": "BE7FF813-A007E011-FED08020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FF813-A007E011-FED08020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "2.4L I4 eAssist": {
          "Message": null,
          "PID": "BE7FF813-A007E011-FED08020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FF813-A007E011-FED08020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007A019-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.5L I4 eAssist": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28021-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28021-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.5L I4 eAssist": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "LeSabre": {
      "1996": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": null
        }
      },
      "1997": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Lucerne": {
      "2006": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.9L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.9L V6": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.9L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Park Avenue": {
      "1996": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Rainier": {
      "2004": {
        "4.2L I6": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "4.2L I6": {
          "Message": null,
          "PID": "BE3EF811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3EF811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "4.2L I6": {
          "Message": null,
          "PID": "BE3FF811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3FF811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "4.2L I6": {
          "Message": null,
          "PID": "BE3FF811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3FF811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Regal": {
      "1996": {
        "3.1L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED04001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED04001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FFF77-A007FF75-FED0FF01-0100FF00-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FFF77-A007FF75-FED0FF01-0100FF00-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED0C001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4 eAssist": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED0C001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4 eAssist": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-61080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-61080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Regal Sportback": {
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Regal Touring X": {
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-61080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-61080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Rendezvous": {
      "2002": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Riviera": {
      "1996": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Roadmaster": {
      "1996": {
        "5.7L V8": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Skylark": {
      "1996": {
        "2.4L I4": {
          "Message": null,
          "PID": "BFBFFD10-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.1L V6": {
          "Message": null,
          "PID": "BFBFFD10-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.1L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.1L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Terraza": {
      "2005": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.9L V6": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.9L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Verano": {
      "2012": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED04001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    }
  },
  "Cadillac": {
    "ATS": {
      "2013": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "CT4": {
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.7L I4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.7L I4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFDFA893-A007F119-FED08001-67080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFDFA893-A007F119-FED08001-67080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFDFA893-A007F119-FED08001-67080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFDFA893-A007F119-FED08001-67080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "CT5": {
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFDFA893-A007F119-FED08001-67080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFDFA893-A007F119-FED08001-67080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFDFA893-A007F119-FED08001-67080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFDFA893-A007F119-FED08001-67080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "CT6": {
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.2L V8 Twin Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.2L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "CTS": {
      "2003": {
        "2.6L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "3.2L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "2.8L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.8L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.8L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.8L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "2.8L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Catera": {
      "1997": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FE890-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FE890-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FE890-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FE890-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "DTS": {
      "2006": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFF913-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFFD13-803FF611-FEF07D00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFF913-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFF913-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFF913-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFF913-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "DeVille": {
      "1996": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFBD10-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFBD10-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB510-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "4.6L V8": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2001": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFF910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2002": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFF910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2003": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFF910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2004": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFF911-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFF911-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "ELR": {
      "2014": {
        "1.4L I4 Hybrid": {
          "Message": null,
          "PID": "BE7FF813-8007E011-FED00020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "1.4L I4 Hybrid": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED08020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Eldorado": {
      "1996": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFBD10-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFBD10-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "1998": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB510-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "1999": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB510-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2000": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2001": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFF910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2002": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFF910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Escalade": {
      "1999": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2003": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2004": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "6.2L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8 Hybrid": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "6.0L V8 Hybrid": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "6.0L V8 Hybrid": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8 Hybrid": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "6.0L V8 Hybrid": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED00020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED00020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Fleetwood": {
      "1996": {
        "5.7L V8": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Lyriq": {
      "2023": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "OPTIQ": {
      "2025": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "SRX": {
      "2004": {
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA891-80001100-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FA891-80001100-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "3.6L V6": {
          "Message": null,
          "PID": "BE1FA813-8007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BE1FA813-8007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "3.6L V6": {
          "Message": null,
          "PID": "BE1FA813-8007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BE1FA813-8007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.8L V6 Turbo": {
          "Message": null,
          "PID": "BE5FF813-8007E011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE5FF813-8007E011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "2.8L V6 Turbo": {
          "Message": null,
          "PID": "BE5FF813-8007E011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE5FF813-8007E011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED04001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED0C001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "STS": {
      "2005": {
        "3.6L V6": {
          "Message": null,
          "PID": "BE1FA813-8007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BE1FA813-8007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "3.6L V6": {
          "Message": null,
          "PID": "BE1FA813-8007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BE1FA813-8007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BE1FA813-8007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FB993-A007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BF9FB993-A007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB993-A007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FB993-A007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BF9FB993-A007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB993-A007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FB993-A007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Seville": {
      "1996": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFBD10-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFBD10-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "4.6L V8": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB510-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFF910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2001": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFF910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2002": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFF910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2003": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFF910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2004": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFF911-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "XLR": {
      "2004": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFA893-9107E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFA893-9107E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "4.4L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "4.4L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "4.4L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "4.4L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "XT4": {
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "XT5": {
      "2017": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-61080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-61080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-61080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "XT6": {
      "2020": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "XTS": {
      "2013": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED08001-05000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED08001-05000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.6L V6": {
          "Message": null,
          "PID": "80400001-A007E019-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6 Twin Turbo": {
          "Message": null,
          "PID": "80400001-A007E019-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    }
  },
  "Chevrolet": {
    "Astro": {
      "1996": {
        "4.3L V6": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFBD14-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Avalanche": {
      "2002": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2003": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2004": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Aveo": {
      "2004": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB811-C0000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB811-80000001-08080000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB813-801FE011-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Beretta": {
      "1996": {
        "2.2L I4": {
          "Message": null,
          "PID": "BFBFFD10-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.1L V6": {
          "Message": null,
          "PID": "BFBFFD10-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Blazer": {
      "1996": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFBD10-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFBD14-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "4.3L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFF914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Bolt": {
      "2017": {
        "EV": {
          "Message": null,
          "PID": "80080013-80018001-44C08020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "EV": {
          "Message": null,
          "PID": "80080013-80018001-44C08020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "EV": {
          "Message": null,
          "PID": "80080013-80018001-44C08021-00000001-00000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "EV": {
          "Message": null,
          "PID": "80080013-80018001-44C08021-00000001-00000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "EV": {
          "Message": null,
          "PID": "80080013-80018001-44C08021-00000001-00000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "EV": {
          "Message": null,
          "PID": "80080013-80018001-44C08021-00000001-00000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "C Series Truck": {
      "2002": {
        "7.2L I6 Turbo Diesel": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": "BFBFB114-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "8.1L V8": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": "BFBFB114-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "6.6L V8 Turbo Diesel": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": "983B0014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "7.2L I6 Turbo Diesel": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": "983B0014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "8.1L V8": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": "983B0014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "983B0015-20000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "983B0015-20000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "6.6L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0015-20000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "8.1L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0015-20000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "6.6L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0017-A019A001-D4C28000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.2L I6 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0017-A019A001-D4C28000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "8.1L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0017-A019A001-D4C28000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "6.6L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0017-A019A001-D4C28000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.8L I6 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0017-A019A001-D4C28000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "8.1L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0017-A019A001-D4C28000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "6.6L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B8017-A01BA015-DCD28000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "8.1L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B8017-A01BA015-DCD28000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "6.6L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B8017-A01BA015-DCD28000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.8L I6 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B8017-A01BA015-DCD28000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "8.1L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B8017-A01BA015-DCD28000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "CK 1500": {
      "1996": {
        "4.3L V6": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFBD14-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFBD14-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFBD14-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFBD14-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "CK 2500": {
      "1996": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.4L V8": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.4L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.4L V8": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "7.4L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "7.4L V8": {
          "Message": null,
          "PID": "BFBFF994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "CK 3500": {
      "1996": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.4L V8": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.4L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.4L V8": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "7.4L V8": {
          "Message": null,
          "PID": "BFBFF994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "7.4L V8": {
          "Message": null,
          "PID": "BFBFF994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Camaro": {
      "1996": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBEB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB510-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB510-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB510-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB510-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007A019-FED04001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-A007A019-FED04001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFFB993-A007A019-FED04001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "7.0L V8": {
          "Message": null,
          "PID": "BFFFB993-A007A019-FED04001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007A019-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-A007A019-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFFB993-A007A019-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "7.0L V8": {
          "Message": null,
          "PID": "BFFFB993-A007A019-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Caprice": {
      "1996": {
        "4.3L V8": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED04001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED04001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007A019-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-A007A019-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "6.0L V8": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Caprice Police Vehicle": {
      "2011": {
        "All": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "All": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "All": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Captiva Sport": {
      "2010": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED04001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED04001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED0C001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED0C001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Cavalier": {
      "1996": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Chevy Van": {
      "1996": {
        "4.3L V6": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFBD14-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFBD14-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFBD14-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFBD14-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.4L V8": {
          "Message": null,
          "PID": "BFBFBD14-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFF994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFF994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFF994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.4L V8": {
          "Message": null,
          "PID": "BFBFF994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "City Express": {
      "2015": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Cobalt": {
      "2005": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.2L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.2L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.2L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.2L I4": {
          "Message": null,
          "PID": "BE3FA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.2L I4": {
          "Message": null,
          "PID": "BE3FA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.2L I4": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Colorado": {
      "2004": {
        "2.8L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L I5": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.8L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L I5": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.8L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L I5": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.9L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.7L I5": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.9L I4": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.7L I5": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "2.9L I4": {
          "Message": null,
          "PID": "BE7FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.7L I5": {
          "Message": null,
          "PID": "BE7FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE7FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.9L I4": {
          "Message": null,
          "PID": "BE7FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.7L I5": {
          "Message": null,
          "PID": "BE7FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE7FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "2.9L I4": {
          "Message": null,
          "PID": "BE7FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.7L I5": {
          "Message": null,
          "PID": "BE7FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE7FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "2.9L I4": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.7L I5": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.8L I4 Turbo Diesel": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.5L I4": {
          "Message": null,
          "PID": "98390013-8003A001-C4C2801D-E9E98343-E9B20100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.8L I4 Turbo Diesel": {
          "Message": null,
          "PID": "98390013-8003A001-C4C2801D-E9E98343-E9B20100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "98390013-8003A001-C4C2801D-E9E98343-E9B20100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.8L I4 Turbo Diesel": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.8L I4 Turbo Diesel": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.8L I4 Turbo Diesel": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.5L I4": {
          "Message": null,
          "PID": "9F1B07FF-851BBFF5-F7DB87FF-EDFB87EF-EFFF07EF",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L I4 Turbo Diesel": {
          "Message": null,
          "PID": "9F1B07FF-851BBFF5-F7DB87FF-EDFB87EF-EFFF07EF",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "9F1B07FF-851BBFF5-F7DB87FF-EDFB87EF-EFFF07EF",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Corsica": {
      "1996": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.1L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Corvette": {
      "1996": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "1998": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "1999": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2000": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2001": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2002": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2003": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2004": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "7.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "7.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "6.2L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "7.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "6.2L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "7.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "7.0L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "6.2L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "7.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "6.2L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "7.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "6.2L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "7.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED08001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED08001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED08001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "6.2L V8": {
          "Message": null,
          "PID": "BE3FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "6.2L V8": {
          "Message": null,
          "PID": "BE3FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFDCA893-8007F119-F7C08551-65180001-020C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFDCA893-8007F119-F7C08551-65180001-020C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFDCA893-8007F119-F7C08551-65180001-020C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFDCA893-8007F119-F7C08551-65180001-020C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Cruze": {
      "2010": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB813-801FA011-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB877-A007E075-FED6A075-A106A075-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE7FB877-A007E075-FED6A075-A106A075-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "BE7FB877-A007E075-FED6A075-A106A075-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo Diesel": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007A011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo Diesel": {
          "Message": null,
          "PID": "BE7FB813-A007A011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo Diesel": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Epica": {
      "2004": {
        "2.5L I6": {
          "Message": null,
          "PID": "BFBFB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB811-80000001-08080000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I6": {
          "Message": null,
          "PID": "BE3EB811-80000001-08080000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "2.5L I6": {
          "Message": null,
          "PID": "BFBFB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Equinox": {
      "2005": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FF813-A007E011-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FF813-A007E011-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FF813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FF813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED0C001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED0C001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo Diesel": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo Diesel": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "BE5FB813-A007E011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Express": {
      "1996": {
        "4.3L V6": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "4.3L V6": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FC800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FC800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FC800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FC800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "4.3L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.4L V8": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.4L V8": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "4.3L V6": {
          "Message": null,
          "PID": "981A0014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "981A0014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "981A0014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "981A0014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "981A0014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED04001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED04001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED04001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED04001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED04001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFF997-8007E019-FED2C001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFF997-8007E019-FED2C001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFF997-8007E019-FED2C001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "2.8L I4 Turbo Diesel": {
          "Message": null,
          "PID": "98390013-8003A001-C4C2801D-E9E98343-E9B20100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "98390013-8003A001-C4C2801D-E9E98343-E9B20100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "98390013-8003A001-C4C2801D-E9E98343-E9B20100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.8L I4 Turbo Diesel": {
          "Message": null,
          "PID": "98390013-8003A001-C4C2801D-E9E98343-E9B20100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.3L V6": {
          "Message": null,
          "PID": "98390013-8003A001-C4C2801D-E9E98343-E9B20100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "98390013-8003A001-C4C2801D-E9E98343-E9B20100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.8L I4 Turbo Diesel": {
          "Message": null,
          "PID": "98390013-8003A001-C4C2801D-E9E98343-E9F6012D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.3L V6": {
          "Message": null,
          "PID": "98390013-8003A001-C4C2801D-E9E98343-E9F6012D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "98390013-8003A001-C4C2801D-E9E98343-E9F6012D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.8L I4 Turbo Diesel": {
          "Message": null,
          "PID": "98390013-8003A001-C4C2801D-E9E98343-E9F20123",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.3L V6": {
          "Message": null,
          "PID": "98390013-8003A001-C4C2801D-E9E98343-E9F20123",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "98390013-8003A001-C4C2801D-E9E98343-E9F20123",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.8L I4 Turbo Diesel": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.3L V6": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.6L V8": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "HHR": {
      "2006": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.2L I4": {
          "Message": null,
          "PID": "BE3FA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.2L I4": {
          "Message": null,
          "PID": "BE3FA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.2L I4": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Impala": {
      "2000": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.9L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.9L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.9L V6": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.9L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.9L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.9L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED04001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED0C001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "2.4L I4 eAssist": {
          "Message": null,
          "PID": "BE7FF813-A007E011-FED08020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE7FF813-A007E011-FED08020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FF813-A007E011-FED08020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.5L I4": {
          "Message": null,
          "PID": "98390013-8003A001-C4C2801D-E9E98343-E9B20100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "98390013-8003A001-C4C2801D-E9E98343-E9B20100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Lumina": {
      "1996": {
        "3.1L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.1L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.1L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.1L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.1L V6": {
          "Message": null,
          "PID": "BE3FF810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.1L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Lumina Minivan": {
      "1996": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Malibu": {
      "1997": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.1L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.1L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.1L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.1L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.1L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.1L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.1L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.9L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.9L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4 BAS Hybrid": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4 BAS Hybrid": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4 BAS Hybrid": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4 eAssist": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4 eAssist": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4 Hybrid": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4 Hybrid": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4 Hybrid": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4 Hybrid": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE5FB813-A007E011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE5FB813-A007E011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE5FB813-A007E011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE5FB813-A007E011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Malibu Classic": {
      "2004": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Malibu Maxx": {
      "2004": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFB993-801FE019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFB993-801FE019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.9L V6": {
          "Message": null,
          "PID": "BFBFB993-801FE019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.9L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Metro": {
      "1998": {
        "1.0L I3": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "1.3L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "1.0L I3": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "1.3L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "1.0L I3": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "1.3L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "1.3L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Monte Carlo": {
      "1996": {
        "3.1L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.1L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.4L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.1L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.1L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.9L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Optra": {
      "2004": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB811-80000001-08080000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB811-80000001-08080000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "All": {
          "Message": null,
          "PID": "BE3EB813-80058011-FC800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Orlando": {
      "2012": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "P30": {
      "1996": {
        "6.5L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector",
          "PID": "981A0010-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "7.4L V8": {
          "Message": "Not compatible with round 9pin connector",
          "PID": "981A0010-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "6.5L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector",
          "PID": "981A0010-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "7.4L V8": {
          "Message": "Not compatible with round 9pin connector",
          "PID": "981A0010-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "7.4L V8": {
          "Message": "Not compatible with round 9pin connector",
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "7.4L V8": {
          "Message": "Not compatible with round 9pin connector",
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Prizm": {
      "1998": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "S10": {
      "1996": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.3L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.3L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.3L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.3L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EF810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.3L V6": {
          "Message": null,
          "PID": "BE3EF810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EF810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.3L V6": {
          "Message": null,
          "PID": "BE3EF810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.3L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.3L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "SS": {
      "2014": {
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "SSR": {
      "2003": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Silverado 1500": {
      "1999": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2001": {
        "4.3L V6": {
          "Message": null,
          "PID": "981A0014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "981A0014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "981A0014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "981A0014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2002": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2003": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2004": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "4.8L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8 Hybrid": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8 Hybrid": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8 Hybrid": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8 Hybrid": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8 Hybrid": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED04001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED04001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED04001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED0C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED0C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED0C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED0C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED2C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED2C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED2C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED2C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED2C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED2C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED2C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED2C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED2C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED2C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED2C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.7L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.3L V6": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "2.7L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L I6 Turbo Diesel": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.3L V6": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "2.7L I4 Turbo": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L I6 Turbo Diesel": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.3L V6": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Silverado 1500 (Vin Pos 5 Y/9/W/8)": {
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Silverado 1500 (Vin Pos 5 U/H/D/A)": {
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Silverado 1500 Classic": {
      "1999": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Silverado 1500 LD": {
      "2019": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Silverado 2500": {
      "1999": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2001": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2002": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2003": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2004": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED2C001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED2C001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED2C001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED2C001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED2C001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED2C001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "6.6L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "6.6L V8": {
          "Message": null,
          "PID": "98590013-8003A015-F4C0801D-E9E98343-EBF6012D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "98590013-8003A015-F4C0801D-E9E98343-EBF6012D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "98590013-8003A015-F4C0801D-E9E98343-EBF6012D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "98590013-8003A015-F4C0801D-E9E98343-EBF6012D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "98590013-8003A015-F4C0801D-E9E98343-EBF6012D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "98590013-8003A015-F4C0801D-E9E98343-EBF6012D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Silverado 2500 Classic": {
      "1999": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.4L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Silverado 3500": {
      "2001": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2002": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2003": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2004": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED2C001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED2C001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED2C001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED2C001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED2C001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.6L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED2C001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED2C001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "6.6L V8": {
          "Message": null,
          "PID": "98590013-8003A015-F4C0801D-E9E98343-EBF6012D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "98590013-8003A015-F4C0801D-E9E98343-EBF6012D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "98590013-8003A015-F4C0801D-E9E98343-EBF6012D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "98590013-8003A015-F4C0801D-E9E98343-EBF6012D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "98590013-8003A015-F4C0801D-E9E98343-EBF6012D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "98590013-8003A015-F4C0801D-E9E98343-EBF6012D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Silverado 3500 Classic": {
      "1999": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.4L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.4L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "8.1L V8": {
          "Message": null,
          "PID": "B83AA014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "981A0014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Silverado EV": {
      "2024": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Sonic": {
      "2012": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.6L I4": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.6L I4": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BF7FFF1B-9F07E01B-FFD0FF0B-9F00000A-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4": {
          "Message": null,
          "PID": "BF7FFF1B-9F07E01B-FFD0FF0B-9F00000A-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BF7FFF1B-9F07E01B-FFD0FF0B-9F00000A-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Spark": {
      "2013": {
        "1.2L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "1.2L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "EV": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "1.2L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "EV": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "1.4L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.4L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.4L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.4L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED28001-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "1.4L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED28001-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "1.4L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED28001-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE1FB813-8007E011-FED08001-63000001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Suburban": {
      "1996": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.4L V8": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.4L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.4L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.4L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2001": {
        "5.3L V8": {
          "Message": null,
          "PID": "98B9D117-80A3F101-C4E2CF0D-E9E9BB53-E9B2BE00",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "98B9D117-80A3F101-C4E2CF0D-E9E9BB53-E9B2BE00",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "98B9D117-80A3F101-C4E2CF0D-E9E9BB53-E9B2BE00",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "98B9D117-80A3F101-C4E2CF0D-E9E9BB53-E9B2BE00",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2002": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2003": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2004": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED08001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED2C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED2C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED2C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED2C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED2C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "5.3L V8": {
          "Message": null,
          "PID": "BE1B3013-80022001-44000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BE1B3013-80022001-44000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFDFA893-A007F119-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFDFA893-A007F119-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFDFA893-A007F119-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFDFA893-A007F119-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "T Series": {
      "2007": {
        "7.8L I6 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "7.8L I6 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Tahoe": {
      "1996": {
        "5.7L V8": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2001": {
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2002": {
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2003": {
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2004": {
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "4.8L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "4.8L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8 Hybrid": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8 Hybrid": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8 Hybrid": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8 Hybrid": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8 Hybrid": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8 Hybrid": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED08001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E01B-FED2C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED2C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "5.3L V8": {
          "Message": null,
          "PID": "BE1B3013-80022001-44000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BE1B3013-80022001-44000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "5.3L V8": {
          "Message": null,
          "PID": "BE1B3013-80022001-44000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BE1B3013-80022001-44000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "98590013-8003A011-F4C0801D-EBE98343-EBF6002D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "98590013-8003A011-F4C0801D-EBE98343-EBF6002D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "98590013-8003A011-F4C0801D-EBE98343-EBF6002D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "98590013-8003A011-F4C0801D-EBE98343-EBF6002D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Tracker": {
      "1998": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000 ",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000 ",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "2.5L V6": {
          "Message": null,
          "PID": "BFBFB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Trailblazer": {
      "2002": {
        "4.2L I6": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "4.2L I6": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "4.2L I6": {
          "Message": null,
          "PID": "BE3EF811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3EF811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "4.2L I6": {
          "Message": null,
          "PID": "BE3EF811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3EF811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "4.2L I6": {
          "Message": null,
          "PID": "BE3FF811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3FF811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BE3FF811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "4.2L I6": {
          "Message": null,
          "PID": "BE3FF811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3FF811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BE3FF811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "4.2L I6": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "4.2L I6": {
          "Message": null,
          "PID": "BF7FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BF7FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "1.2L I4 Turbo": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "1.3L I4 Turbo": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Traverse": {
      "2009": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63000001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63000001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63000001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63000001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Trax": {
      "2013": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED0C001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED0C001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED0C001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Uplander": {
      "2005": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.9L V6": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.9L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.9L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.9L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Venture": {
      "1997": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FF811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Volt": {
      "2011": {
        "1.4L I4 Hybrid": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED00020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "1.4L I4 Hybrid": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED00020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "1.4L I4 Hybrid": {
          "Message": null,
          "PID": "BE7FF813-8007E011-FED00020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "1.4L I4 Hybrid": {
          "Message": null,
          "PID": "BE7FF813-8007E011-FED00020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.4L I4 Hybrid": {
          "Message": null,
          "PID": "BE7FF813-8007E011-FED08020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE7FB813-A01FE011-FED28021-01280000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE7FB813-A01FE011-FED28021-01280000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE7FB813-A01FE011-FED28021-01280000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE7FB813-A01FE011-FED28021-61280001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "W Series": {
      "1998": {
        "5.7L V8": {
          "Message": "Not compatible with round 9pin connector",
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "5.7L V8": {
          "Message": "Not compatible with round 9pin connector",
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "5.7L V8": {
          "Message": "Not compatible with round 9pin connector",
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "8.1L V8": {
          "Message": "Not compatible with round 9pin connector",
          "PID": "BFBFB114-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "6.0L V8": {
          "Message": "Not compatible with round 9pin connector",
          "PID": "BFBFB114-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "5.2L I4 Turbo Diesel": {
          "Message": null,
          "PID": "80000000-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "5.2L I4 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector",
          "PID": "983B0015-A0182001-40E00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.0L V8": {
          "Message": "Not compatible with round 9pin connector",
          "PID": "983B0015-A0182001-40E00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "5.2L I4 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector",
          "PID": "983B8017-A019A001-CCD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.0L V8": {
          "Message": "Not compatible with round 9pin connector",
          "PID": "983B8017-A019A001-CCD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    }
  },
  "Chrysler": {
    "200": {
      "2011": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED08005-00000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "300": {
      "1999": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB991-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB991-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.1L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.1L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.1L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.1L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.1L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "B99BFFBF-A039C127-40C0FFD0-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.1L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-00200000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "981B0013-8003A001-C4CC804D-F8B9BB43-EBE64100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08001-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08001-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Aspen": {
      "2006": {
        "6.1L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Cirrus": {
      "1996": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE3EB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "2.5L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "2.5L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Concorde": {
      "1996": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "2.7L V6": {
          "Message": null,
          "PID": "BE3CB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.7L V6": {
          "Message": null,
          "PID": "BE3CB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.7L V6": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB991-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.7L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB991-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.7L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Crossfire": {
      "2004": {
        "3.2L V6": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "3.2L V6": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L V6 Supercharged": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "3.2L V6": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "3.2L V6": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "3.2L V6": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Grand Caravan": {
      "2021": {
        "3.6L V6": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Grand Voyager": {
      "2000": {
        "3.0L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Intrepid": {
      "1996": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "2.7L V6": {
          "Message": null,
          "PID": "BE3CB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.7L V6": {
          "Message": null,
          "PID": "BE3CB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB991-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB991-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.7L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB991-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.7L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "LHS/New Yorker": {
      "1996": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "3.5L V6": {
          "Message": null,
          "PID": "983A8014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Neon": {
      "2000": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3CB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3CB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "PT Cruiser": {
      "2001": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3CB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3CB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3CB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BE3EB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Pacifica": {
      "2004": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3EB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3EB813-801FA011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3EB813-801FA011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFEB993-801FE019-FED08001-00200000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6 Plug-In Hybrid": {
          "Message": null,
          "PID": "BFFEB993-8007A019-FED08021-00000001-00000001",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFEB993-801FE019-FED08001-00200000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6 Plug-In Hybrid": {
          "Message": null,
          "PID": "BFFEB993-8007A019-FED08021-00000001-00000001",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFEB993-801FE019-FED08001-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6 Plug-In Hybrid": {
          "Message": null,
          "PID": "BFFEB993-801FE019-FED08001-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFEB993-801FE019-FED08001-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6 Plug-In Hybrid": {
          "Message": null,
          "PID": "BFFEB993-801FE019-FED08001-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFEB993-801FE019-FED08001-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6 Plug-In Hybrid": {
          "Message": null,
          "PID": "BFFEB993-801FE019-FED08001-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFFEB993-801FE019-FED08005-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFFEB993-801FE019-FED08005-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFFEB993-801FE019-FED08005-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFFEB993-801FE019-FED08005-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Prowler": {
      "2001": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB991-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Sebring": {
      "2001": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3CB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB991-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.4L I4": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE1FF81D-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Sebring Convertible": {
      "1996": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "2.5L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "2.5L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3CB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "80108000-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Sebring Coupe": {
      "1996": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "2.5L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Town and Country": {
      "1996": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3CB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "3.3L V6": {
          "Message": null,
          "PID": "80108000-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3CB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3CB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3CB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3EB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3EB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3EB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "80108000-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3EB813-801FA011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3EB813-801FA011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3EB813-801FA011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3EB813-801FA011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3EB813-801FA011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Voyager": {
      "2000": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3CB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3CB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "803CB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "3.6L V6": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "3.6L V6": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "3.6L V6": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "3.6L V6": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "983B0013-A0018001-40800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "983B0013-A0018001-40800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    }
  },
  "Daewoo": {
    "Lanos": {
      "1999": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Leganza": {
      "1999": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Nubira": {
      "1999": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    }
  },
  "Dodge": {
    "Avenger": {
      "1996": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BFBEB980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L V6": {
          "Message": null,
          "PID": "80108000-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "2.5L V6": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EF813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED08005-00000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Caliber": {
      "2007": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Caravan": {
      "1996": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3CB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3CB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3CB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BE3EB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BE3EB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Challenger": {
      "2008": {
        "6.1L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.1L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "B99BFFBF-A039C127-40C0FFD0-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.1L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFEA893-8007F119-FED08001-01000200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFEA893-8007F119-FED08001-01000200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-00200000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "981B0013-8003A001-C4CC804D-F8B9BB43-EBE64100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFEA893-8007F119-FED08001-01000200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFEA893-8007F119-FED08001-01000200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFEA893-8007F119-FED08001-01000200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFFEA893-8007F119-FED08001-61000201-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFFEA893-8007F119-FED08001-61000201-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Charger": {
      "2006": {
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.1L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.1L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.1L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.1L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.1L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEFFFF-8007FFFF-FED0FFFF-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "981B0013-8003A001-C4CC004D-F8B9BB43-EBE44100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFEA893-8007F119-FED08001-01000200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFEA893-8007F119-FED08001-01000200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-00200000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "981B0013-8003A001-C4CC804D-F8B9BB43-EBE64100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFEA893-8007F119-FED08001-01000200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB993-8017E019-FED18000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFEA893-8007F119-FED08001-01000200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFEA893-8007F119-FED08001-01000200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BE3DB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08001-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08001-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08001-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Charger EV": {
      "2024": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "Dakota": {
      "1996": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.9L V6": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.2L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.9L V6": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.2L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.9L V6": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.2L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V8": {
          "Message": null,
          "PID": "B81AA014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.9L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.2L V8": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BFBEBD90-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.9L V6": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V8": {
          "Message": null,
          "PID": "983A8014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.9L V6": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.9L V6": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "3.9L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "All": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "All": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Dart": {
      "2013": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Durango": {
      "1998": {
        "3.9L V6": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.2L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "5.2L V8": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "4.7L V8": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.2L V8": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V8": {
          "Message": null,
          "PID": "983A8014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "4.7L V8": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "4.7L V8": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "4.7L V8": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8 Hybrid": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-00200000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BE3DB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08005-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08005-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08005-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08005-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Grand Caravan": {
      "1996": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "3.0L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3CB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "3.0L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE1FA810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.3L V6": {
          "Message": null,
          "PID": "803CB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3CB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3CB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.3L V6": {
          "Message": null,
          "PID": "80108000-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3EB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3EB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "803EB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3EB813-801FA011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3EB813-801FA011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3EB813-801FA011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3EB813-801FA011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3EB813-801FA011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Hornet": {
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Intrepid": {
      "1996": {
        "3.3L V6": {
          "Message": null,
          "PID": "BFBEB980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "3.3L V6": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "2.7L V6": {
          "Message": null,
          "PID": "BE3CB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.7L V6": {
          "Message": null,
          "PID": "BE3CB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.7L V6": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.7L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB991-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.7L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "80108000-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Journey": {
      "2009": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EBCFF-8007ECFF-FED00CFF-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED08005-00000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Magnum": {
      "2005": {
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.1L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.1L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.1L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Neon": {
      "1996": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3CB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3CB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3CB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Nitro": {
      "2007": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Ram 1500": {
      "1996": {
        "3.9L V6": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.2L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "3.9L V6": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.2L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "3.9L V6": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.2L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "3.9L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.2L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "3.9L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.2L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BFBEB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "3.9L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.2L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "3.3L V6": {
          "Message": null,
          "PID": "803CB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBFB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.7L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB995-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB995-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "8.3L V10": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB995-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB995-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "8.3L V10": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB997-8007A019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB997-801FA019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB997-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "8.3L V10": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB997-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB997-801FA019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB997-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB997-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB997-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB997-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB997-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB997-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB997-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB997-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB997-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB997-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB997-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB997-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.7L V6": {
          "Message": "2013 models are listed under Ram brand",
          "PID": "BFBEB997-801FE019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8": {
          "Message": "2013 models are listed under Ram brand",
          "PID": "BFBEB997-801FE019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": "2013 models are listed under Ram brand",
          "PID": "BFBEB997-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Ram 2500": {
      "1996": {
        "5.2L V8": {
          "Message": null,
          "PID": "BFBEB114-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L I6 Turbo Diesel": {
          "Message": null,
          "PID": "B81AA014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "8.0L V10": {
          "Message": null,
          "PID": "BFBEB114-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "5.9L I6 Turbo Diesel": {
          "Message": null,
          "PID": "B81AA014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "8.0L V10": {
          "Message": null,
          "PID": "BFBEB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "5.9L I6 Turbo Diesel": {
          "Message": null,
          "PID": "B83AA014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "8.0L V10": {
          "Message": null,
          "PID": "BFBEB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "5.2L V8": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983A8014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "8.0L V10": {
          "Message": null,
          "PID": "BFBEB114-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "5.9L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983A8014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BFBEB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "8.0L V10": {
          "Message": null,
          "PID": "BFBEB114-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "5.9L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983A8014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "8.0L V10": {
          "Message": null,
          "PID": "BFBEB114-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "5.9L I6 Turbo Diesel": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "8.0L V10": {
          "Message": null,
          "PID": "BFBEB114-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "5.7L V8": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.9L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983A8014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "8.0L V10": {
          "Message": null,
          "PID": "BFBEBD94-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB995-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.9L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983A8014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB995-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.9L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983A8015-20022001-44000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.9L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983A8017-A003A001-C40C8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB997-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.9L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983A8017-A003A001-C40C8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983B801F-A01BB815-C48E8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB997-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.9L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983A8017-A003A001-C40C8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983B801F-A01BB815-C48E8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB997-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.9L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983A8017-A003A001-C40C8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983B801F-A01BB815-C48E8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB997-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983B8017-A01BA015-CC9C8007-5BFE5FFF-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983B8017-A01BA015-CC9C8007-5BFE5FFF-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "5.7L V8": {
          "Message": "2013 models are listed under Ram brand",
          "PID": "BFBEB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L I6 Turbo Diesel": {
          "Message": "2013 models are listed under Ram brand",
          "PID": "981B0013-8003A001-C4CC004D-F8B9B94F-EBE44100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Ram 3500": {
      "1996": {
        "5.9L I6 Turbo Diesel": {
          "Message": null,
          "PID": "B81AA014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BFBEB114-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "8.0L V10": {
          "Message": null,
          "PID": "BFBEB114-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "5.9L I6 Turbo Diesel": {
          "Message": null,
          "PID": "B81AA014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "8.0L V10": {
          "Message": null,
          "PID": "BFBEB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "5.9L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983A8014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V8": {
          "Message": null,
          "PID": "B81AA014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "8.0L V10": {
          "Message": null,
          "PID": "BFBEB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "5.9L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983A8014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "8.0L V10": {
          "Message": null,
          "PID": "BFBEB114-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "5.9L I6 Turbo Diesel": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V8": {
          "Message": null,
          "PID": "983A8014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "8.0L V10": {
          "Message": null,
          "PID": "BFBEB114-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "5.9L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983A8014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BFBEB114-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "8.0L V10": {
          "Message": null,
          "PID": "BFBEB114-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "5.9L I6 Turbo Diesel": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "8.0L V10": {
          "Message": null,
          "PID": "BFBEB114-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "5.7L V8": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.9L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983A8014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB995-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.9L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983A8014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB995-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.9L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983A8015-20022001-44000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB997-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.9L I6 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB114-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.9L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983A8017-A003A001-C40C8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983B801F-A01BB815-C48E8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB997-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983B801F-A01BB815-C48E8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983B801F-A01BB815-C48E8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983B8017-A01BA015-CC9C8007-5BFE5FFF-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983B8017-A01BA015-CC9C8007-5BFE5FFF-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Ram 4500/5500": {
      "2008": {
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983B8017-A01BA015-C40C8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983B8017-A01BA015-CC9C8007-5BFE5FFF-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983B8017-A01BA015-CC9C8007-5BFE5FFF-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983B8017-A01BA015-CC9C8007-5BFE5FFF-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Ram Van/Wagon": {
      "1996": {
        "3.9L V6": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.2L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "3.9L V6": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.2L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "3.9L V6": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.2L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "3.9L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.2L V8": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "3.9L V6": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.2L V8": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V8": {
          "Message": null,
          "PID": "983A8014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "3.9L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.2L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "3.9L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.2L V8": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "3.9L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.2L V8": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Sprinter": {
      "2002": {
        "2.7L I5 Turbo Diesel": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "2.7L I5 Turbo Diesel": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "2.7L I5 Turbo Diesel": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "2.7L I5 Turbo Diesel": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "2.7L I5 Turbo Diesel": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.5L V6": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.5L V6": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Stealth": {
      "1996": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Stratus": {
      "1996": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3CB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3CB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB991-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Stratus Coupe": {
      "2001": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Viper": {
      "1996": {
        "8.0L V10": {
          "Message": null,
          "PID": "BFBEB114-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "8.0L V10": {
          "Message": null,
          "PID": "BFBEB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "8.0L V10": {
          "Message": null,
          "PID": "BFBEB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "8.0L V10": {
          "Message": null,
          "PID": "BFBEB114-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "8.0L V10": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "8.0L V10": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "8.0L V10": {
          "Message": null,
          "PID": "BFBEB114-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "8.3L V10": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "8.3L V10": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "8.3L V10": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "8.3L V10": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "8.4L V10": {
          "Message": null,
          "PID": "BFBFB993-8007A019-FFD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "8.4L V10": {
          "Message": null,
          "PID": "BFBFB993-8007A019-FFD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "8.4L V10": {
          "Message": null,
          "PID": "BFBFB993-8007A019-FFD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "8.4L V10": {
          "Message": null,
          "PID": "BFBFB993-8007A019-FFD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "8.4L V10": {
          "Message": null,
          "PID": "BFBFB993-8007A019-FFD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "8.4L V10": {
          "Message": null,
          "PID": "BFBFB993-8007A019-FFD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "8.4L V10": {
          "Message": null,
          "PID": "BFBFB993-8007A019-FFD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "8.4L V10": {
          "Message": null,
          "PID": "BFBFB993-8007A019-FFD08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    }
  },
  "Eagle": {
    "Summit": {
      "1996": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Talon": {
      "1996": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Vision": {
      "1996": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE3CB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    }
  },
  "Ferrari": {
    "12Cilindri": {
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    " SF 90 Stradale": {
      "2021": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "296": {
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "360": {
      "1999": {
        "3.6L V8": {
          "Message": null,
          "PID": "BE1FE810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "3.6L V8": {
          "Message": null,
          "PID": "BE1FE810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "3.6L V8": {
          "Message": null,
          "PID": "BE1FE810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "3.6L V8": {
          "Message": null,
          "PID": "BE1FE810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "3.6L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "3.6L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "3.6L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "456": {
      "1997": {
        "5.5L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "5.5L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "5.5L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "5.5L V12": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "5.5L V12": {
          "Message": null,
          "PID": "B99FE190-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "5.5L V12": {
          "Message": null,
          "PID": "B99FE190-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "5.5L V12": {
          "Message": null,
          "PID": "B99FE190-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "458": {
      "2010": {
        "4.5L V8": {
          "Message": null,
          "PID": "BF9FE893-A007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "4.5L V8": {
          "Message": null,
          "PID": "BF9FE893-A007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "4.5L V8": {
          "Message": null,
          "PID": "BF9FE893-A007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "4.5L V8": {
          "Message": null,
          "PID": "BF9FE893-A007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "4.5L V8": {
          "Message": null,
          "PID": "BF9FE893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "4.5L V8": {
          "Message": null,
          "PID": "BF9FE893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "488": {
      "2015": {
        "3.9L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "3.9L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "3.9L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "3.9L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "3.9L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "3.9L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "550": {
      "1997": {
        "5.5L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "5.5L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "5.5L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "5.5L V12": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "5.5L V12": {
          "Message": null,
          "PID": "B99FE190-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "5.5L V12": {
          "Message": null,
          "PID": "B99FE190-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "575M": {
      "2002": {
        "5.7L V12": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "5.7L V12": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "5.7L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "5.7L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "5.7L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "599": {
      "2007": {
        "6.0L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "6.0L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "6.0L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "6.0L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "6.0L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "6.0L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "612": {
      "2005": {
        "5.7L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "5.7L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "5.7L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "5.7L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "5.7L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "5.7L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "5.7L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "812": {
      "2018": {
        "6.5L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "6.5L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "6.5L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "6.5L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "California": {
      "2009": {
        "4.3L V8": {
          "Message": null,
          "PID": "BF9FE893-A007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "4.3L V8": {
          "Message": null,
          "PID": "BF9FE893-A007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "4.3L V8": {
          "Message": null,
          "PID": "BF9FE893-A007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "4.3L V8": {
          "Message": null,
          "PID": "BF9FE893-A007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "4.3L V8": {
          "Message": null,
          "PID": "BF9FE893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "4.3L V8": {
          "Message": null,
          "PID": "BF9FE893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "3.9L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "3.9L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "3.9L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "3.9L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Enzo": {
      "2003": {
        "6.0L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "6.0L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "F12": {
      "2013": {
        "6.3L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "6.3L V12": {
          "Message": null,
          "PID": "BF9FE893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "6.3L V12": {
          "Message": null,
          "PID": "BF9FE893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "6.3L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "6.3L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "F355": {
      "1996": {
        "3.5L V8": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "3.5L V8": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "3.5L V8": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "3.5L V8": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "F430": {
      "2005": {
        "4.3L V8": {
          "Message": null,
          "PID": "BE1FA811-00001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "4.3L V8": {
          "Message": null,
          "PID": "BE1FA811-00001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "4.3L V8": {
          "Message": null,
          "PID": "BE1FA811-00001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "4.3L V8": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "4.3L V8": {
          "Message": null,
          "PID": "BF9FE893-8007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "F8": {
      "2020": {
        "3.9L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "3.9L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBCE893-8007B119-F7C08551-6D190201-000C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "FF": {
      "2012": {
        "6.3L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "6.3L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "6.3L V12": {
          "Message": null,
          "PID": "BF9FE893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "6.3L V12": {
          "Message": null,
          "PID": "BF9FE893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "6.3L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "GTC4Lusso": {
      "2017": {
        "6.3L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "3.9L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.3L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "3.9L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.3L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "6.3L V12": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "LaFerrari": {
      "2013": {
        "6.3L V12 Hybrid": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "6.3L V12 Hybrid": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "6.3L V12 Hybrid": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "6.3L V12 Hybrid": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "6.3L V12 Hybrid": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "6.3L V12 Hybrid": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Portofino": {
      "2018": {
        "3.9L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "3.9L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "3.9L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "3.9L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBCA893-8007B119-F7C08541-6D190201-000C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFBCA893-8007B119-F7C08541-6D190201-000C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Purosangue": {
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Roma": {
      "2021": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    }
  },
  "Fiat": {
    "124 Spider": {
      "2017": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8017F011-FED48000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8017F011-FED48000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "500": {
      "2012": {
        "1.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "1.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2014": {
        "1.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2015": {
        "1.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2016": {
        "1.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2017": {
        "1.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2018": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2019": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "500E": {
      "2024": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "500L": {
      "2014": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "500X": {
      "2016": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "1.3L I4 Turbo": {
          "Message": null,
          "PID": "BE7EA813-8007F011-FED28001-01080200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "1.3L I4 Turbo": {
          "Message": null,
          "PID": "BE7EA813-8007F011-FED28001-01080200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BE7EA813-8007F011-FED28005-61080201-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE7EA813-8007F011-FED28005-61080201-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE7EA813-8007F011-FED28005-61080201-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE7EA813-8007F011-FED28005-61080201-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    }
  },
  "Fisker": {
    "Karma": {
      "2012": {
        "2.0L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "2.0L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Ocean": {
      "2023": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    }
  },
  "Ford": {
    "Aerostar": {
      "1996": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.0L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Aspire": {
      "1996": {
        "1.3L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "1.3L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Bronco": {
      "1996": {
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FF910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.8L V8": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD08505-61A00001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD08505-61A00001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD08505-61A00001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD08505-61A00001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD08505-61A00001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Bronco Sport": {
      "2021": {
        "1.5L I3 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FCD09405-61000001-0004200F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FCD09405-61000001-0004200F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FCD09405-61000001-0004200F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "2.0L I4 Turbo": {
          "Message": "This vehicle uses a new generation of OBDII - Check back soon for updated compatibility!",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "All Except 2.0 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "C-Max": {
      "2013": {
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED03021-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED03021-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED03020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED03020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED0B021-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED0B021-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED0B021-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED0B021-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED0B021-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED0B021-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED0B020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "CF/LCF": {
      "2006": {
        "4.5L V6 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "4.5L V6 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Contour": {
      "1996": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Crown Victoria": {
      "1996": {
        "4.6L V8": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8 CNG": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "4.6L V8": {
          "Message": null,
          "PID": "B81FA010-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8 CNG": {
          "Message": null,
          "PID": "B81FA010-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB991-C0000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.6L V8 CNG": {
          "Message": null,
          "PID": "BFBFB991-C0000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2004": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB991-C0000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.6L V8 CNG": {
          "Message": null,
          "PID": "BFBFB991-C0000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "E-Transit": {
      "2022": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2023": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2024": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2025": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      }
    },
    "E-Series SD Van/Chassis": {
      "1996": {
        "4.9L I6": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FF910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.8L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "BF9FF910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "7.5L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FF910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "4.2L V6": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB110-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "1998": {
        "4.2L V6": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB110-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "1999": {
        "4.2L V6": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8 CNG": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB110-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "4.2L V6": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB110-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8 CNG": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB110-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2001": {
        "4.2L V6": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB915-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2002": {
        "4.2L V6": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB911-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8 CNG": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2003": {
        "4.2L V6": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB911-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8 CNG": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB110-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2004": {
        "4.6L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB991-C0000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB911-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8 CNG": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B8014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB991-C0000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "4.6L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB997-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0017-801BA001-C0E00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB917-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "4.6L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB997-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983A0017-801BA001-C0E00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB997-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "4.6L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BFFFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB117-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0017-801BA001-C0E00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB117-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "4.6L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB997-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0017-801BA001-C0E00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB997-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "4.6L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BFBFA897-801FF119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0017-801BA001-C0E00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB917-8007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "4.6L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BFBFA897-801FF119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BE7FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0017-801BA001-C0E00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB997-8007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "4.6L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BFBFA897-801FF119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB917-8007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "4.6L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA897-8007F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007B119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "4.6L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BFBFA897-801FF119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007B119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA897-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "4.6L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BFBFA897-801FF119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA897-8007F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "5.4L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007F119-FED08001-00000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "5.4L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007F119-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007B111-FED09001-08000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "6.2L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BFBEA897-8007B119-FED0D001-08000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007B111-FED09001-00000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "6.2L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA897-8007B119-FED0D501-09000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007B111-FED09001-00000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "6.2L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA897-8007B119-FED0D501-09000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007B111-FED09001-00000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "7.3L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "7.3L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Ecosport": {
      "2018": {
        "1.0L I3 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09010-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-A007B011-FED09401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "1.0L I3 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09411-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-A007B011-FED09401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "1.0L I3 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09411-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09411-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "1.0L I3 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09411-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09411-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE1FA813-A007B011-FED09405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Edge": {
      "2007": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BFBEA893-8007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-01A02001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-01A02001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FCD09401-61A00001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FCD09401-61A00001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FCD09401-61A00001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Escape": {
      "2001": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.0L I4": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB811-40000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB811-40000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB813-C017E011-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.3L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FB813-C017E011-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB813-8017E011-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.3L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FB813-C017E011-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB813-C017E011-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.3L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FB813-C017E011-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB813-C017E011-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.3L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FB813-C017E011-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FB813-8017E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB993-8017E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFA893-8017F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFA893-8017F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFA893-8017F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-8017F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2016": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-8017F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2017": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2018": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2019": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2020": {
        "1.5L I3 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.5L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2021": {
        "1.5L I3 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-8007B011-FED0A425-61B02001-0004204D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-8007B011-FED0A425-61B02001-0004204D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-8007B011-FED0A425-61B02001-0004204D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-8007B011-FED0A425-61B02001-0004204D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      }
    },
    "Escort": {
      "1996": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.9L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3CB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE5FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Excursion": {
      "2000": {
        "5.4L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB110-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB110-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "BF9FB110-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2001": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": null,
          "PID": "BF9FB911-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "BF9FB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2002": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": null,
          "PID": "BF9FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2003": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8 Turbo Diesel": {
          "Message": null,
          "PID": "9C7F8057-7E440057-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": null,
          "PID": "BF9FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "BF9FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2004": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB911-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8 Turbo Diesel": {
          "Message": null,
          "PID": "983B8014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": null,
          "PID": "BF9FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB911-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8 Turbo Diesel": {
          "Message": null,
          "PID": "983B0017-801BA001-C0E00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": null,
          "PID": "BF9FB911-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Expedition": {
      "1997": {
        "4.6L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.4L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "1998": {
        "4.6L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.4L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "1999": {
        "4.6L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.4L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2000": {
        "4.6L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.4L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2001": {
        "4.6L V8": {
          "Message": null,
          "PID": "B81FA010-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2002": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2003": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB993-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2006": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB993-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2007": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2008": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2009": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED04040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2010": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED04040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2011": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED04040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2012": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2013": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2014": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2015": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08001-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2016": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08001-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2017": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08001-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2018": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2019": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-01000001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2020": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-01000001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2021": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-01000001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD08505-61A02001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD08505-61A02001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD08505-61A02001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": "This vehicle uses a new generation of OBDII - Check back soon for updated compatibility!",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "Explorer": {
      "1996": {
        "4.0L V6": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "1997": {
        "4.0L V6": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "1998": {
        "4.0L V6": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BFDFB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "1999": {
        "4.0L V6": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2000": {
        "4.0L V6": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2001": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "4.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "4.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "4.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB993-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "4.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB993-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "4.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB993-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "4.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB993-C007E019-FEF00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "4.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB993-C007E019-FEF00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB993-801FE019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-8007B119-FED0D000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA897-8007B119-FED09001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-8007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-8007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-8007B119-FED0D000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-8007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-8007B119-FED0D501-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-01000001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA897-8007B119-FED09501-09000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FCD09401-61A02001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FCD09401-61A02001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FCD09401-61A02001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6 Hybrid": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD0D501-61800001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FCD09401-61A02001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FCD09401-61A02001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FCD09401-61A02001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6 Hybrid": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FCD09401-61A02001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FCD09401-61A02001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FCD09401-61A02001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FCD09401-61A02001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "2.3L I4 Turbo": {
          "Message": "This vehicle uses a new generation of OBDII - Check back soon for updated compatibility!",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "All Except 2.3 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Explorer SportTrac": {
      "2001": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB8E9-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "4.0L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "4.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB993-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "4.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB993-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "4.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB993-C007E019-FEF00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "4.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB993-C007E019-FEF00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "F-150": {
      "1996": {
        "4.9L I6": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FF910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FF910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.8L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "4.2L V6": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "4.2L V6": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "4.2L V6": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8 Supercharged": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "4.2L V6": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8 CNG": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8 Supercharged": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "4.2L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8 CNG": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "4.2L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "4.2L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8 CNG": {
          "Message": null,
          "PID": "BF9FB110-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB991-C0000001-48100000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB991-C0000001-48100000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "4.2L V6": {
          "Message": null,
          "PID": "BFBFB993-801FE019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB993-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "4.2L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB993-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "4.2L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB993-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "4.2L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB993-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED04040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED04040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA897-8007F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BF9FA897-8007F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA897-8007F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BF9FA897-8007F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-8007B119-FED0D000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBEA893-8007B119-FED0D000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-8007B119-FED0D000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBEA893-8007B119-FED0D000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-8007B119-FED0D000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09001-00000001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBEA893-8007B119-FED0D000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-01A02001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "981B0013-A003A015-C4C080C9-F8E9A343-E9F6002D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD0D501-01800001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-01000001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD0D501-01000001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-01A02001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "981B0013-A003A015-C4C080C9-F8E9A343-E9F6002D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD0D501-61800001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-61000001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD0D501-61000001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2020": {
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-01A02001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-01A02001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-01A02001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-01A02001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-01A02001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2021": {
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-01A02001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-01A02001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-01A02001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.5L V6 Twin Turbo Hybrid": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-01A02001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2022": {
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2023": {
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2024": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2025": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      }
    },
    "F-150 Heritage": {
      "2004": {
        "4.2L V6": {
          "Message": null,
          "PID": "BFBFB991-C0000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8 CNG": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "F-250": {
      "1996": {
        "4.9L I6": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FF910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.8L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "BF9FF910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "7.5L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "4.6L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8 CNG": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.8L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "7.5L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "4.6L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "4.6L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8 CNG": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB110-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2000": {
        "5.4L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB110-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB110-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "BF9FB110-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2001": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": null,
          "PID": "BF9FB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "BF9FB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2002": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "BF9FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2003": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8 Turbo Diesel": {
          "Message": null,
          "PID": "983B8014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": null,
          "PID": "BF9FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "BF9FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2004": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": null,
          "PID": "BF9FB911-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB997-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8 Turbo Diesel": {
          "Message": null,
          "PID": "983A0017-801BA001-C0E00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": null,
          "PID": "BF9FB117-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB997-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8 Turbo Diesel": {
          "Message": null,
          "PID": "983B0017-801BA001-C0E00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": null,
          "PID": "BF9FB117-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB997-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8 Turbo Diesel": {
          "Message": null,
          "PID": "983B0017-801BA001-C0E00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": null,
          "PID": "BF9FB117-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "5.4L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.4L V8 Turbo Diesel": {
          "Message": null,
          "PID": "983B0017-A01BA015-C0CC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": null,
          "PID": "BF9FB997-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB997-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.4L V8 Turbo Diesel": {
          "Message": null,
          "PID": "983B0017-A01BA015-C0CC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": null,
          "PID": "BF9FB997-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB997-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.4L V8 Turbo Diesel": {
          "Message": null,
          "PID": "983B0017-A01BA015-C0CC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": null,
          "PID": "BF9FB997-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "6.2L V8": {
          "Message": null,
          "PID": "BF9FA897-8007F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L V8 Turbo Diesel": {
          "Message": null,
          "PID": "981A2013-9003A001-C4C2801D-FFE8E34F-EAE00000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "6.2L V8": {
          "Message": null,
          "PID": "BF9FA897-8007F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L V8 Turbo Diesel": {
          "Message": null,
          "PID": "981A2013-9003A001-C4C2801D-FFE8E34F-EAE00000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "6.2L V8": {
          "Message": null,
          "PID": "BF9FA897-8007F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L V8 Turbo Diesel": {
          "Message": null,
          "PID": "98180013-8003A001-C4C0801F-FFE8E34F-EBF40000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "6.2L V8": {
          "Message": null,
          "PID": "BF9FA897-8007F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L V8 Turbo Diesel": {
          "Message": null,
          "PID": "98180013-8003A001-C4C0801F-FFE8E34F-EBF40000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "6.2L V8": {
          "Message": null,
          "PID": "BF9FA897-8007F119-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L V8 Turbo Diesel": {
          "Message": null,
          "PID": "981A0013-8003A001-C4C0801D-FFE8A34F-EBF60000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "6.2L V8": {
          "Message": null,
          "PID": "BF9FA897-8007F119-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L V8 Turbo Diesel": {
          "Message": null,
          "PID": "981A0013-8003A001-C4C0801D-FFE8A34F-EBF60000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "6.2L V8": {
          "Message": null,
          "PID": "BFBEA897-8007B119-FED0D001-08000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.7L V8 Turbo Diesel": {
          "Message": null,
          "PID": "983B0017-A01BA015-C4C080DD-FFE9A34F-EBF6002D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "6.2L V8": {
          "Message": null,
          "PID": "BFBEA897-8007B119-FED0D501-09000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.7L V8 Turbo Diesel": {
          "Message": null,
          "PID": "983B0017-A01BA015-C4C080DD-FFE9A34F-EBF6002D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "6.2L V8": {
          "Message": null,
          "PID": "BF9FA897-8007B119-FED0D501-09000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "6.7L V8 Turbo Diesel": {
          "Message": null,
          "PID": "983B0017-A01BA015-C4C080DD-FFE9A34F-EBF6002D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2020": {
        "6.2L V8": {
          "Message": null,
          "PID": "BF9FA897-8007B119-FED0D501-09000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "6.7L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BF9FA897-8007B119-FED0D501-09000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "7.3L V8": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2021": {
        "6.2L V8": {
          "Message": null,
          "PID": "BF9FA897-8007B119-FED0D501-09000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "6.7L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BF9FA897-8007B119-FED0D501-09000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "7.3L V8": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      }
    },
    "F-350": {
      "1996": {
        "5.8L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "7.5L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "5.8L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "7.5L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "5.4L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB110-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "BF9FB110-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2000": {
        "5.4L V8": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB110-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB110-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "BF9FB110-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2001": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB911-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": null,
          "PID": "BF9FB911-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "BF9FB911-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2002": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": null,
          "PID": "BF9FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2003": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8 Turbo Diesel": {
          "Message": null,
          "PID": "983B8014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": null,
          "PID": "BF9FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2004": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8 Turbo Diesel": {
          "Message": null,
          "PID": "983B8014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": null,
          "PID": "BF9FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB997-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8 Turbo Diesel": {
          "Message": null,
          "PID": "983B0017-801BA001-C0E00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": null,
          "PID": "BF9FB997-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "5.4L V8": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8 Turbo Diesel": {
          "Message": null,
          "PID": "983B0017-801BA001-C0E00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": null,
          "PID": "BF9FB997-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB997-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8 Turbo Diesel": {
          "Message": null,
          "PID": "983B0017-801BA001-C0E00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": null,
          "PID": "BF9FB997-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB997-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.4L V8 Turbo Diesel": {
          "Message": null,
          "PID": "983B0017-A01BA015-C0CC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": null,
          "PID": "BF9FB997-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB997-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.4L V8 Turbo Diesel": {
          "Message": null,
          "PID": "983B0017-A01BA015-C0CC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": null,
          "PID": "BF9FB917-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB997-C007E019-FFF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.4L V8 Turbo Diesel": {
          "Message": null,
          "PID": "983B0017-A01BA015-C0CC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": null,
          "PID": "BF9FB997-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "6.2L V8": {
          "Message": null,
          "PID": "BF9FA897-8007F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L V8 Turbo Diesel": {
          "Message": null,
          "PID": "981A2013-9003A001-C4C2801D-FFE8A34F-EAE00000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "6.2L V8": {
          "Message": null,
          "PID": "BF9FA897-8007F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L V8 Turbo Diesel": {
          "Message": null,
          "PID": "981A2013-9003A001-C4C2801D-FFE8A34F-EAE00000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "6.2L V8": {
          "Message": null,
          "PID": "BF9FA897-8007F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L V8 Turbo Diesel": {
          "Message": null,
          "PID": "981A0013-8003A001-C4C0801F-FFE8E34F-EBF40000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "6.2L V8": {
          "Message": null,
          "PID": "BF9FA897-8007F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L V8 Turbo Diesel": {
          "Message": null,
          "PID": "981A0013-8003A001-C4C0801D-FFE8E34F-EBF40000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "6.2L V8": {
          "Message": null,
          "PID": "BF9FA897-8007F119-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L V8 Turbo Diesel": {
          "Message": null,
          "PID": "981A0013-8003A001-C4C0801D-FFE8A34F-EBF60000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "6.2L V8": {
          "Message": null,
          "PID": "BF9FA897-8007F119-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L V8 Turbo Diesel": {
          "Message": null,
          "PID": "981A0013-8003A001-C4C0801D-FFE8A34F-EBF60000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "6.2L V8": {
          "Message": null,
          "PID": "BFBEA897-8007B119-FED0D501-09000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.7L V8 Turbo Diesel": {
          "Message": null,
          "PID": "983B0017-A01BA015-C4C080DD-FFE9A34F-EBF6002D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "6.2L V8": {
          "Message": null,
          "PID": "BF9FA897-8007B119-FED0D501-09000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.7L V8 Turbo Diesel": {
          "Message": null,
          "PID": "983B0017-A01BA015-C4C080DD-FFE9A34F-EBF6002D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "6.2L V8": {
          "Message": null,
          "PID": "BF9FA897-8007B119-FED0D501-09000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "6.7L V8 Turbo Diesel": {
          "Message": null,
          "PID": "983B0017-A01BA015-C4C080DD-FFE9A34F-EBF6002D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2020": {
        "6.2L V8": {
          "Message": null,
          "PID": "BF9FA897-8007B119-FED0D501-09000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "6.7L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BF9FA897-8007B119-FED0D501-09000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "7.3L V8": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2021": {
        "6.2L V8": {
          "Message": null,
          "PID": "BF9FA897-8007B119-FED0D501-09000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "6.7L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BF9FA897-8007B119-FED0D501-09000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "7.3L V8": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      }
    },
    "F-450": {
      "1996": {
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "7.5L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "7.5L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "7.5L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB110-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "BF9FB110-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2000": {
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB110-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "BF9FB110-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2001": {
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "BF9FB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2002": {
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "BF9FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2003": {
        "6.0L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B8014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "983B8014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2004": {
        "6.0L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B8014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "6.0L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983A0017-801BA001-C0E00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB117-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "6.0L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983A0017-801BA001-C0E00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB117-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "6.0L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983A0017-801BA001-C0E00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB117-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "6.4L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0017-A01BA015-C0CC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB117-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "6.4L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0017-A01BA015-C0CC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB917-8007A019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "6.4L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0017-A01BA015-C0CC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB917-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "6.7L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "98182013-9003A001-C4C2801D-FFE8A34F-EAE00000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007B119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "6.7L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "981A2013-9003A001-C4C2801D-FFE8A34F-EAE00000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007B119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "6.7L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "981A0013-8003A001-C4C0801D-FFE8A34F-EBF40000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "6.7L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "98180013-8003A001-C4C0801F-FFE8E34F-EBF40000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "6.7L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "981A0013-8003A001-C4C0801D-FFE8A34F-EBF60000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007F119-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "6.7L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "981A0013-8003A001-C4C0801D-FFE8A34F-EBF60000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007B111-FED09001-08000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "6.7L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0017-A01BA015-C4C080DD-FFE9A34F-EBF6002D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007B111-FED09001-08000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "6.7L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0017-A01BA015-C4C080DD-FFE9A34F-EBF6002D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007B111-FED09001-00000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "6.7L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0017-A01BA015-C4C080DD-FFE9A34F-EBF6002D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007B111-FED09001-08000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2020": {
        "6.7L V8 Turbo Diesel": {
          "Message": null,
          "PID": "983B0017-A01BA015-C4C080DD-FFE9A34F-EBF6002D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "7.3L V8": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2021": {
        "6.7L V8 Turbo Diesel": {
          "Message": null,
          "PID": "983B0017-A01BA015-C4C080DD-FFE9A34F-EBF6002D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "7.3L V8": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      }
    },
    "F-550": {
      "1999": {
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "BF9FB110-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2000": {
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB110-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "BF9FB110-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2001": {
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "BF9FB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2002": {
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "BF9FB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2003": {
        "6.0L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B8014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.3L V8 Turbo Diesel": {
          "Message": "Some variations of the 7.3L Powerstroke Diesel are not fully OBDII compliant<br>We advise using a scanner intended specifcally for this motor",
          "PID": "983B8014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2004": {
        "6.0L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B8014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "6.0L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0017-801BA001-C0E00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB117-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "6.0L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983A0017-801BA001-C0E00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB117-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "6.0L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983A0017-801BA001-C0E00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB117-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "6.4L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0017-A01BA015-C0CC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB117-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "6.4L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0017-A01BA015-C0CC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB917-8007A019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "6.4L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0017-A01BA015-E5CC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB917-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "6.7L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "981A2013-9003A001-C4C2801D-FFE8A34F-EAE00000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007B119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "6.7L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "981A2013-9003A001-C4C2801D-FFE8A34F-EAE00000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007B119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "6.7L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "981A0013-8003A001-C4C0801D-FFE8A34F-EBF40000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007B119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "6.7L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "981A0013-8003A001-C4C0801D-FFE8A34F-EBF40000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "6.7L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "981A0013-8003A001-C4C0801D-FFE8A34F-EBF60000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007F119-FED08001-00000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "6.7L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "981A0013-8003A001-C4C0801D-FFE8A34F-EBF60000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007B111-FED09001-08000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "6.7L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0017-A01BA015-C4C080DD-FFE9A34F-EBF6002D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007B111-FED09001-08000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "6.7L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0017-A01BA015-C4C080DD-FFE9A34F-EBF6002D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007B111-FED09001-00000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "6.7L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0017-A01BA015-C4C080DD-FFE9A34F-EBF6002D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BFDFA817-8B7FB111-FFD79001-0B660002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2020": {
        "6.7L V8 Turbo Diesel": {
          "Message": null,
          "PID": "983B0017-A01BA015-C4C080DD-FFE9A34F-EBF6002D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "7.3L V8": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2021": {
        "6.7L V8 Turbo Diesel": {
          "Message": null,
          "PID": "983B0017-A01BA015-C4C080DD-FFE9A34F-EBF6002D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "7.3L V8": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      }
    },
    "F600": {
      "2021": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "F-650": {
      "2021": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      }
    },
    "F-750": {
      "2021": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      }
    },
    "Fiesta": {
      "2011": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FB813-8007A015-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FB813-8007A015-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FB813-8007A015-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.0L I3 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.0L I3 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08001-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.0L I3 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.0L I3 Turbo": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Five Hundred": {
      "2005": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF40000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Flex": {
      "2009": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-8007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-8007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09001-00000001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-8007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-8007B119-FED0D501-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-01000001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Focus": {
      "2000": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE5FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE5FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE5FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB811-40000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FFC11-C0000001-40000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB811-40000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FFC11-C0000001-40000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB813-C017E011-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB813-C017E011-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FFC13-C017E011-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB813-C017E011-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB813-8017E011-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB813-8017E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB813-8017E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB813-8017E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB813-8017E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3FB813-8017E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2013": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-A007F011-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE1FA813-A007F011-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2014": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-A007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE1FA813-A007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2015": {
        "1.0L I3 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-A007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2016": {
        "1.0L I3 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-A007F011-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2017": {
        "1.0L I3 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-A007F011-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2018": {
        "1.0L I3 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-A007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "Freestar": {
      "2004": {
        "3.9L V6": {
          "Message": null,
          "PID": "BFBFB991-C0000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.2L V6": {
          "Message": null,
          "PID": "BFBFB991-C0000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.9L V6": {
          "Message": null,
          "PID": "BFBFB991-C0000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.2L V6": {
          "Message": null,
          "PID": "BFBFB991-C0000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.9L V6": {
          "Message": null,
          "PID": "BFBFB993-801FE019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.2L V6": {
          "Message": null,
          "PID": "BFBFB993-801FE019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.9L V6": {
          "Message": null,
          "PID": "BFBFB993-801FE019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.2L V6": {
          "Message": null,
          "PID": "BFBFB993-801FE019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Freestyle": {
      "2005": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF40000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF40000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB993-CD5FEB19-FEF40000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Fusion": {
      "2006": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB813-8017E011-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB993-C01FA019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB813-8017E011-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB993-801FE019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB813-C017E011-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB993-801FE019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB813-8017E011-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB993-8017E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFA893-8017F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFA893-8017F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFA893-8017F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED03020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08001-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED03020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08001-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08001-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED0B020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08001-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED79638-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-8017F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08001-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED0B021-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08001-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FFD08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-8017F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017B011-40840020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.0L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2018": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED0B020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.0L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-01A02001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2019": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED0B020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.0L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-01A02001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2020": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.0L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      }
    },
    "GT": {
      "2005": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB991-C0000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB911-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-01000001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2019": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-01000001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2020": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-01000001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BF9FB991-C0000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BF9FB991-C0000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      }
    },
    "Maverick": {
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-8007B011-FED0B421-61A02001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-8007B011-FED0B421-61A02001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-8007B011-FED0B421-61A02001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All Except Hybrid": {
          "Message": "This vehicle uses a new generation of OBDII - Check back soon for updated compatibility!",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3EA813-8007B011-FED0B421-61A02001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Mustang": {
      "1996": {
        "3.8L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.8L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.8L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.8L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFDFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BFDFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.8L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BFDFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.8L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BFDFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.8L V6": {
          "Message": null,
          "PID": "BF9FB991-40000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.9L V6": {
          "Message": null,
          "PID": "BFBFB991-C0000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB991-C0000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "4.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "4.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB993-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB993-801FE019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB993-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB117-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BF9FB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "4.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB993-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BF9FB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB993-801FE019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB993-C007E019-FEF00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BF9FB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "4.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB993-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BF9FB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BF9FA893-C01FF119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BF9FA893-C01FF119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.8L V8 Supercharged": {
          "Message": null,
          "PID": "BF9FA893-C01FF119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.8L V8 Supercharged": {
          "Message": null,
          "PID": "BF9FA893-C01FF119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBEA893-8007B119-FED0D000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "5.2L V8": {
          "Message": null,
          "PID": "BFDFA893-8007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2016": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA897-8007B119-FED09001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "5.2L V8": {
          "Message": null,
          "PID": "BFDFA893-8007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2017": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-8007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FFFFFFFF-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "5.2L V8": {
          "Message": null,
          "PID": "BFDFA893-8007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2018": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FA893-A007B119-FCD09501-01000001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "5.2L V8": {
          "Message": null,
          "PID": "BFDFA893-8007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2019": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD0D501-61000001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "5.2L V8": {
          "Message": null,
          "PID": "BFDFA893-8007B119-FED09501-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2020": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "5.2L V8": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2021": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "5.2L V8": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE7EA813-A007B011-FCD08405-65B02101-0004200F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE7EA813-A007B011-FCD08405-65B02101-0004200F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE7EA813-A007B011-FCD08405-65B02101-0004200F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE7EA813-A007B011-FCD08405-65B02101-0004200F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      }
    },
    "Mustang GTD": {
      "2025": {
        "5.2L V8 Supercharged": {
          "Message": "This vehicle uses a new generation of OBDII - Check back soon for updated compatibility!",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "Mustang Mach-E": {
      "2021": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2022": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2023": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2024": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2025": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      }
    },
    "Probe": {
      "1996": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "RV/Bus Chassis": {
      "1996": {
        "7.5L V8": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "7.5L V8": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "6.8L V10": {
          "Message": null,
          "PID": "BF9FB110-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "6.8L V10": {
          "Message": null,
          "PID": "BF9FB110-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "6.8L V10": {
          "Message": null,
          "PID": "BF9FB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "6.8L V10": {
          "Message": null,
          "PID": "BF9FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB117-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB117-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB117-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FB917-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007B119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007B119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007F119-FED08001-00000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007F119-FED08001-00000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007B119-FED09001-00000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007B111-FED09001-00000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007B111-FED09001-00000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "6.8L V10": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "BF9FA817-8007B111-FED09001-00000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "7.3L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "All": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Ranger": {
      "1996": {
        "2.3L I4": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB900-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB900-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "2.3L I4": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "2.5L I4": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.5L I4": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.5L I4": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "98188001-80000001-C0000020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB911-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB911-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB911-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB813-8017E011-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB813-8017E011-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB993-801FE019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB993-801FE019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB813-C017E011-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB993-801FE019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB993-801FE019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB813-8017E011-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB993-801FE019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB813-8017E011-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB993-801FE019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB813-8017E011-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB993-801FE019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FCD08405-61A02101-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FCD08405-61A02101-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FCD08405-61A02101-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FCD08405-61A02101-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Taurus": {
      "1996": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.4L V8": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "1997": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.4L V8": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "1998": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.4L V8": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "1999": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.4L V8": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFDFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFDFB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFDFB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB993-C01FA019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB993-C01FA019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB993-C01FA019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB993-C01FA019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-A00FF519-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-8007B119-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA897-8007B119-FED09001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-8007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-8007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-8007B119-FED0D000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-8007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BFBEA893-8007B119-FED0D501-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-8007B119-FED0D501-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-8007B119-FED0D501-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA897-8007B119-FED09501-09000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Taurus X": {
      "2008": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Thunderbird": {
      "1996": {
        "3.8L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.8L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.9L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.9L V8": {
          "Message": null,
          "PID": "BFBFB991-C0000001-08100000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.9L V8": {
          "Message": null,
          "PID": "BFBFB991-C0000001-08100000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.9L V8": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Transit": {
      "2015": {
        "3.2L I5 Turbo Diesel": {
          "Message": null,
          "PID": "983B0013-8003A015-C4C0801D-F8E8834F-E9F40000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA897-8007F119-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.2L I5 Turbo Diesel": {
          "Message": null,
          "PID": "983B0017-A003A001-C4C0809D-F8E9834F-EBF60000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA897-A007B119-FED09001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA897-8007B119-FED09001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2017": {
        "3.2L I5 Turbo Diesel": {
          "Message": null,
          "PID": "983B0017-A003A001-C4C0809D-F8E9834F-E2F60000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA897-A007B119-FED09001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA897-8007B119-FED09001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2018": {
        "3.2L I5 Turbo Diesel": {
          "Message": null,
          "PID": "983B0017-A003A001-C4C0809D-F8E9834F-EBF60000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA897-A007B119-FED09001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA897-8007B119-FED09001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2019": {
        "3.2L I5 Turbo Diesel": {
          "Message": null,
          "PID": "983B0017-A003A001-C4C0809D-F8E9834F-EBF60001",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA897-A007B119-FED09501-09000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA897-8007B119-FED09501-09000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2020": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "983B0017-A003A001-C4C0809D-F8E9834F-EBF60001",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2021": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "983B0017-A003A001-C4C0809D-F8E9834F-EBF60001",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBEA897-A007B119-FCD0D501-69800001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFBEA897-A007B119-FCD0D501-69800001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFBEA897-A007B119-FCD0D501-69800001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": "This vehicle uses a new generation of OBDII - Check back soon for updated compatibility!",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "Transit Connect": {
      "2010": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB813-8017E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB813-8017E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB813-8017E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB813-8017E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2017": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2018": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2019": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-A017B011-FCD0D401-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2020": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-A017B011-FCD09401-61000001-FDD4940D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-A017B011-FCD09401-61000001-FDD4940D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2021": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-A017B011-FCD09401-61000001-FDD4940D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-A017B011-FCD09401-61000001-FDD4940D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-A017B011-FCD09401-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-A017B011-FCD09401-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      }
    },
    "Windstar": {
      "1996": {
        "3.0L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.0L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.0L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.8L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.8L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.8L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    }
  },
  "Freightliner": {
    "All": {
      "1996": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "All Except Sprinter": {
      "2002": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Sprinter": {
      "2002": {
        "2.7L I5 Turbo Diesel": {
          "Message": null,
          "PID": "983B8010-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "2.7L I5 Turbo Diesel": {
          "Message": null,
          "PID": "983B2013-B001A001-40000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "2.7L I5 Turbo Diesel": {
          "Message": null,
          "PID": "983B2013-B001A001-40000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "2.7L I5 Turbo Diesel": {
          "Message": null,
          "PID": "983B2013-B001A001-40000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "2.7L I5 Turbo Diesel": {
          "Message": null,
          "PID": "983B2013-B001A001-40000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B01BA015-CCD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007B119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B01BA015-CCD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B01BA015-CCD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B003A015-CCD8001D-CF9BAB53-A2000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B003A015-CCD8001D-CF9BAB53-A2000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B003A015-CCD8001D-CF9BAB53-A2000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B003A001-CCD8801D-EFBBA353-AB200000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.1L I4 Turbo Diesel": {
          "Message": null,
          "PID": "981AA013-B001A001-C4C0801D-EFBB2143-AB200000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B003A001-CCD8801D-EFBBA353-AB200000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.1L I4 Turbo Diesel": {
          "Message": null,
          "PID": "981AA013-B001A001-C4C0801D-EFBB2143-AB200000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B003A001-CCD8801D-EFBBA353-AB200000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.1L I4 Turbo Diesel": {
          "Message": null,
          "PID": "981AA013-B001A001-C4C0801D-EFBB2143-AB200000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "981AA013-B001A001-C4C0801D-EFBB2143-AB200000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "9818A013-9003A001-C4C0801D-EFBBA343-E9A00000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "9818A013-9003A001-C4C0801D-EFBBA343-E9A00000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "9818A013-9003A001-C4CC801D-EDBBA343-E926402D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "9818A013-9003A001-C4CC801D-EDBBA343-E926402D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "9818A013-9003A001-C4CC801D-EDBBA343-E926402D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    }
  },
  "GMC": {
    "Acadia": {
      "2007": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A07FE019-FEFD0001-017D0001-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "C Series Truck": {
      "1996": {
        "6.0L V8": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "7.2L I6 Turbo Diesel": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": "BFBFB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "7.4L V8": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": "BFBFB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "6.0L V8": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": "987B0014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "8.1L V8": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": "987B0014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "8.1L V8": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": "BFBFB114-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "6.6L V8 Turbo Diesel": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": "983B0014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "8.1L V8": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": "983B0014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "6.6L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0015-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.2L I6 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0015-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "8.1L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0015-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "6.6L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0015-20000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.2L I6 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0015-20000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "8.1L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0015-20000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "6.6L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0017-A019A001-D4C28000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.8L I6 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0017-A019A001-D4C28000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "8.1L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0017-A019A001-D4C28000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "6.6L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0017-A019A001-D4C28000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.8L I6 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0017-A019A001-D4C28000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "8.1L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B0017-A019A001-D4C28000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "6.6L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B8017-A01BA015-DCD28000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.8L I6 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B8017-A01BA015-DCD28000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "8.1L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B8017-A01BA015-DCD28000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "6.6L V8 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B8017-A01BA015-DCD28000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.8L I6 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B8017-A01BA015-DCD28000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "8.1L V8": {
          "Message": "Not compatible with round 9pin connector<br>Enhanced code support listed is for bare chassis only - modifications may prevent access to some systems",
          "PID": "983B8017-A01BA015-DCD28000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Canyon": {
      "2004": {
        "2.8L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L I5": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.8L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L I5": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.8L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L I5": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.9L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.7L I5": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.9L I4": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.7L I5": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "2.9L I4": {
          "Message": null,
          "PID": "BE7FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.7L I5": {
          "Message": null,
          "PID": "BE7FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE7FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.9L I4": {
          "Message": null,
          "PID": "BE7FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.7L I5": {
          "Message": null,
          "PID": "BE7FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE7FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "2.9L I4": {
          "Message": null,
          "PID": "BE7FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.7L I5": {
          "Message": null,
          "PID": "BE7FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE7FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "2.9L I4": {
          "Message": null,
          "PID": "BE7FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L I5": {
          "Message": null,
          "PID": "BE7FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.7L I5": {
          "Message": null,
          "PID": "BE7FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE7FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.8L I4 Turbo Diesel": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.8L I4 Turbo Diesel": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.8L I4 Turbo Diesel": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.8L I4 Turbo Diesel": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.8L I4 Turbo Diesel": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.5L I4": {
          "Message": null,
          "PID": "9F1B07FF-851BBFF5-F7DB87FF-EDFB87EF-EFFF07EF",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L I4 Turbo Diesel": {
          "Message": null,
          "PID": "9F1B07FF-851BBFF5-F7DB87FF-EDFB87EF-EFFF07EF",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "9F1B07FF-851BBFF5-F7DB87FF-EDFB87EF-EFFF07EF",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Envoy": {
      "1998": {
        "4.3L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "4.3L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "4.2L I6": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "4.2L I6": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "4.2L I6": {
          "Message": null,
          "PID": "BE3EF811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3EF811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "4.2L I6": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "4.2L I6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "4.2L I6": {
          "Message": null,
          "PID": "BE3FF811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3FF811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "4.2L I6": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "4.2L I6": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Hummer EV": {
      "2022": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Jimmy": {
      "1996": {
        "4.3L V6": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFBD14-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "4.3L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFF514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFF914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Safari": {
      "1996": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFBD10-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "4.3L V6": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FC800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "4.3L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Savana": {
      "1996": {
        "4.3L V6": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "4.3L V6": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FC800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FC800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FC800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.4L V8": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FC800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "4.3L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.4L V8": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "4.3L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.4L V8": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED04001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED04001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED04001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED04001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED04001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "2.8L I4 Turbo Diesel": {
          "Message": null,
          "PID": "98390013-8003A001-C4C2800D-E9E9835F-E9300000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "98390013-8003A001-C4C2800D-E9E9835F-E9300000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "98390013-8003A001-C4C2800D-E9E9835F-E9300000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.8L I4 Turbo Diesel": {
          "Message": null,
          "PID": "98390013-8003A001-C4C2801D-E9E98343-E9B20100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.3L V6": {
          "Message": null,
          "PID": "98390013-8003A001-C4C2801D-E9E98343-E9B20100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "98390013-8003A001-C4C2801D-E9E98343-E9B20100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.8L I4 Turbo Diesel": {
          "Message": null,
          "PID": "98390013-8003A001-C4C2801D-E9E98343-E9B20100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.3L V6": {
          "Message": null,
          "PID": "98390013-8003A001-C4C2801D-E9E98343-E9B20100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "98390013-8003A001-C4C2801D-E9E98343-E9B20100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.8L I4 Turbo Diesel": {
          "Message": null,
          "PID": "98390013-8003A001-C4C2801D-E9E98343-E9F20121",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.3L V6": {
          "Message": null,
          "PID": "98390013-8003A001-C4C2801D-E9E98343-E9F20121",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "98390013-8003A001-C4C2801D-E9E98343-E9F20121",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "2.8L I4 Turbo Diesel": {
          "Message": null,
          "PID": "98390013-8003A001-C4C2801D-E9E98343-E9F20121",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.3L V6": {
          "Message": null,
          "PID": "98390013-8003A001-C4C2801D-E9E98343-E9F20121",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.6L V8": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Sierra 1500": {
      "1996": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFBD10-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFBD10-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFBD10-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFBD10-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFBD14-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFBD14-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFBD14-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2001": {
        "4.3L V6": {
          "Message": null,
          "PID": "981A0014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "981A0014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "981A0014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "981A0014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2002": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2003": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2004": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "4.8L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8 Hybrid": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8 Hybrid": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8 Hybrid": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8 Hybrid": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8 Hybrid": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED04001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED04001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED04001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED0C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED0C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED0C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED2C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED2C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED2C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED2C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED2C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED2C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED2C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED2C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED2C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.7L I4 Turbo": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L I6 Turbo Diesel": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.3L V6": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BE7FA813-A007F011-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "2.7L I4 Turbo": {
          "Message": null,
          "PID": "D8790013-B237B133-C4C2801F-EBE9835F-E9F6003F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L I6 Turbo Diesel": {
          "Message": null,
          "PID": "D8790013-B237B133-C4C2801F-EBE9835F-E9F6003F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.3L V6": {
          "Message": null,
          "PID": "D8790013-B237B133-C4C2801F-EBE9835F-E9F6003F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "D8790013-B237B133-C4C2801F-EBE9835F-E9F6003F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "D8790013-B237B133-C4C2801F-EBE9835F-E9F6003F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "2.7L I4 Turbo": {
          "Message": null,
          "PID": "98590013-8003A011-F4C0801D-EBE98343-EBF6002D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L I6 Turbo Diesel": {
          "Message": null,
          "PID": "98590013-8003A011-F4C0801D-EBE98343-EBF6002D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.3L V6": {
          "Message": null,
          "PID": "98590013-8003A011-F4C0801D-EBE98343-EBF6002D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "98590013-8003A011-F4C0801D-EBE98343-EBF6002D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "98590013-8003A011-F4C0801D-EBE98343-EBF6002D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFDFA893-A007F119-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFDFA893-A007F119-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFDFA893-A007F119-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Sierra 1500 (Vin Pos 5 Y/9/W/8)": {
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Sierra 1500 (Vin Pos 5 U/H/D/A)": {
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Sierra 1500 Classic": {
      "1999": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Sierra 1500 Limited": {
      "2018": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-61080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-61080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Sierra 2500": {
      "1996": {
        "5.0L V8": {
          "Message": null,
          "PID": "BE3FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BE3FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BE3FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.4L V8": {
          "Message": null,
          "PID": "BE3FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.4L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.4L V8": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "5.3L V8": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2001": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2002": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2003": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2004": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB114-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB114-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB114-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED2C001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED2C001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED2C001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED2C001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED2C001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED2C001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED2C001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED2C001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "6.6L V8": {
          "Message": null,
          "PID": "BFFFB993-A0AFEABB-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFFFB993-A0AFEABB-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "6.6L V8": {
          "Message": null,
          "PID": "98590013-8003A015-F4C0801D-E9E98343-EBF6012D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "98590013-8003A015-F4C0801D-E9E98343-EBF6012D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "98790017-8003A001-C4C2801D-E9E98343-E9F20121",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "98790017-8003A001-C4C2801D-E9E98343-E9F20121",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "98790017-8003A001-C4C2801D-E9E98343-E9F20121",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "98790017-8003A001-C4C2801D-E9E98343-E9F20121",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Sierra 2500 Classic": {
      "1999": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.4L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.4L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Sierra 3500": {
      "1996": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.4L V8": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.4L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.4L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "6.0L V8": {
          "Message": null,
          "PID": "987B0014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "987B0014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "987B0014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2002": {
        "6.0L V8": {
          "Message": null,
          "PID": "983B0014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "983B0014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "983B0014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2003": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2004": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB114-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB114-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB114-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED2C001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED2C001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED28001-01000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED28001-01000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "6.6L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "6.6L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Sierra EV": {
      "2024": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Sierra 3500 Classic": {
      "1999": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.4L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.4L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Sonoma": {
      "1996": {
        "2.2L I4": {
          "Message": null,
          "PID": "BFBFBD10-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFBD10-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "2.2L I4": {
          "Message": null,
          "PID": "BFBFBD14-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFBD14-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.3L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.3L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EF810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.3L V6": {
          "Message": null,
          "PID": "BE3EF810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EF810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.3L V6": {
          "Message": null,
          "PID": "BE3EF810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.3L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.3L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Suburban": {
      "1996": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.4L V8": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.4L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.4L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "7.4L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "T Series": {
      "2005": {
        "7.8L I6 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "7.8L I6 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector",
          "PID": "983B8017-A0182001-4CF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "7.8L I6 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector",
          "PID": "983B8017-A0182001-4CF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "7.8L I6 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector",
          "PID": "983B8017-A0182001-4CF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "7.8L I6 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector",
          "PID": "983B8017-A0182001-4CF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Terrain": {
      "2010": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED04001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED04001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "2.4L I4": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FF813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FF813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED08001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo Diesel": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo Diesel": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "BE7FB813-A007E011-FED28001-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE5FA813-A007F011-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Van": {
      "1996": {
        "4.3L V6": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "W Series": {
      "1998": {
        "5.7L V8": {
          "Message": "Not compatible with round 9pin connector",
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "5.7L V8": {
          "Message": "Not compatible with round 9pin connector",
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "5.7L V8": {
          "Message": "Not compatible with round 9pin connector",
          "PID": "983B0014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "5.7L V8": {
          "Message": "Not compatible with round 9pin connector",
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "5.7L V8": {
          "Message": "Not compatible with round 9pin connector",
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "5.7L V8": {
          "Message": "Not compatible with round 9pin connector",
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "5.2L I4 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector",
          "PID": "983B0015-A0182001-40E00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.0L V8": {
          "Message": "Not compatible with round 9pin connector",
          "PID": "983B0015-A0182001-40E00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "5.2L I4 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector",
          "PID": "983B0015-A0182001-40E00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.0L V8": {
          "Message": "Not compatible with round 9pin connector",
          "PID": "983B0015-A0182001-40E00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "5.2L I4 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector",
          "PID": "983B8017-A019A001-CCD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.0L V8": {
          "Message": "Not compatible with round 9pin connector",
          "PID": "983B8017-A019A001-CCD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "5.2L I4 Turbo Diesel": {
          "Message": "Not compatible with round 9pin connector",
          "PID": "983B8017-A019A001-CCD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.0L V8": {
          "Message": "Not compatible with round 9pin connector",
          "PID": "983B8017-A019A001-CCD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Yukon": {
      "1996": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2001": {
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2002": {
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2003": {
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2004": {
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "8.1L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "4.8L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8 Hybrid": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "4.8L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8 Hybrid": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8 Hybrid": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8 Hybrid": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8 Hybrid": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V8 Hybrid": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED0C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED0C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED28001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED2C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED2C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-ABDFF8BB-FED2C001-ABDEE2AB-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-ABDFF8BB-FED2C001-ABDEE2AB-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED2C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-A007E019-FED2C001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "5.3L V8": {
          "Message": null,
          "PID": "BE1B3013-80022001-44000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BE1B3013-80022001-44000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "5.3L V8": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED08001-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "98590013-8003A011-F4C0801D-EBE98343-EBF6002D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "98590013-8003A011-F4C0801D-EBE98343-EBF6002D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "98590013-8003A011-F4C0801D-EBE98343-EBF6002D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "98590013-8003A011-F4C0801D-EBE98343-EBF6002D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    }
  },
  "Genesis": {
    "G70": {
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.3L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.3L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.3L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "G80": {
      "2017": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.3L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.3L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.3L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.5L I4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007F015-FED08C05-62000001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2024": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "G90": {
      "2017": {
        "3.3L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.3L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.3L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.3L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "3.3L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "GV60": {
      "2023": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2024": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "GV70": {
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08C05-62000001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2024": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "GV80": {
      "2021": {
        "2.5L I4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08505-62000001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08505-62000001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08505-62000001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08505-62000001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    }
  },
  "Geo": {
    "Metro": {
      "1996": {
        "1.0L I3": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "1.3L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "1.0L I3": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "1.3L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Prizm": {
      "1996": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": null
        }
      },
      "1997": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": null
        }
      }
    },
    "Tracker": {
      "1996": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    }
  },
  "Hino": {
    "All": {
      "1996": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    }
  },
  "Honda": {
    "Accord": {
      "1996": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE1FA811-80001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA811-80001001-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBEA891-80001101-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA811-80001001-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBEA891-80001101-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA811-80001001-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBEA891-80001101-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Hybrid": {
          "Message": null,
          "PID": "BFBFA891-80001101-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA811-80001001-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFA891-80001101-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Hybrid": {
          "Message": null,
          "PID": "BFBFA891-80001101-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA811-80001001-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBEA891-80001101-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Hybrid": {
          "Message": null,
          "PID": "BFBFA891-80001101-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-A007F011-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-801DB011-FAD09020-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-A007F011-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-801DB011-FAD09020-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-A007F011-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-B007E011-FAD08001-00000001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-911FE019-FAD08001-00000001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3CA813-901FA011-F2C0AC21-67100001-0004004F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-B007E011-FAD08001-00000001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-911FE019-FAD08001-00000001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "B63CA813-B007E011-F2C28C01-67114001-0004000E",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3CA813-901FA011-F2C0AC21-67100001-0004004F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "B63CA813-B007E011-F2C28C01-67114001-0004000E",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3CA813-901FA011-F2C0AC21-67100001-0004004F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "B63CA813-B007E011-F2C28C01-67114001-0004000E",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "B63CA813-B007E011-F2C28C01-67114001-0004000E",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "B63CA813-B007E011-F2C28C01-67114001-0004000E",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "B63CA813-B007E011-F2C28C01-67114001-0004000E",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "B63CA813-B007E011-F2C28C01-67114001-0004000E",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "B63CA813-B007E011-F2C28C01-67114001-0004000E",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "B63CA813-B007E011-F2C28C01-67114001-0004000E",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "B43CA803-B005A001-F2C28C01-67114001-0004000E",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "B43CA803-B005A001-F2C28C01-67114001-0004000E",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "B43CA803-B005A001-F2C28C01-67114001-0004000E",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "B43CA803-B005A001-F2C28C01-67114001-0004000E",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Accord Crosstour": {
      "2010": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-00000001-A01FF119-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "CR-V": {
      "1997": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA811-80001001-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA811-80001001-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-A007F011-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-A007F011-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "B63CA813-B007A011-F2C2AC01-07114001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "B63CA813-B007E011-F2C08C01-07100001-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "B63CA813-B007A011-F2C2AC01-07114001-00000003",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "B63CA813-B007E011-F2C08C01-07100001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "B63CA813-B007A011-F2C2AC01-67114001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "B63CA813-B007A011-F2C2AC01-67114001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "B63CA813-B007A011-F2C2AC01-67114001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "B63CA813-B007A011-F2C2AC01-67114001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3CA813-A01FB011-F2C0AC21-67100001-0004004F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3CA813-A01FB011-F2C0AC21-67100001-0004004F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3CA813-A01FB011-F2C0AC21-67100001-0004004F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3CA813-A01FB011-F2C0AC21-67100001-0004004F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "CR-Z": {
      "2011": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "983A8003-801FF011-CAC00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD00020-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "98188003-801FF011-FAD08020-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "98188003-801FF011-C0000020-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-901FE011-FAD08021-00000001-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Civic": {
      "1996": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.6L I4 CNG": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.6L I4 CNG": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "1.7L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.7L I4 CNG": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "1.7L I4": {
          "Message": null,
          "PID": "BE3EB811-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.7L I4 CNG": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "1.3L I4 Hybrid": {
          "Message": null,
          "PID": "BE3EBC10-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.7L I4": {
          "Message": null,
          "PID": "BE3EB811-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.7L I4 CNG": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "1.3L I4 Hybrid": {
          "Message": null,
          "PID": "BE3EBC10-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.7L I4": {
          "Message": null,
          "PID": "BE3EA811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.7L I4 CNG": {
          "Message": null,
          "PID": "BE7EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "1.3L I4 Hybrid": {
          "Message": null,
          "PID": "BE3EAC11-80001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.7L I4": {
          "Message": null,
          "PID": "BE3EA811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.7L I4 CNG": {
          "Message": null,
          "PID": "BE7EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA811-80001001-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "1.3L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4 CNG": {
          "Message": null,
          "PID": "BE7FA813-8001B011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "1.3L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4 CNG": {
          "Message": null,
          "PID": "BE7FA813-8001B011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "1.3L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4 CNG": {
          "Message": null,
          "PID": "BE7FA813-8001B011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "1.3L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4 CNG": {
          "Message": null,
          "PID": "BE7FA813-8001B011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "1.3L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8000A001-CAC00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4 CNG": {
          "Message": null,
          "PID": "BE7FA813-8001B011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "1.3L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4 CNG": {
          "Message": null,
          "PID": "BE7FA813-8001B011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4 CNG": {
          "Message": null,
          "PID": "BE7FA813-8001B011-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD00020-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4 CNG": {
          "Message": null,
          "PID": "BE7FA813-8001B011-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "98188003-801FF011-FAD08020-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4 CNG": {
          "Message": null,
          "PID": "BE7FA813-8001B011-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD08020-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4 CNG": {
          "Message": null,
          "PID": "BE7FA813-8001B011-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "B63CA813-B007E011-F2C28C01-07114001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-9007E011-FAD08001-00000001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "B63CA813-B007E011-F2C28C01-07114001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "B63CA813-901FE011-F2C08C01-07100001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "B63CA813-9007E011-F2C08C01-07100001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "B63CA813-B007E011-F2C28C01-07114001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "B63CA813-9007E011-F2C08C01-07100001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "B63DA813-A007F011-FED08401-03014000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "B63CA813-B007E011-F2C28C01-07114001-00000003",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "B63CA813-9007E011-F2C08C01-67100001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "B63DA813-A007F011-FED08401-03014001-00000001",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "B63CA813-B007A011-F2C2AC01-67114001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "B63CA813-B007A011-F2C2AC01-67114001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "B63CA813-B007A011-F2C2AC01-67114001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": "B63CA813-B007A011-F2C2AC01-67114001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "B63CA813-B007A011-F2C2AC01-67114001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "B63CA813-B007A011-F2C2AC01-67114001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3EA811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3EA811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3EA811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3EA811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Civic Del Sol": {
      "1996": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Clarity": {
      "2017": {
        "1.5L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3CA813-901FA011-F6C0AC21-67100001-0004004F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.5L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3CA813-901FA011-F6C0AC21-67100001-0004004F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.5L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3CA813-901FA011-F6C0AC21-67100001-0004004F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "1.5L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3CA813-901FA011-F6C0AC21-67100001-0004004F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "1.5L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3CA813-901FA011-F6C0AC21-67100001-0004004F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Element": {
      "2003": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA811-80001001-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA811-80001001-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA811-80001001-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA811-80001001-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Fit": {
      "2007": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE3EA813-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE3EA813-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE3FA813-A01FF011-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.5L I4": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE3FA813-B01FE011-FAD08001-00000001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.5L I4": {
          "Message": null,
          "PID": "B63CA813-B01FE011-F2C08C01-07100001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.5L I4": {
          "Message": null,
          "PID": "B63CA813-B01FE011-F2C08C01-07100001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "1.5L I4": {
          "Message": null,
          "PID": "B63CA813-B01FE011-F2C08C01-07100001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "HR-V": {
      "2016": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.8L I4": {
          "Message": null,
          "PID": "B63CA813-901FE011-F2C08C01-07100001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.8L I4": {
          "Message": null,
          "PID": "B63CA813-901FE011-F2C08C01-07100001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.8L I4": {
          "Message": null,
          "PID": "B63CA813-901FE011-F2C08C01-07100001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "1.8L I4": {
          "Message": null,
          "PID": "B63CA813-901FE011-F2C08C01-07100001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "1.8L I4": {
          "Message": null,
          "PID": "B63CA813-901FE011-F2C08C01-07100001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "B63CA813-9007A011-F2C08C01-67100001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "B63CA813-9007A011-F2C08C01-67100001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "B63CA813-9007A011-F2C08C01-67100001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "B63CA813-9007A011-F2C08C01-67100001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Insight": {
      "2000": {
        "1.0L I3 Hybrid": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "1.0L I3 Hybrid": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "1.0L I3 Hybrid": {
          "Message": null,
          "PID": "BE3EBC10-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "1.0L I3 Hybrid": {
          "Message": null,
          "PID": "BE3EBC10-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "1.0L I3 Hybrid": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "1.0L I3 Hybrid": {
          "Message": null,
          "PID": "BE3EA811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "1.0L I3 Hybrid": {
          "Message": null,
          "PID": "BE3EA811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "1.3L I4 Hybrid": {
          "Message": null,
          "PID": "983A8001-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "1.3L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "1.3L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.3L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.3L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3CA813-901FA011-F2C0AC21-67100001-0004004F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3CA813-901FA011-F2C0AC21-67100001-0004004F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3CA813-901FA011-F2C0AC21-67100001-0004004F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3CA813-901FA011-F2C0AC21-67100001-0004004F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Odyssey": {
      "1996": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FA811-10001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA891-80001101-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA891-80001101-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-801DB011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-801FF119-FAC08F01-07100001-07100001",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBCA893-B11FE019-FAC08F01-07100001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.5L V6": {
          "Message": null,
          "PID": "B7BCA893-B11FE019-F2C08F01-07100001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBCA893-B11FE019-FAC08F01-07100001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBCA893-B11FE019-FAC08F01-07100001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBEA891-80001101-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFBEA891-80001101-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFBEA891-80001101-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFBEA891-80001101-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Passport": {
      "1996": {
        "2.6L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBCA893-B11FE019-FAC08F01-67100001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBCA893-B11FE019-FAC08F01-67100001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBCA893-B11FE019-FAC08F01-67100001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBCA893-B11FA019-FAC08F01-67100001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFBCA893-B11FA019-FAC08F01-67100001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFBCA893-B11FA019-FAC08F01-67100001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": "This vehicle uses a new generation of OBDII - Check back soon for updated compatibility!",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "Pilot": {
      "2003": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA891-80001101-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA891-80001101-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA891-80001101-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA891-80001101-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-A01FF119-FAD08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-B11FE019-FAD08001-00000001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBCA893-B11FE019-FAC08F01-07100001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.5L V6": {
          "Message": null,
          "PID": "B7BCA893-B11FE019-F2C08F01-67100001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBCA893-B11FE019-FAC08F01-67100001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBCA893-B11FE019-FAC08F01-67100001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "B79DA893-A007F119-FAD08F01-63100001-0204000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "B79DA893-A007F119-FAD08F01-63100001-0204000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "B79DA893-A007F119-FAD08F01-63100001-0204000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "B79DA893-A007F119-FAD08F01-63100001-0204000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Prelude": {
      "1996": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.3L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Prologue": {
      "2024": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Ridgeline": {
      "2006": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA891-80001101-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA891-80001101-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA891-80001101-08000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-801FF119-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFA893-B11FE019-FAD08001-00000001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.5L V6": {
          "Message": null,
          "PID": "B7BCA893-B11FE019-F2C08F01-07100001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.5L V6": {
          "Message": null,
          "PID": "B7BCA893-B11FE019-F2C08F01-07100001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBCA893-B11FE019-FAC08F01-07100001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBCA893-B11FE019-FAC08F01-07100001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBCA893-B11FA019-FAC08F01-67100001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFBCA893-B11FA019-FAC08F01-67100001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFBCA893-B11FA019-FAC08F01-67100001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFBCA893-B11FA019-FAC08F01-67100001-0004000F",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "S2000": {
      "2000": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FAD00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    }
  },
  "Hummer": {
    "H1": {
      "2001": {
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "981A0014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "981A0014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "981A0014-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "D83B8013-8019A001-C4CC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "6.5L V8 Turbo Diesel": {
          "Message": null,
          "PID": "D83B8013-8019A001-C4CC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.6L V8 Turbo Diesel": {
          "Message": null,
          "PID": "D83B8013-8019A001-C4CC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "H2": {
      "2003": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2004": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "6.2L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFB993-8007E019-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "H3": {
      "2006": {
        "3.5L I5": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.7L I5": {
          "Message": null,
          "PID": "BE3FF811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.7L I5": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.7L I5": {
          "Message": null,
          "PID": "BE7FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE7FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "3.7L I5": {
          "Message": null,
          "PID": "BE7FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE7FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    }
  },
  "Hyundai": {
    "Accent": {
      "1996": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FB811-F8000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FB811-F8000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FC800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FC800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FC800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FC800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FEDC8C01-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3FA813-801FF011-FEDC8C01-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Azera": {
      "2006": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "3.3L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "3.3L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-A207E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.3L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "3.3L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "3.3L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "3.3L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.3L V6": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.3L V6": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.3L V6": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.3L V6": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Elantra": {
      "1996": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "2.0L I4": {
          "Message": null,
          "PID": "881A8000-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E015-FC0C0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E015-FC0C0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E015-FC0C0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E015-FC0C0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C01-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C01-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "1.6L I4 Hybrid": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "B63FA813-801FF011-FED08C05-62000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "B63FA813-801FF011-FED08C05-62000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "B63FA813-801FF011-FED08C05-62000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "B63FA813-801FF011-FED08C05-62000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Elantra Coupe": {
      "2013": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Elantra N": {
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Elantra Touring/GT": {
      "2009": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E015-FC0C0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E015-FC0C0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E015-FC0C0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C01-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C01-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C01-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Entourage": {
      "2007": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-A207E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Equus": {
      "2011": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBEB993-80018001-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Genesis": {
      "2009": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Genesis Coupe": {
      "2010": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EB813-8007E015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EB813-8007E015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Ioniq": {
      "2017": {
        "1.6L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-801FF015-FEDC8CA0-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3FA813-801FF015-FEDC8CA0-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2018": {
        "1.6L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-801FF015-FEDC8CA0-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-801FF015-FEDC8CA0-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3FA813-801FF015-FEDC8CA0-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2019": {
        "1.6L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-801FF015-FEDC8CA1-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-801FF015-FEDC8CA1-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3FA813-801FF015-FEDC8CA1-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2020": {
        "1.6L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-801FF015-FEDC8CA1-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-801FF015-FEDC8CA1-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3FA813-801FF015-FEDC8CA1-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2021": {
        "1.6L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-801FF015-FEDC8CA1-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-801FF015-FEDC8CA1-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2022": {
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "Ioniq 5": {
      "2022": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2023": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2024": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "Ioniq 6": {
      "2023": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2024": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "Kona": {
      "2018": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C01-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2020": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C01-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3EA813-A007F011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2021": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3EA813-A007F011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2022": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3EA813-A007F011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2023": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3EA813-A007F011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2024": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Palisade": {
      "2020": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Santa Cruz": {
      "2022": {
        "All": {
          "Message": null,
          "PID": "B63DA813-A01FF011-FED08C05-63000001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "B63DA813-A01FF011-FED08C05-63000001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "B63DA813-A01FF011-FED08C05-63000001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "B63DA813-A01FF011-FED08C05-63000001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Santa Fe": {
      "2001": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "2.4L I4": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "2.7L V6": {
          "Message": null,
          "PID": "BF9FB991-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BF9FB991-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "2.7L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "2.7L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.5L I4": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "B63EA813-A007F011-FED08C05-62000001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "B63EA813-A007F011-FED08C05-62000001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "B63EA813-A007F011-FED08C05-62000001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "B63EA813-A007F011-FED08C05-62000001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Sonata": {
      "1996": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3DB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE3DB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BE1FB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-00DC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4 Hybrid": {
          "Message": null,
          "PID": "BE3EA813-8007B015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4 Hybrid": {
          "Message": null,
          "PID": "BE3EA813-8007B015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4 Hybrid": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4 Hybrid": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C20-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4 Hybrid": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C20-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-801FB015-FEDCBCA0-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-801FB015-FEDCBCA0-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-801FF015-FEDC8CA0-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3EA813-801FF015-FEDC8CA1-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3EA813-801FF015-FEDC8CA1-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3EA813-801FF015-FEDC8CA1-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3EA813-801FF015-FEDC8CA1-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "B63EA813-A007F011-FED08C05-62000001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "B63EA813-A007F011-FED08C05-62000001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "B63EA813-A007F011-FED08C05-62000001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "B63EA813-A007F011-FED08C05-62000001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Tiburon": {
      "1997": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E015-FC0C0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE1FA813-9007E015-FC0C0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB813-8007E015-FC0C0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E01F-FC0C0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Tucson": {
      "2005": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB813-8007E015-FC0C0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE1FB813-8007E015-FC0C0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E015-FC0C0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E01F-FC0C0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E015-FC0C0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E01F-FC0C0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-00DC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "B63FA813-A01FB011-FED0AC21-62200001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "B63FA813-A01FB011-FED0AC21-62200001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "B63FA813-A01FB011-FED0AC21-62200001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "B63FA813-A01FB011-FED0AC21-62200001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Veloster": {
      "2012": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C01-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C01-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Venue": {
      "2020": {
        "1.6L I4": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "1.6L I4": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Veracruz": {
      "2007": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-A207E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "XG300": {
      "2001": {
        "3.0L V6": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "XG350": {
      "2002": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    }
  },
  "Ineos": {
    "Grenadier": {
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08415-63000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08415-63000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08415-63000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    }
  },
  "Infiniti": {
    "EX35": {
      "2008": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9EA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9EA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9EA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "EX37": {
      "2013": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "FX35": {
      "2003": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9EA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9EA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9EA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "FX37": {
      "2013": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "FX45": {
      "2003": {
        "4.5L V8": {
          "Message": null,
          "PID": "BF9FA891-80001101-40000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "4.5L V8": {
          "Message": null,
          "PID": "BF9FA891-80001101-40000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "4.5L V8": {
          "Message": null,
          "PID": "BF9FA891-80001101-40000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "4.5L V8": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "4.5L V8": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "4.5L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "FX50": {
      "2009": {
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFFEA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFFEA893-9157E019-FADC8001-04500000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFFEA893-9157E019-FADC8001-04500000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "G20": {
      "1996": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "G25": {
      "2011": {
        "2.5L V6": {
          "Message": null,
          "PID": "BF9EA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "2.5L V6": {
          "Message": null,
          "PID": "BF9EA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "G35 Coupe": {
      "2003": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "G35 Sedan": {
      "2003": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "G37 Coupe": {
      "2008": {
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "G37 Sedan": {
      "2009": {
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "I30": {
      "1996": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "I35": {
      "2002": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "J30": {
      "1996": {
        "3.0L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "JX35": {
      "2013": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "M35": {
      "2006": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9EA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BF9EA893-9107E019-FADC0021-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BF9EA893-9107E019-FADC0021-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "M37": {
      "2011": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "M45": {
      "2003": {
        "4.5L V8": {
          "Message": null,
          "PID": "BF9FA891-80001101-40000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "4.5L V8": {
          "Message": null,
          "PID": "BF9FA891-80001101-40000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "4.5L V8": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "4.5L V8": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "4.5L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "4.5L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "4.5L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "M56": {
      "2011": {
        "5.6L V8": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FADC8001-04080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "5.6L V8": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FADC8001-04080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Q40": {
      "2015": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Q45": {
      "1996": {
        "4.5L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "4.1L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "4.1L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "4.1L V8": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "4.1L V8": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "4.1L V8": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "4.5L V8": {
          "Message": null,
          "PID": "BF9FA891-80001101-40000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "4.5L V8": {
          "Message": null,
          "PID": "BF9FA891-80001101-40000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "4.5L V8": {
          "Message": null,
          "PID": "BF9FA891-80001101-40000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "4.5L V8": {
          "Message": null,
          "PID": "BF9FA891-80001101-40000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "4.5L V8": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Q50": {
      "2014": {
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BF9EA893-9107E019-FADC0021-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BF9EA893-9107E019-FADC0021-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "BFBCA893-9107E019-FED88001-05088000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BF9EA893-9107E019-FADC0021-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "BFFFFFFF-91FFFFFF-FFFFFFFF-15FFFFFF-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BF9EA893-9107E019-FADC0021-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "BFBCA893-9107E019-FED88001-05088000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BF9EA893-9107E019-FADC0021-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "BFBCA893-9107E019-FED88001-65088001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "BFBCA893-9107E019-FED88001-65088001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "BFBCA893-9107E019-FED88001-65088001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBCA893-9107E019-FED88001-65088001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFBCA893-9107E019-FED88001-65088001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFBCA893-9107E019-FED88001-65088001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Q60": {
      "2014": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "BFBCA893-9107E019-FED88001-05088000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "BFBCA893-9107E019-FED88001-05088000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "BFBCA893-9107E019-FED88001-65088001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "BFBCA893-9107E019-FED88001-65088001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BFBCA893-9107E019-FED88001-65089001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBCA893-9107E019-FED88001-65089001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Q70": {
      "2014": {
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BF9EA893-9107E019-FADC0021-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BF9EA893-9107E019-FADC0021-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.6L V8": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FADC8001-04080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BF9EA893-9107E019-FADC0021-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E059-FFFFFFFF-FFFFFFFF-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.6L V8": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FED88001-04080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BF9EA893-9107E019-FADC0021-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FED88001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-00080180-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BF9EA893-9107E019-FADC0021-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FED88001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-00080180-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FED88001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "QX30": {
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "QX4": {
      "1997": {
        "3.3L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.3L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.3L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "QX50": {
      "2014": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FEDC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FED88001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BE3DA813-9007E011-FED88001-61088001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3DA813-9007E011-FED88001-61088001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3DA813-9007E011-FED88001-61088001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3DA813-9007E011-FED88001-61088001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3DA813-9007E011-FED88001-61088001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "QX55": {
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3DA813-9007E011-FED88001-61088001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3DA813-9007E011-FED88001-61088001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3DA813-9007E011-FED88001-61088001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3DA813-9007E011-FED88001-61088001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "QX56": {
      "2004": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "5.6L V8": {
          "Message": null,
          "PID": "BFBFA893-9107E019-FADC8001-00080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "5.6L V8": {
          "Message": null,
          "PID": "BFBFA893-9107E019-FADC8001-00080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "QX60": {
      "2014": {
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC0021-01080100-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC0021-01080100-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC0021-01080100-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC0021-01080100-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FEDC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-00080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FEDC8001-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88041-60080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88041-60080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88041-60080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88041-60080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "QX70": {
      "2014": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFFEA893-9157E019-FADC8001-04500000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FEDC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FED88001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "QX80": {
      "2014": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "5.6L V8": {
          "Message": null,
          "PID": "BFBFA893-9107E019-FADC8001-00080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-00080180-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-00080180-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-00080180-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-60080181-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-60080181-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-60080181-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-60080181-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-60080181-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-60080181-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    }
  },
  "International": {
    "All": {
      "1996": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    }
  },
  "Isuzu": {
    "Amigo": {
      "1998": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Ascender": {
      "2003": {
        "4.2L I6": {
          "Message": null,
          "PID": "BE3EB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3EB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "4.2L I6": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "4.2L I6": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "4.2L I6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "4.2L I6": {
          "Message": null,
          "PID": "BE3FF811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "4.2L I6": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Axiom": {
      "2002": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FF811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Hombre": {
      "1996": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.3L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.3L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.3L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.3L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Oasis": {
      "1996": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Rodeo": {
      "1996": {
        "2.6L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "2.6L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Trooper": {
      "1996": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Vehicross": {
      "1999": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    }
  },
  "Jaguar": {
    "E-Pace": {
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED38451-03010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED38451-03010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED08441-63000001-00040009",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED08441-63000001-00040009",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED08441-63000001-00040009",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED08441-63000001-00040009",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "F-Pace": {
      "2017": {
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "9EBBA013-A6ABB001-E6E9805D-EFB98343-AFABC000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "9EBBA013-A6ABB001-E6E9805D-EFB98343-AFABC000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED38451-03010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED38451-03010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED38451-03010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED38451-03010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED38451-03010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED38451-03010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED38451-03010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED38451-03010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED38451-03010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED38451-03010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED38451-03010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED38451-03010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "F-Type": {
      "2014": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED0C540-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED0C540-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED0C540-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED0C540-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED08551-07010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED08551-07010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED08551-07010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED08551-07010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED38451-03010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED38451-03010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED38451-03010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED38551-07010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED38551-07010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED38551-07010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBFACD3-A007B11F-FED08541-67000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFBFACD3-A007B11F-FED08541-67000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFBFACD3-A007B11F-FED08541-67000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "I-Pace": {
      "2019": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2020": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2021": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2022": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2023": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2024": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "S-Type": {
      "2000": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FA891-00001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FA891-00001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFDFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L V8": {
          "Message": null,
          "PID": "BFDFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFDFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L V8": {
          "Message": null,
          "PID": "BFDFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFFFA891-80001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BFFFA891-80001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "3.0L V6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.2L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFFFA891-80001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BFFFA891-80001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFFFE893-8007B101-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007B101-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFFFA891-80001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BFFFA891-80001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFFA891-80001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFFFE893-801FB101-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BFFFE893-801FB101-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "X-Type": {
      "2002": {
        "2.5L V6": {
          "Message": null,
          "PID": "BFFFA891-80001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFFFA891-80001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "2.5L V6": {
          "Message": null,
          "PID": "BFFFA891-80001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFFFA891-80001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "2.5L V6": {
          "Message": null,
          "PID": "BFFFA891-80001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFFFA891-80001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "2.5L V6": {
          "Message": null,
          "PID": "BFFFA891-80001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFFFA891-80001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BFFFA891-80001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFFFA891-80001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFFFA891-80001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFFFA893-8007F101-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "XE": {
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FEDF8441-03010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FEDF8441-03010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FEDF8441-03010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED38441-03010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED38441-03010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED38441-03010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "XF": {
      "2009": {
        "4.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8017B101-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFFE893-8017B101-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "4.2L V8": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F40-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F40-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F40-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F40-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F40-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F40-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F40-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED30440-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED30440-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED30440-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED0C540-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED0C540-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED0C540-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED08551-07010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED08551-07010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED08551-07010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED08551-07010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-A003B001-E4C8805D-EBB98343-A9224000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "983BA013-A003B001-E4C8805D-EBB98343-A9224000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "983BA013-A003B001-E4C8805D-EBB98343-A9224000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-A003B001-E4C8805D-EBB98343-A9224000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "983BA013-A003B001-E4C8805D-EBB98343-A9224000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "983AA013-A003B001-E4C8805D-EEB98343-2922400C",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "983AA013-A003B001-E4C8805D-EEB98343-2922400C",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "983AA013-A003B001-E4C8805D-EEB98343-2922400C",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "983AA013-A003B001-E4C8805D-EEB98343-2922400C",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "XJ": {
      "1996": {
        "4.0L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L I6 Supercharged": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.0L V12": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "4.0L I6": {
          "Message": null,
          "PID": "E3EB8118-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L I6 Supercharged": {
          "Message": null,
          "PID": "E3EB8118-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FB991-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L V8 Supercharged": {
          "Message": null,
          "PID": "BF9FB991-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FB991-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L V8 Supercharged": {
          "Message": null,
          "PID": "BF9FB991-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FA891-00001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L V8 Supercharged": {
          "Message": null,
          "PID": "BF9FA891-00001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FA891-00001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L V8 Supercharged": {
          "Message": null,
          "PID": "BF9FA891-00001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FA891-00001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FA891-00001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "4.2L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.2L V8 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "4.2L V8": {
          "Message": null,
          "PID": "BFFFA891-80001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFFA891-80001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "4.2L V8": {
          "Message": null,
          "PID": "BFFFE893-801FB101-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFFE893-801FB101-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "4.2L V8": {
          "Message": null,
          "PID": "BFFFE893-801FB101-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFFE893-801FB101-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "4.2L V8": {
          "Message": null,
          "PID": "BFFFE893-801FB101-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFFE893-801FB101-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "4.2L V8": {
          "Message": null,
          "PID": "BFFFA893-801FB101-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F40-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F40-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F40-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F40-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F40-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F40-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED0C540-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED0C540-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED0C540-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED0C540-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED0C540-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED0C540-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED0C540-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED08551-07010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED08551-07010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED08551-07010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED08551-07010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED38551-07010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED38551-07010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "XK": {
      "1997": {
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FB991-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FB991-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FA891-00001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FA891-00001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L V8 Supercharged": {
          "Message": null,
          "PID": "BF9FA891-00001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FA891-00001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L V8 Supercharged": {
          "Message": null,
          "PID": "BF9FA891-00001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FA891-00001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L V8 Supercharged": {
          "Message": null,
          "PID": "BF9FA891-00001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "4.2L V8": {
          "Message": null,
          "PID": "BFFFA891-80001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFFA891-80001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "4.2L V8": {
          "Message": null,
          "PID": "BFFFA891-80001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFFA891-80001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "4.2L V8": {
          "Message": null,
          "PID": "BFFFA891-80001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFFA891-80001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "4.2L V8": {
          "Message": null,
          "PID": "BFFFA891-80001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFFA891-80001101-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "4.2L V8": {
          "Message": null,
          "PID": "BFFFE893-801FB101-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFFE893-801FB101-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "4.2L V8": {
          "Message": null,
          "PID": "BFFFE893-801FB101-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFFE893-801FB101-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "4.2L V8": {
          "Message": null,
          "PID": "BFFFE893-801FB101-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFFE893-801FB101-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F40-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F40-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F40-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F40-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F40-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F40-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED0C540-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED0C540-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED0C540-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F40-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F40-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "5.0L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    }
  },
  "Jeep": {
    "Cherokee": {
      "1996": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L I6": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L I6": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L I6": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L I6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L I6": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "4.0L I6": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7EA813-801FF011-FED28001-01280200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": false,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": false,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": false,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": false,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": false,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": false,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": false,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": false,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": false,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE7EA813-8007F011-FED08005-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": false,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE7EA813-8007F011-FED08005-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": false,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Commander": {
      "2006": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Compass": {
      "2007": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08001-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08001-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE7EA813-801FF011-FED28005-61280201-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE7EA813-801FF011-FED28005-61280201-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE7EA813-801FF011-FED28005-61280201-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Gladiator": {
      "2020": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFEB993-801FE019-FED08001-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFFEB993-801FE019-FED08001-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFFEB993-801FE019-FED08005-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFFEB993-801FE019-FED08005-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFFEB993-801FE019-FED08005-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFFEB993-801FE019-FED08005-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Grand Cherokee": {
      "1996": {
        "4.0L I6": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.2L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "4.0L I6": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.2L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "4.0L I6": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.2L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.9L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "4.0L I6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "4.0L I6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "4.0L I6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "4.0L I6": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "4.0L I6": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "4.0L I6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983B2013-B001A001-40000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.1L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B003A011-44D00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.1L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B003A011-44D00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.1L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983B2013-B001A015-40000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.1L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.1L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B01BA011-C8D300CD-EFFFFFF3-EE000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B01BA011-C8D300CD-EFFFFFF3-EE000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "98392013-9001A011-C4C2801D-C9EBA343-80220000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "98392013-9001A011-C4C2801D-E9EBA343-E9220000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "98392013-9001A011-C4C2801D-E9EBA343-E9A20000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-00200000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-00200000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "98392013-9001A011-C4C2801D-C9EBA343-80220000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-00200000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "98392013-9001A011-C4C2801D-E9EBA343-E9A20000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-00200000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFEA893-8007B119-FED08001-01000200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFEA893-8007F119-FED08001-01000200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BE3DB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFFEB993-801FE019-FED08005-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFFEB993-801FE019-FED08005-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFFEB993-801FE019-FED08005-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFFEB993-801FE019-FED08005-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Grand Wagoneer": {
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFFFA893-A007F119-FED28551-610B0001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFFFA893-A007F119-FED28551-610B0001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFFFA893-A007F119-FED28551-610B0001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFFFA893-A007F119-FED28551-610B0001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Liberty": {
      "2002": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3CB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L I4 Turbo Diesel": {
          "Message": "Enhanced diagnostics available for gas models only",
          "PID": "983B8011-A0000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.8L I4 Turbo Diesel": {
          "Message": "Enhanced diagnostics available for gas models only",
          "PID": "983B8011-A0000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "2.8L I4 Turbo Diesel": {
          "Message": "Enhanced diagnostics available for gas models only",
          "PID": "983B8011-A0000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Patriot": {
      "2007": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007A011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Renegade": {
      "2015": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "1.3L I4 Turbo": {
          "Message": null,
          "PID": "BE7EA813-8007F011-FED28001-01080200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "1.3L I4 Turbo": {
          "Message": null,
          "PID": "BE7EA813-8007F011-FED28001-01080200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE7EA813-8007F011-FED28001-01080200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "1.3L I4 Turbo": {
          "Message": null,
          "PID": "BE7EA813-8007F011-FED28001-01080200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE7EA813-8007F011-FED28001-01080200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE7EA813-8007F011-FED28005-61080201-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE7EA813-8007F011-FED28005-61080201-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Wagoneer": {
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFFFA893-A01FF119-FED28551-616B0001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFFFA893-A01FF119-FED28551-616B0001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFFFA893-A01FF119-FED28551-616B0001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFFFA893-A01FF119-FED28551-616B0001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Wrangler": {
      "1997": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L I6": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L I6": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L I6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L I6": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L I6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L I6": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.4L I4": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L I6": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L I6": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L I6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L I6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08005-00000002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7EA813-801FF011-FED28021-01280201-00000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFFEB993-801FA019-FED08001-00200000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo (includes eTorque)": {
          "Message": null,
          "PID": "BE7EA813-801FF011-FED28021-01280201-00000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFFEB993-801FE019-FED08001-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo (includes eTorque)": {
          "Message": null,
          "PID": "BE7EA813-801FF011-FED28001-61280201-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "BE7EA813-801FF011-FED28001-61280201-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6 (includes eTorque)": {
          "Message": null,
          "PID": "BFFEB993-801FE019-FED08001-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE7EA813-801FF011-FED28021-01280201-00000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "BE7EA813-801FF011-FED28001-61280201-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6 (includes eTorque)": {
          "Message": null,
          "PID": "BE7EA813-801FF011-FED28001-61280201-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFFEB993-801FE019-FED08005-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFFEB993-801FE019-FED08005-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFFEB993-801FE019-FED08005-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFFEB993-801FE019-FED08005-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Wrangler JK": {
      "2018": {
        "3.6L V6": {
          "Message": "Previous generation Wrangler sold alongside the JL model for 2018 model year",
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    }
  },
  "Karma": {
    "GS-6": {
      "2021": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Revero": {
      "2018": {
        "2.0L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "2.0L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "2.0L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Revero GT": {
      "2020": {
        "1.5L I3 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "1.5L I3 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "1.5L I3 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "1.5L I3 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    }
  },
  "Kenworth": {
    "All": {
      "1996": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    }
  },
  "Kia": {
    "Amanti": {
      "2004": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-A207E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Borrego": {
      "2009": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "3.8L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "All": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Cadenza": {
      "2014": {
        "3.3L V6": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.3L V6": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.3L V6": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.3L V6": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.3L V6": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Carnival": {
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBFA893-A007F119-FED38505-63800001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFBFA893-A007F119-FED38505-63800001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFBFA893-A007F119-FED38505-63800001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFBFA893-A007F119-FED38505-63800001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "EV6": {
      "2022": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2023": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2024": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "EV9": {
      "2024": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "Forte": {
      "2010": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E015-FC0C0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-00DC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-801FF015-FEDC8C01-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-801FF015-FEDC8C01-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-801FF015-FEDC8C01-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-801FF015-FEDC8C01-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-801FF015-FEDC8C01-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08C01-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08C01-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08C01-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "K4": {
      "2025": {
        "All": {
          "Message": null,
          "PID": "B63FA813-801FF011-FED08C05-62000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "K5": {
      "2021": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "B63DA813-A01FF011-FED08C05-63000001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "B63DA813-A01FF011-FED08C05-63000001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "B63DA813-A01FF011-FED08C05-63000001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "B63DA813-A01FF011-FED08C05-63000001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "K900": {
      "2015": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.3L V6": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Niro": {
      "2017": {
        "1.6L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-801FF015-FEDC8CA0-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.6L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-801FF015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-801FF015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.6L I4 Hybrid": {
          "Message": null,
          "PID": "BE3EA813-801FF015-FEDC8CA1-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3EA813-801FF015-FEDC8CA1-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3EA813-801FF015-FEDC8CA1-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2020": {
        "1.6L I4 Hybrid": {
          "Message": null,
          "PID": "BE3EA813-801FF015-FEDC8CA1-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3EA813-801FF015-FEDC8CA1-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3EA813-801FF015-FEDC8CA1-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2021": {
        "1.6L I4 Hybrid": {
          "Message": null,
          "PID": "BE3EA813-801FF015-FEDC8CA1-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3EA813-801FF015-FEDC8CA1-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3EA813-801FF015-FEDC8CA1-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2022": {
        "1.6L I4 Hybrid": {
          "Message": null,
          "PID": "BE3EA813-801FF015-FEDC8CA1-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3EA813-801FF015-FEDC8CA1-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3EA813-801FF015-FEDC8CA1-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2023": {
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2024": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Optima": {
      "2001": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E01F-FC0C0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-00DC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4 Hybrid": {
          "Message": null,
          "PID": "BE3EA813-8007B015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4 Hybrid": {
          "Message": null,
          "PID": "BE3EA813-8007B015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4 Hybrid": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4 Hybrid": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C20-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4 Hybrid": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C20-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4 Hybrid": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C20-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-801FB015-FEDCBCA0-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-801FF015-FEDC8CA0-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3EA813-801FF015-FEDC8CA1-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-801FF015-FEDC8CA1-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3EA813-801FF015-FEDC8CA1-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-801FF015-FEDC8CA1-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Rio": {
      "2001": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FC800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FC800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FC800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FC800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Rondo": {
      "2007": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E01F-FC0C0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E01F-FC0C0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E01F-FC0C0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-00DC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E01F-FC0C0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Sedona": {
      "2002": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-A207E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "3.3L V6": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.3L V6": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.3L V6": {
          "Message": null,
          "PID": "BFFFB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.3L V6": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.3L V6": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.3L V6": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "3.3L V6": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Seltos": {
      "2021": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C01-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C01-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C01-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C01-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Sephia": {
      "1996": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Sorento": {
      "2003": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "3.3L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-A207E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.3L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BFBEB993-A007E019-FED08F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "1.6L I4 Hybrid": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "B63EA813-A007F011-FED08C05-62000001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "B63EA813-A007F011-FED08C05-62000001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "B63EA813-A007F011-FED08C05-62000001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "B63EA813-A007F011-FED08C05-62000001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Soul": {
      "2010": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E015-FC0C0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FC800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EABB3-F007FFF1-FED2A770-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2016": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2017": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2018": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2019": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C01-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2020": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C01-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3EA813-A007F011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2021": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3EA813-A007F011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2022": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3EA813-A007F011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2023": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3EA813-A007F011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08C05-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-8007F011-FED08C05-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Spectra": {
      "2000": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "1.8L I4": {
          "Message": null,
          "PID": "BFDFB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E015-FC0C0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E015-FC0C0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E015-FC0C0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Sportage": {
      "1996": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3DB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB813-8007E015-FC0C0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE1FB813-8007E015-FC0C0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E015-FC0C0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE3EB813-8007E015-FC0C0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E015-FC0C0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L V6": {
          "Message": null,
          "PID": "BE3EB813-8007E015-FC0C0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC0C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "B63FA813-A01FB011-FED0AC21-62200001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "B63FA813-A01FB011-FED0AC21-62200001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "B63FA813-A01FB011-FED0AC21-62200001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "B63FA813-A01FB011-FED0AC21-62200001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Stinger": {
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.3L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.3L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.3L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.3L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007F015-FEDC8C81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Telluride": {
      "2020": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-8007F11F-FEDC8F81-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    }
  },
  "Lamborghini": {
    "Aventador": {
      "2012": {
        "6.5L V12": {
          "Message": null,
          "PID": "BFBEE897-9107A001-F8800000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "6.5L V12": {
          "Message": null,
          "PID": "BFBEE897-9107A001-F8800000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "6.5L V12": {
          "Message": null,
          "PID": "BFBEE897-9107A001-F8800000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "6.5L V12": {
          "Message": null,
          "PID": "BFBEE897-9107A001-F8800000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "6.5L V12": {
          "Message": null,
          "PID": "BFBEE897-9107A001-F8800000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "6.5L V12": {
          "Message": null,
          "PID": "BFBEE897-9107A001-F8800000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "6.5L V12": {
          "Message": null,
          "PID": "BFBECABB-9547A01F-FC808511-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "6.5L V12": {
          "Message": null,
          "PID": "BFBECABB-9547A01F-FC808511-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "6.5L V12": {
          "Message": null,
          "PID": "BFBECABB-9547A01F-FC808511-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "6.5L V12": {
          "Message": null,
          "PID": "BFBECABB-9547A01F-FC808511-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBECABB-9547A01F-FC808511-01000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Diablo": {
      "1996": {
        "5.7L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "5.7L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "5.7L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "5.7L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "6.0L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Gallardo": {
      "2004": {
        "5.0L V10": {
          "Message": null,
          "PID": "BFBEF991-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "5.0L V10": {
          "Message": null,
          "PID": "BFBEF991-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "5.0L V10": {
          "Message": null,
          "PID": "BFBEE891-91000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "5.0L V10": {
          "Message": null,
          "PID": "BFBEE891-91000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "5.0L V10": {
          "Message": null,
          "PID": "BFBEE891-91000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "5.2L V10": {
          "Message": null,
          "PID": "BF9FCABB-A005B559-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "5.2L V10": {
          "Message": null,
          "PID": "BF9FE893-A005B119-FED08500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "5.2L V10": {
          "Message": null,
          "PID": "BF9FE893-A005B119-FED08500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "5.2L V10": {
          "Message": null,
          "PID": "BF9FE893-A005B119-FED08500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "5.2L V10": {
          "Message": null,
          "PID": "BF9FE893-A005B119-FED08500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "5.2L V10": {
          "Message": null,
          "PID": "BF9FE893-A005B119-FED08500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Huracan": {
      "2015": {
        "5.2L V10": {
          "Message": null,
          "PID": "BF9EE893-8007B119-F7C08501-06180001-00080002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "5.2L V10": {
          "Message": null,
          "PID": "BE1EE813-8007B011-F6C08401-06180001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "5.2L V10": {
          "Message": null,
          "PID": "BE1EE813-8007B011-F6C08401-06180001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "5.2L V10": {
          "Message": null,
          "PID": "BE1EE813-8007B011-F6C08401-06180001-00000002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "5.2L V10": {
          "Message": null,
          "PID": "BF9EE893-8007B119-F7C08501-06180001-00080002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "5.2L V10": {
          "Message": null,
          "PID": "BF9EE893-8007B119-F7C08501-06180001-00080002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "5.2L V10": {
          "Message": null,
          "PID": "BF9EE893-8007B119-F7C08501-06180001-00080002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BF9EE893-8007B119-F7C08501-06180001-00080002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BF9EE893-8007B119-F7C08501-06180001-00080002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BF9EE893-8007B119-F7C08501-06180001-00080002",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Murcielago": {
      "2002": {
        "6.2L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "6.2L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "6.2L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "6.2L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "6.2L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "6.5L V12": {
          "Message": null,
          "PID": "BFBEE897-9107A001-F8800000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "6.5L V12": {
          "Message": null,
          "PID": "BFBEE897-9107A001-F8800000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "6.5L V12": {
          "Message": null,
          "PID": "BFBEE897-9107A001-F8800000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "6.5L V12": {
          "Message": null,
          "PID": "BFBEE897-9107A001-F8800000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Revuelto": {
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Urus": {
      "2019": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-69190201-020C000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-69190201-020C000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-69190201-020C000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-63190201-020C000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-63190201-020C000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-63190201-020C000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-63190201-020C000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    }
  },
  "Land Rover": {
    "Defender": {
      "1997": {
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED08441-63000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L I6 Turbo Hybrid": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED08441-63000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Discovery": {
      "1996": {
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FB980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED38551-07010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED38551-07010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED38551-07010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED38551-07010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B11F-FED08541-67000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFACD3-A007B11F-FED08541-67000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Discovery Sport": {
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FAC13-A007B011-FEDF8441-03010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FAC13-A007B011-FEDF8441-03010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FAC13-A007B011-FEDF8441-03010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FAC13-A007B011-FEDF8441-03010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FAC13-A007B011-FEDF8441-03010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED08441-63000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED08441-63000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED08441-63000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED08441-63000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED08441-63000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED08441-63000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Freelander": {
      "2002": {
        "2.5L V6": {
          "Message": null,
          "PID": "BF9FF991-FC000001-004D0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "2.5L V6": {
          "Message": null,
          "PID": "BF9FF991-FC000001-004D0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "2.5L V6": {
          "Message": null,
          "PID": "BF9FF991-FC000001-004D0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "2.5L V6": {
          "Message": null,
          "PID": "BF9FF991-FC000001-004D0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "LR2": {
      "2008": {
        "3.2L I6": {
          "Message": null,
          "PID": "BFFFA893-8007B111-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "3.2L I6": {
          "Message": null,
          "PID": "BFFFA893-8007B111-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "3.2L I6": {
          "Message": null,
          "PID": "BFFFA893-8007B111-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "3.2L I6": {
          "Message": null,
          "PID": "BFFFA893-8007B111-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "3.2L I6": {
          "Message": null,
          "PID": "BFFFA893-8007B111-FED00F10-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED30440-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED30440-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED30440-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "LR3": {
      "2005": {
        "4.0L V6": {
          "Message": null,
          "PID": "BFBFA893-801FB101-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BFBFA893-801FB101-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "4.0L V6": {
          "Message": null,
          "PID": "BFBFA893-801FB101-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BFBFA893-801FB101-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "4.0L V6": {
          "Message": null,
          "PID": "BFBFA893-801FB101-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BFBFA893-801FB101-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "4.0L V6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.4L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "4.0L V6": {
          "Message": null,
          "PID": "BFBFA893-801FB101-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BFBFA893-801FB101-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "LR4": {
      "2010": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F40-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFA8D7-A007B15F-FED00F57-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFFFEDD3-A057FD5B-FFD04F53-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F50-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED0C540-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED08551-07010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Range Rover": {
      "1996": {
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FB980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FB980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "4.4L V8": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "4.4L V8": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "4.4L V8": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "4.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFFA893-8007B101-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BFFFA893-8007B101-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "4.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFFA893-8007B101-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BFFFA893-8007B101-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "4.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFFA893-8007B101-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BFFFA893-8007B101-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "4.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFFA893-8007B101-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BFFFA893-8007B101-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F40-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F40-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "5.0L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F50-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F50-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F50-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F50-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED0C540-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED0C540-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED08551-07010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED08551-07010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED38551-07010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED38551-07010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED38551-07010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "2.0L I4 Twin Turbo Hybrid": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "2.0L I4 Twin Turbo Hybrid": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L I6 Turbo Hybrid": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "2.0L I4 Twin Turbo Hybrid": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L I6 Turbo Hybrid": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Range Rover Evoque": {
      "2012": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED30440-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED30440-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FAC13-A007B011-FEDF8441-03010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FAC13-A007B011-FEDF8441-03010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FAC13-A007B011-FEDF8441-03010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED38451-03010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED38451-03010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED08441-63000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Range Rover Sport": {
      "2006": {
        "4.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFFA893-8007B101-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BFFFA893-8007B101-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "4.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFFA893-8007B101-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BFFFA893-8007B101-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "4.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFFA893-8007B101-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BFFFA893-8007B101-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "4.2L V8 Supercharged": {
          "Message": null,
          "PID": "BFFFA893-8007B101-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BFFFA893-8007B101-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F40-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F40-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "5.0L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F40-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F40-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F50-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED00F50-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED0C540-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED0C540-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED08551-07010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED08551-07010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED08551-07010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED38551-07010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED38551-07010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED38551-07010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "3.0L I6 Turbo Hybrid": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "2.0L I4 Twin Turbo Hybrid": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L I6 Turbo Hybrid": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "2.0L I4 Twin Turbo Hybrid": {
          "Message": null,
          "PID": "BE3EAC13-A007B015-FED08441-67000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L I6 Turbo Hybrid": {
          "Message": null,
          "PID": "BE3EAC13-A007B015-FED08441-67000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BE3EAC13-A007B015-FED08441-67000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3EAC13-A007B015-FED08441-67000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3EAC13-A007B015-FED08441-67000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3EAC13-A007B015-FED08441-67000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3EAC13-A007B015-FED08441-67000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Range Rover Velar": {
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED38451-03010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED38451-03010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED38451-03010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FEDC8041-63000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FEDC8041-63000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FEDC8041-63000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED38551-07010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED38551-07010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFACD3-A007B119-FED38551-07010000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED08441-63000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED08441-63000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED08441-63000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED08441-63000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3FAC13-A007B015-FED08441-63000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    }
  },
  "Lexus": {
    "CT200h": {
      "2011": {
        "1.8L I4 Hybrid": {
          "Message": null,
          "PID": "BE7FF87B-FF7DFFFD-FFFE7DF8-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "1.8L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDC2021-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.8L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDC2021-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.8L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDCA021-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.8L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDCA021-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.8L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDCA021-08000001-00000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.8L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDCB021-08800001-02000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.8L I4 Hybrid": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "ES": {
      "1996": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FA811-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FA811-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.0L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2003": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2004": {
        "3.3L V6": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "3.3L V6": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "3.3L V6": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDC2021-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDC2021-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-7ADC8001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDCA021-08000001-00000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDCA021-08000001-00000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDCA021-08000001-00000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FEDCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDCA021-08000001-00000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-68880001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B101-7EDC8F01-08080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-68880001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-68880001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.5L I4": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-68880001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-68880001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-68880001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-68880001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-68880001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-68880001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "GS": {
      "1996": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "1999": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2000": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2001": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.3L V8": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2002": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.3L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2003": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.3L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2004": {
        "3.0L I6": {
          "Message": null,
          "PID": "BE3EA811-00001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.3L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.3L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FA893-B105A01F-FEDC2B00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.3L V8": {
          "Message": null,
          "PID": "BF9FB993-8005A01F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FEDC3000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.3L V8": {
          "Message": null,
          "PID": "BF9FB993-8005A01F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FEDC3000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FEDC3000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FEDC3000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFE893-9115B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FEDC3020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-7ADC8001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BFBFA893-9115B11F-FEDC3021-08030000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-7ADC8001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BFBFA893-9115B11F-FEDC3021-08030000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FADCE201-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BFBFA893-9115B11F-FA1C3000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA011-08094200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BFBFA893-B115B11F-7EDC8021-08080001-00000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BFBFA893-B115B11F-FEDCB021-08080001-00000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDCA011-08094200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BF9FA013-9105B99F-C4CC0021-08880001-02000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BF9FA893-9105B101-7EDC8F01-08080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B101-7EDC8F01-08080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9EA893-B105B11F-FEDCA001-0D000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BF9FA893-9105B101-7EDC8F01-08080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B101-7EDC8F01-08080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FA893-9105B101-7EDC8F01-08080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "GX": {
      "2003": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2004": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105A01F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFE893-9115B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFE893-F115B11F-FEDCA000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFE893-9115B11F-FEDCA000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9EA893-B105B11F-FADCA001-0DEA0000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFE893-9115B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9EA893-B105B11F-FADCA001-0D00002B-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFE893-9115B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9EA893-B105B11F-FADCA001-0D000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFE893-9115B11F-FADCAF01-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFE893-9115B11F-FADCAF01-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFE893-9115B11F-FADCAF01-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFE893-9115B11F-FADCAF01-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBFE893-9117B11F-FEDCAF01-68000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFBFE893-9117B11F-FEDCAF01-68000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFBFE893-9117B11F-FEDCAF01-68000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFBFE893-9117B11F-FEDCAF01-68000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "HS250h": {
      "2010": {
        "2.4L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9005B015-FEDC2020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.4L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDC3020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.4L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDC3020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "IS": {
      "2001": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.5L V6": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.5L V6": {
          "Message": null,
          "PID": "BF9FA893-B115B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.5L V6": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "2.5L V6": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.5L V6": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "2.5L V6": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "2.5L V6": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "2.5L V6": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FEDCA000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FEDCA000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "2.5L V6": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.5L V6": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA011-08094200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-7ADC8001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FEDCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDCA011-08094200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FEDCAF01-08080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-68880001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107B11F-FEDCAF01-68080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-68880001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-68880001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-68880001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-68880001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-B107B11F-FEDCAF01-68000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-B107B11F-FEDCAF01-68000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-B107B11F-FEDCAF01-68000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-B107B11F-FEDCAF01-68000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "LC": {
      "2018": {
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BF9FA013-9105B99F-C4CC0021-08880001-02000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9EA893-B105B11F-FEDCA001-0D000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BF9EA893-B105B11F-FEDCA001-0D000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9EA893-B105B11F-FEDCA001-0D000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BF9EA893-B105B11F-FEDCA001-0D000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9EA893-B105B11F-FEDCA001-0D000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "5.0L V8": {
          "Message": null,
          "PID": "BF9EA893-B105B11F-FEDCA001-0D000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BF9EA893-B107B11F-FEDCAF01-6D000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BF9EA893-B107B11F-FEDCAF01-6D000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BF9EA893-B107B11F-FEDCAF01-6D000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BF9EA893-B107B11F-FEDCAF01-6D000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "LFA": {
      "2012": {
        "4.8L V10": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "LS": {
      "1996": {
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "1999": {
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2000": {
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2001": {
        "4.3L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2002": {
        "4.3L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2003": {
        "4.3L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2004": {
        "4.3L V8": {
          "Message": null,
          "PID": "BF9FB993-8005E01F-FEDC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "4.3L V8": {
          "Message": null,
          "PID": "BF9FB993-8005E01F-FEDC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "4.3L V8": {
          "Message": null,
          "PID": "BF9FB993-8005A01F-FFDC2028-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8 Hybrid": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FEDC3000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8 Hybrid": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FEDC3000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFE893-9115B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8 Hybrid": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FEDC3000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8 Hybrid": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FEDC3000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9CA893-B105B11F-FEDC2001-05000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8 Hybrid": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FEDC3000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9EA893-B105B11F-FADCA001-0DEA0000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8 Hybrid": {
          "Message": null,
          "PID": "BF9EA893-B105B11F-FEDCB021-05000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9EA9DF-B105B1DF-FADCA1CD-0D0001CC-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8 Hybrid": {
          "Message": null,
          "PID": "BF9EA893-B105B11F-FEDCB021-05000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9EA893-B105B11F-FADCA001-0D00002B-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8 Hybrid": {
          "Message": null,
          "PID": "BF9EA893-B105B11F-FEDCB021-05000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9EA893-B105B11F-FADCA001-0D000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8 Hybrid": {
          "Message": null,
          "PID": "BF9EA893-B105B11F-FEDCB021-05000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9EA893-B105B11F-FADCA001-0D000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BF9FA013-9105B99F-C4CC0021-08880001-02000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Turbo": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BF9FA013-9105B99F-C4CC0021-08880001-02000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BFBFA893-B115B11F-FEDCBF21-08080001-0000004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Turbo": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-B115B11F-FEDCBF21-08080001-0000004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BFBFA893-B115B11F-FEDCBF21-08080001-0000004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-B115B11F-FEDCBF21-08080001-0000004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-B115B11F-FEDCBF21-08080001-0000004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BF9CA013-8007B99F-F7CCAF01-6F190201-020C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BF9CA013-8007B99F-F7CCAF01-6F190201-020C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BF9CA013-8007B99F-F7CCAF01-6F190201-020C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BF9CA013-8007B99F-F7CCAF01-6F190201-020C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "LX": {
      "1996": {
        "4.5L I6": {
          "Message": null,
          "PID": "BE1FB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "4.5L I6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "1999": {
        "4.7L V8": {
          "Message": null,
          "PID": "BE3EB814-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2000": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2001": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2002": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2003": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2004": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105A01F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9107B11F-FADC6001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9107B11F-FADC6001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9107B11F-FADCE001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FEDCAF01-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FEDCAF01-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FEDCAF01-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BF9FE893-9107B11F-FEDCAF01-68000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BF9FE893-9107B11F-FEDCAF01-68000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BF9FE893-9107B11F-FEDCAF01-68000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BF9FE893-9107B11F-FEDCAF01-68000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "NX": {
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA011-08094200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDCA021-08000001-00000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA011-08094200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDCA021-08000001-00000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDCA021-08000001-00000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDCA011-08094200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDCAC21-08000001-00000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-9007B015-FEDCAC11-68094201-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9017B015-FEDCAC21-08000001-0000004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-9007B015-FEDCAC11-68094201-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-68880001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-9007B015-FEDCAC11-68094201-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA813-9007B015-FEDCAC11-68094201-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "RC": {
      "2015": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA011-08094200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDCA011-08094200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9EA893-B105B11F-FEDCA001-0D000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-68880001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107B11F-FEDCAF01-68080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9EA893-B105B11F-FEDCA001-0D000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BF9EA893-B105B11F-FEDCA001-0D000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9EA893-B105B11F-FEDCA001-0D000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9EA893-B105B11F-FEDCA001-0D000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BF9EA893-B105B11F-FEDCA001-0D000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9EA893-B105B11F-FEDCA001-0D000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9EA893-B105B11F-FEDCA001-0D000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107B11F-FEDCAF01-68080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107B11F-FEDCAF01-68080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107B11F-FEDCAF01-68080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107B11F-FEDCAF01-68080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "RX": {
      "1999": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.0L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FA811-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FA811-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FA811-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.3L V6": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "3.3L V6": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "3.3L V6": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.3L V6 Hybrid": {
          "Message": null,
          "PID": "BF9FA893-9105A01F-FEDC3000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.3L V6 Hybrid": {
          "Message": null,
          "PID": "BF9FA893-9105A01F-FEDC3000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.3L V6 Hybrid": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FEDC3000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FEDC3000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BFBFA893-9115B11F-FEDC3020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FEDC3020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BFBFA893-9115B11F-FEDC3021-08030000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BFBFA893-9115B11F-FEDC3021-08030000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BFBFA893-9115B11F-FA1C3000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BFBFA893-B115B11F-7EDC8021-08080001-00000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BFBFA893-B115B11F-FEDCB021-08080001-00000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BF9FA013-9105B99F-C4CC0021-08880001-02000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B101-7EDC8F01-08080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BFBFA893-B115B11F-FEDCBF21-08080001-0000004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B101-7EDC8F01-08080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BF9FA893-9105B101-7EDC8F01-08080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B101-7EDC8F01-08080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BF9FA893-9105B101-7EDC8F01-08080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-6B090201-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-6B090201-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-6B090201-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-6B090201-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "RZ": {
      "2024": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "SC": {
      "1996": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "4.3L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2003": {
        "4.3L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2004": {
        "4.3L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "4.3L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "4.3L V8": {
          "Message": null,
          "PID": "BF9FB993-8005A01F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "4.3L V8": {
          "Message": null,
          "PID": "BF9FB993-8005A01F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "4.3L V8": {
          "Message": null,
          "PID": "BF9FB993-8005A01F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "4.3L V8": {
          "Message": null,
          "PID": "BF9FB993-8005A01F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "4.3L V8": {
          "Message": null,
          "PID": "BF9FB993-8005A01F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "TX": {
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE1FA013-8007B815-FEDCAC11-6A090201-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE1FA013-8007B815-FEDCAC11-6A090201-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "UX": {
      "2019": {
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-68880001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-68880001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-68880001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.0L I4": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-68880001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-68880001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-68880001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-68880001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-68880001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    }
  },
  "Lincoln": {
    "Aviator": {
      "2003": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2004": {
        "4.6L V8": {
          "Message": null,
          "PID": "BA3FC000-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB991-C0000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.0L V6 Twin Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2021": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.0L V6 Twin Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      }
    },
    "Blackwood": {
      "2002": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Continental": {
      "1996": {
        "4.6L V8": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "1997": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "1998": {
        "4.6L V8": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "1999": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFDFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFDFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "4.6L V8": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-8007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2018": {
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-01A02001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-8007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2019": {
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED09501-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA897-8007B119-FED09501-09000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2020": {
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED09501-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED09501-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED09501-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      }
    },
    "Corsair": {
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FCD09401-61A02001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FCD09401-61A02001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FCD09401-61A02001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FCD09401-61A02001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE7EA813-A007B011-FCD08405-67B02001-0004200F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE7EA813-A007B011-FCD08405-67B02001-0004200F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE7EA813-A007B011-FCD08405-67B02001-0004200F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE7EA813-A007B011-FCD08405-67B02001-0004200F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      }
    },
    "LS": {
      "2000": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.9L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2001": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.9L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2002": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFDFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.9L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2003": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB993-C01FA019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.9L V8": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2004": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB991-C0000001-08100000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.9L V8": {
          "Message": null,
          "PID": "BFBFB991-C0000001-08100000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB993-C01FA019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.9L V8": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "3.9L V8": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "MKC": {
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      }
    },
    "MKS": {
      "2009": {
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED0011E-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA897-8007B119-FED09001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "MKT": {
      "2010": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA897-8007B119-FED09001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09001-00000001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-8007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-8007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-01000001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA897-8007B119-FED09501-09000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "MKX": {
      "2007": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA897-8007B119-FED09001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2017": {
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-8007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2018": {
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-8007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      }
    },
    "MKZ": {
      "2007": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED03020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2014": {
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED03020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2015": {
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED0B020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED0B021-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA897-8007B119-FED09001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017B011-40840020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED0B020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED0B020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED09000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED0B020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED0B020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED0B020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      }
    },
    "Mark LT": {
      "2006": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB993-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB993-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB993-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Mark VIII": {
      "1996": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "1998": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Nautilus": {
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-01A02001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        },
        "2.7L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED09401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE7EA813-A007B011-FCD08405-65B02001-0004200F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE7EA813-A007B011-FCD08405-65B02001-0004200F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE7EA813-A007B011-FCD08405-65B02001-0004200F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE7EA813-A007B011-FCD08405-65B02001-0004200F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      }
    },
    "Navigator": {
      "1998": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "1999": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2000": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2001": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2002": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2003": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB993-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2006": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB117-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2007": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2008": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2009": {
        "5.4L V8": {
          "Message": null,
          "PID": "BFFFFF93-80FFFF19-FEFFFF40-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2010": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED04040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2011": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED04040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2012": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2013": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FA817-8007B119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2014": {
        "5.4L V8": {
          "Message": null,
          "PID": "BF9FA817-8007F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2015": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-AF9FF57D-FED08001-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2016": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08001-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2017": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08001-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2018": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2019": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-01000001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2020": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-01000001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2021": {
        "3.5L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD09501-01000001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD08505-61A02001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD08505-61A02001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FCD08505-61A02001-0004000F",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": false,
              "Hybrid and EV": false
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": false,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": false,
              "Vehicle Control and Suspension": false
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": "This vehicle uses a new generation of OBDII - Check back soon for updated compatibility!",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "Town Car": {
      "1996": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "1999": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2000": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2001": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2002": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2003": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB991-C0000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2004": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB991-C0000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFA897-801FF119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Zephyr": {
      "2006": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB993-C01FA019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    }
  },
  "Lotus": {
    "Eletre": {
      "2024": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "Elise": {
      "2005": {
        "1.8L I4": {
          "Message": null,
          "PID": "FE1FB813-80062001-68000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "1.8L I4": {
          "Message": null,
          "PID": "FE1FB813-80062001-68000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "1.8L I4": {
          "Message": null,
          "PID": "FE1FB813-80062001-6AC00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "1.8L I4": {
          "Message": null,
          "PID": "FE1FB813-80062001-6AC00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "1.8L I4 Supercharged": {
          "Message": null,
          "PID": "FE1FB813-80062001-6AC00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "1.8L I4": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "1.8L I4 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "1.8L I4": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "1.8L I4 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "1.8L I4": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "1.8L I4 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Emira": {
      "2024": {
        "All": {
          "Message": null,
          "PID": "FFFFA893-8007F119-FED08501-60000201-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "FFFFA893-8007F119-FED08501-60000201-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Esprit": {
      "2001": {
        "3.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "3.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "3.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "3.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Evora": {
      "2010": {
        "3.5L V6": {
          "Message": null,
          "PID": "FF9FB993-8007E001-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "3.5L V6": {
          "Message": null,
          "PID": "FF9FB993-8007E001-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.5L V6 Supercharged": {
          "Message": null,
          "PID": "FF9FB993-8007E001-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "3.5L V6": {
          "Message": null,
          "PID": "FF9FB993-8007E001-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.5L V6 Supercharged": {
          "Message": null,
          "PID": "FF9FB993-8007E001-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "3.5L V6": {
          "Message": null,
          "PID": "FF9FB993-8007E001-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.5L V6 Supercharged": {
          "Message": null,
          "PID": "FF9FB993-8007E001-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "3.5L V6": {
          "Message": null,
          "PID": "FF9FB993-8007E001-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.5L V6 Supercharged": {
          "Message": null,
          "PID": "FF9FB993-8007E001-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "3.5L V6 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "3.5L V6 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "3.5L V6 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Exige": {
      "2007": {
        "1.8L I4 Supercharged": {
          "Message": null,
          "PID": "FE1FB813-80062001-6AC00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "1.8L I4 Supercharged": {
          "Message": null,
          "PID": "FE1FB813-80062001-6AC00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "1.8L I4 Supercharged": {
          "Message": null,
          "PID": "FE1FB813-8007A001-FAC00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "1.8L I4 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "1.8L I4 Supercharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Turbo Esprit": {
      "1997": {
        "3.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "3.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "3.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "3.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    }
  },
  "Lucid": {
    "All": {
      "2022": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2023": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2024": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    }
  },
  "MINI": {
    "Clubman": {
      "2008": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.5L I3 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "1.5L I3 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-60000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "1.5L I3 Turbo": {
          "Message": null,
          "PID": "BFFFAABB-A007F511-FEFAAEBB-6D4CAAAB-03BEAAAF",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-60000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "1.5L I3 Turbo": {
          "Message": null,
          "PID": "BFFFAABB-A007F511-FEFAAEBB-6D4CAAAB-03BEAAAF",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-60000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "1.5L I3 Turbo": {
          "Message": null,
          "PID": "BFFFAABB-A007F511-FEFAAEBB-6D4CAAAB-03BEAAAF",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BFFFAABB-A007F511-FEFAAEBB-6D4CAAAB-03BEAAAF",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BFFFAABB-A007F511-FEFAAEBB-6D4CAAAB-03BEAAAF",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Cooper": {
      "2002": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.6L I4 Supercharged": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.6L I4 Supercharged": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.6L I4 Supercharged": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.6L I4 Supercharged": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.6L I4 Supercharged": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.5L I3 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-60000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "1.5L I3 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-60000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "1.5L I3 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "1.5L I3 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-60000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "1.5L I3 Turbo": {
          "Message": null,
          "PID": "BFFFAABB-A007F511-FEFAAEBB-6D4CAAAB-03BEAAAF",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-60000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "1.5L I3 Turbo": {
          "Message": null,
          "PID": "BFFFAABB-A007F511-FEFAAEBB-6D4CAAAB-03BEAAAF",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-60000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "1.5L I3 Turbo": {
          "Message": null,
          "PID": "BFFFAABB-A007F511-FEFAAEBB-6D4CAAAB-03BEAAAF",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BFFFAABB-A007F511-FEFAAEBB-6D4CAAAB-03BEAAAF",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2021": {
        "1.5L I3 Turbo": {
          "Message": null,
          "PID": "BFFFAABB-A007F511-FEFAAEBB-6D4CAAAB-03BEAAAF",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BFFFAABB-A007F511-FEFAAEBB-6D4CAAAB-03BEAAAF",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2022": {
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2023": {
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2024": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Cooper Convertible": {
      "2005": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.6L I4 Supercharged": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.6L I4 Supercharged": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.6L I4 Supercharged": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.6L I4 Supercharged": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.5L I3 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "1.5L I3 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-60000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "1.5L I3 Turbo": {
          "Message": null,
          "PID": "BFFFAABB-A007F511-FEFAAEBB-6D4CAAAB-03BEAAAF",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-60000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "1.5L I3 Turbo": {
          "Message": null,
          "PID": "BFFFAABB-A007F511-FEFAAEBB-6D4CAAAB-03BEAAAF",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-60000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "1.5L I3 Turbo": {
          "Message": null,
          "PID": "BFFFAABB-A007F511-FEFAAEBB-6D4CAAAB-03BEAAAF",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BFFFAABB-A007F511-FEFAAEBB-6D4CAAAB-03BEAAAF",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Countryman": {
      "2011": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.5L I3 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-60000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08410-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "1.5L I3 Turbo": {
          "Message": null,
          "PID": "BFFFAABB-A007F511-FEFAAEBB-6D4CAAAB-03BEAAAF",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.5L I3 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08430-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-60000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "1.5L I3 Turbo": {
          "Message": null,
          "PID": "BFFFAABB-A007F511-FEFAAEBB-6D4CAAAB-03BEAAAF",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.5L I3 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08431-60000001-0004004D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-60000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "1.5L I3 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08431-60000001-0004004D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.5L I3 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08431-60000001-0004004D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08431-60000001-0004004D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "1.5L I3 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08431-60000001-0004004D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.5L I3 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08431-60000001-0004004D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08431-60000001-0004004D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-63000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Coupe": {
      "2012": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Paceman": {
      "2013": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Roadster": {
      "2012": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-8007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
            "Battery": true
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    }
  },
  "Mack": {
    "All": {
      "1996": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    }
  },
  "Maserati": {
    "Coupe": {
      "2002": {
        "4.2L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "4.2L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "4.2L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "4.2L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "4.2L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Ghibli": {
      "2014": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBFE8F3-A005B119-FFD38541-05010203-00080023",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBFE893-A005B119-FFD38541-05010201-00080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBFE893-A005B119-FFD38541-05010201-00080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBFE893-A005B119-FFD38541-05010201-00080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEE893-A007B119-FED38541-00010200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEE893-A007B119-FED38541-00010200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED38551-08010201-00000001",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED38551-08010201-00000001",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBCE893-8007B119-F7C38555-691903E1-000C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFBCE893-8007B119-F7C38555-691903E1-000C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFBCE893-8007B119-F7C38555-691903E1-000C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "GranSport": {
      "2005": {
        "4.2L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Granturismo": {
      "2008": {
        "4.2L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE893-8007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FE893-8007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE893-8007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FE893-8007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "4.2L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.7L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FE893-8007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FE893-8007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "4.7L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "4.7L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "4.7L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "4.7L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "4.7L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "4.7L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BF9FE893-8007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Grecale": {
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Levante": {
      "2017": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBFE893-A005B119-FFD38541-05010201-00080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEE893-A007B119-FED38541-04010200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEE893-A007B119-FED38541-04010200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED38551-08010201-00000001",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED38551-08010201-00000001",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FFD38555-691103E1-000C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FFD38555-691103E1-000C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FFD38555-691103E1-000C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "MC20": {
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Quattroporte": {
      "2005": {
        "4.2L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "4.2L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "4.2L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "4.2L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE893-8007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FE893-8007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "4.2L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.7L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE893-8007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FE893-8007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FE893-8007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "4.7L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBFE893-A005B119-FFD38541-05010201-00080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFE893-A005B119-FFD38541-05010201-00080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBFE893-A005B119-FFD38541-05010201-00080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBFE893-A005B119-FFD38541-05010201-00080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEE893-A007B119-FED38541-00010200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEE893-A007B119-FED38541-00010200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED38551-08010201-00000001",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED38551-08010201-00000001",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BFBCE893-8007B119-F7C38541-05190201-00080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBCE893-8007B119-F7C38541-05190201-00080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFBCE893-8007B119-F7C38541-05190201-00080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFBCE893-8007B119-F7C38541-05190201-00080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Spyder": {
      "2002": {
        "4.2L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "4.2L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "4.2L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "4.2L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "4.2L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    }
  },
  "Mazda": {
    "2": {
      "2011": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00C01-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00C01-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00C01-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00C01-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.5L I4": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "3": {
      "2004": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB813-8017A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FAC13-8017B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB813-8017A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FAC13-8017B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.3L I4": {
          "Message": null,
          "PID": "BE1FA810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A017B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FAC13-8017B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A017B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A017B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA83B-A01FF039-FEDE0037-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00001-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A017F011-FED00001-03000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00C01-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00C01-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A017F011-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00C01-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00C01-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A017F011-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED08C01-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4": {
          "Message": null,
          "PID": "981A8013-8007F011-FED08C81-03000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "FE3FA813-8007F011-FED08C81-03000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4": {
          "Message": null,
          "PID": "981A8013-8007F011-FED08C81-03000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "981A8013-80018001-C0800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4": {
          "Message": null,
          "PID": "981A8013-8007F011-FED08C81-03000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "981A8013-80018001-C0800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4": {
          "Message": null,
          "PID": "FE3FA813-A007F011-FED08C81-03080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "981A8013-80018001-C0800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4": {
          "Message": null,
          "PID": "981A8013-80018001-C0800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "981A8013-80018001-C0800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4": {
          "Message": null,
          "PID": "981A8013-80018001-C0800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "981A8013-80018001-C0800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.0L I4": {
          "Message": null,
          "PID": "981A8013-80018001-C0800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "981A8013-80018001-C0800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "5": {
      "2006": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB813-8017A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB813-8017A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.5L I4": {
          "Message": null,
          "PID": "FE3FA813-8007F011-FED08C81-03000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.5L I4": {
          "Message": null,
          "PID": "981A8013-80018001-C0800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.5L I4": {
          "Message": null,
          "PID": "981A8013-80018001-C0800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "6": {
      "2003": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB813-8017A011-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB993-8017A019-6AD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB813-8017A011-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB993-8017A019-6AD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.3L I4": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB993-8017A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A017B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB993-8017A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE1FA810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A017B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB993-8017A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB993-8017A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00C01-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.5L I4": {
          "Message": null,
          "PID": "FE3FA813-8007F011-FED08C81-03000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.5L I4": {
          "Message": null,
          "PID": "981A8013-80018001-C0800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.5L I4": {
          "Message": null,
          "PID": "981A8013-80018001-C0800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.5L I4": {
          "Message": null,
          "PID": "981A8013-80018001-C0800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.5L I4": {
          "Message": null,
          "PID": "981A8013-80018001-C0800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Turbo": {
          "Message": null,
          "PID": "981A8013-80018001-C0800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.5L I4": {
          "Message": null,
          "PID": "981A8013-80018001-C0800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Turbo": {
          "Message": null,
          "PID": "981A8013-80018001-C0800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.5L I4": {
          "Message": null,
          "PID": "981A8013-80018001-C0800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Turbo": {
          "Message": null,
          "PID": "981A8013-80018001-C0800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "626": {
      "1996": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "2.0L I4": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.0L I4": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "B-Series Truck": {
      "1996": {
        "2.3L I4": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB900-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "2.3L I4": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "2.5L I4": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.5L I4": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.5L I4": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": "ABS is available on vehicles equipped with Four Wheel ABS (R-ABS not supported)",
          "PID": "98188001-80000001-C0000020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB911-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB911-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB813-8017E011-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB993-8017A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB993-801FE019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB813-8017E011-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB993-8017A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB993-801FE019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB993-801FE019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB993-801FE019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "CX-3": {
      "2016": {
        "2.0L I4": {
          "Message": null,
          "PID": "981A8013-8007F011-FED08C81-03000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4": {
          "Message": null,
          "PID": "981A8013-8007F011-FED08C81-03000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4": {
          "Message": null,
          "PID": "FE3FA813-A007F011-FED08C81-03080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4": {
          "Message": null,
          "PID": "FE3FA813-A007F011-FED08C81-03080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4": {
          "Message": null,
          "PID": "FE3FA813-A007F011-FED08C81-03080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.0L I4": {
          "Message": null,
          "PID": "FE3FA813-A007F011-FED08C81-03080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "FE3FA813-A007F011-FED08C85-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "CX-30": {
      "2020": {
        "2.0L I4": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.0L I4": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "CX-5": {
      "2013": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4": {
          "Message": null,
          "PID": "981A8013-8007F011-FED08C81-03000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "FE3FA813-8007F011-FED08C81-03000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4": {
          "Message": null,
          "PID": "981A8013-8007F011-FED08C81-03000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "981A8013-80018001-C0800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4": {
          "Message": null,
          "PID": "981A8013-8007F011-FED08C81-03000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "981A8013-80018001-C0800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4": {
          "Message": null,
          "PID": "FE3FA813-A007F011-FED08C81-03080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "981A8013-80018001-C0800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.2L I4 Diesel Twin Turbo": {
          "Message": null,
          "PID": "981A8013-80018001-C0800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "981A8013-80018001-C0800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Turbo": {
          "Message": null,
          "PID": "981A8013-80018001-C0800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.5L I4": {
          "Message": null,
          "PID": "981A8013-80018001-C0800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Turbo": {
          "Message": null,
          "PID": "981A8013-80018001-C0800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.5L I4": {
          "Message": null,
          "PID": "981A8013-80018001-C0800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Turbo": {
          "Message": null,
          "PID": "981A8013-80018001-C0800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "CX-50": {
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "CX-7": {
      "2007": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A017B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A017B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A017B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A017F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A017F011-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00C01-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A017F011-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "CX-9": {
      "2007": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "2.5L I4 Turbo": {
          "Message": null,
          "PID": "FE7FA813-A017F011-FED08C81-03080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.5L I4 Turbo": {
          "Message": null,
          "PID": "FE7FA813-A017F011-FED08C81-03080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.5L I4 Turbo": {
          "Message": null,
          "PID": "FE7FA813-A017F011-FED08C81-03080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.5L I4": {
          "Message": null,
          "PID": "981A8013-80018001-C0800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Turbo": {
          "Message": null,
          "PID": "981A8013-80018001-C0800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.5L I4 Turbo": {
          "Message": null,
          "PID": "981A8013-80018001-C0800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.5L I4 Turbo": {
          "Message": null,
          "PID": "981A8013-80018001-C0800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "FE7FA813-A017F011-FED08C81-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "FE7FA813-A017F011-FED08C81-63080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "CX-90": {
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "MPV": {
      "1996": {
        "3.0L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.0L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.0L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.5L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.5L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB993-8017A019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB993-8017A019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "MX-30": {
      "2022": {
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2023": {
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "MX-5 Miata": {
      "1996": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FAC13-8017B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4": {
          "Message": null,
          "PID": "981A8013-8007F011-FED08C81-03000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4": {
          "Message": null,
          "PID": "981A8013-8007F011-FED08C81-03000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4": {
          "Message": null,
          "PID": "FE3FA813-A007F011-FED08C81-03080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4": {
          "Message": null,
          "PID": "FE3FA813-A007F011-FED08C81-03080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4": {
          "Message": null,
          "PID": "FE3FA813-A007F011-FED08C81-03080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.0L I4": {
          "Message": null,
          "PID": "FE3FA813-A007F011-FED08C81-03080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "MX-6": {
      "1996": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Millenia": {
      "1996": {
        "2.3L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "2.3L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "2.3L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.3L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.3L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.3L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.3L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Protege": {
      "1996": {
        "1.5L I4": {
          "Message": null,
          "PID": "BFBFB991-C0000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BFBFB991-C0000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "1.6L I4": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "1.6L I4": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "1.6L I4": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Protege5": {
      "2002": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "RX8": {
      "2004": {
        "1.3L Rotary": {
          "Message": null,
          "PID": "BE1FE813-8007B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "1.3L Rotary": {
          "Message": null,
          "PID": "BE1FE813-8007B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "1.3L Rotary": {
          "Message": null,
          "PID": "BE1FE813-8007B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "1.3L Rotary": {
          "Message": null,
          "PID": "BE1FE813-8007B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "1.3L Rotary": {
          "Message": null,
          "PID": "BE1FE813-8007B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "1.3L Rotary": {
          "Message": null,
          "PID": "BE1FE813-8007B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "1.3L Rotary": {
          "Message": null,
          "PID": "BE1FE813-8007B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "1.3L Rotary": {
          "Message": null,
          "PID": "BE1FE813-8007B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Tribute": {
      "2001": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB813-8017A011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FA813-8017B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB813-C017E011-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.3L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FB813-C017E011-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB993-8017A019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FB813-8017E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFA893-8017F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFA893-8017F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00C01-02000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFA893-8017F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    }
  },
  "McLaren": {
    "540C": {
      "2017": {
        "All": {
          "Message": null,
          "PID": "BFFEE893-8007B119-F7CF8501-04110201-00080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "All": {
          "Message": null,
          "PID": "BFFEE893-8007B119-F7CF8501-04110201-00080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "570": {
      "2016": {
        "3.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFFEE893-8007B119-F7CF8501-04110201-00080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "3.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFFEE893-8007B119-F7CF8501-04110201-00080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "3.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFFEE893-8007B119-F7CF8501-04110201-00080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "3.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFFEE893-8007B119-F7CF8501-64110201-000C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "3.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFFEE893-8007B119-F7CF8501-64110201-000C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "600LT": {
      "2019": {
        "3.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFFEE893-8007B119-F7CF8501-64110201-000C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "3.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFFEE893-8007B119-F7CF8501-64110201-000C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "620R": {
      "2020": {
        "3.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFFEE893-8007B119-F7CF8501-64110201-000C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "650S": {
      "2015": {
        "3.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFFEE893-8007B119-F7CF8501-04110201-00080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "3.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFFEE893-8007B119-F7CF8501-04110201-00080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "675LT": {
      "2016": {
        "3.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFFEE893-8007B119-F7CF8501-04110201-00080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "720S": {
      "2018": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFFEE893-8007B119-F7CF8511-6C110201-000C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFFEE893-8007B119-F7CF8511-6C110201-000C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFFEE893-8007B119-F7CF8511-6C110201-000C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BFFEE893-8007B119-F7CF8511-6C110201-000C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFFEE893-8007B119-F7CF8511-6C110201-000C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFFEE893-8007B119-F7CF8511-6C110201-000C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "750S": {
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "765LT": {
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Artura": {
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "GT": {
      "2020": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BFFEE893-8007B119-F7CB8511-6C110201-000C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFFEE893-8007B119-F7CB8511-6C110201-000C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFFEE893-8007B119-F7CB8511-6C110201-000C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFFEE893-8007B119-F7CB8511-6C110201-000C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "MP4-12C": {
      "2011": {
        "3.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFFEE893-8007B119-F7CF0501-04100000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "3.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFFEE893-8007B119-F7CF0501-04100000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "3.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFFEE893-8007B119-F7CF0501-04100000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "3.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFFEE893-8007B119-F7CF0501-04100000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "P1": {
      "2014": {
        "3.8L V8 Twin Turbo Hybrid": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "3.8L V8 Twin Turbo Hybrid": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "SENNA": {
      "2019": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFFEE893-8007B119-F7CF8511-6C110201-000C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFFEE893-8007B119-F7CF8511-6C110201-000C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    }
  },
  "Mercedes-Benz": {
    "A Class": {
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "AMG GT": {
      "2016": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9CA893-8007F119-F7C08501-01180001-02080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9CA893-8007F119-F7C08501-01180001-02080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-01180001-02080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9CA893-8007F119-F7C08501-01180001-02080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-61180001-020C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08421-61000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08421-61000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08421-61000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08421-61000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08421-61000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "AMG GT Sedan": {
      "2019": {
        "3.0L I6 Turbo EQ Boost": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "3.0L I6 Turbo EQ Boost": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08421-61000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08421-61000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "3.0L I6 Turbo EQ Boost": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08421-61000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08421-61000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "B Class": {
      "2006": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EF813-8007E015-FEDC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EF813-8007E015-FEDC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EF813-8007E015-FEDC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EF813-8007E015-FEDC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EF813-8007E015-FEDC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EF813-8007E015-FEDC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EF813-8007E015-FEDC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EF813-8007E015-FEDC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EF813-8007E015-FEDC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EF813-8007E015-FEDC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EF813-8007E015-FEDC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EF813-8007E015-FEDC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "Hydrogen Cell": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3EF813-8007E015-FEDC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2012": {
        "Hydrogen Cell": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3EF813-8007E015-FEDC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2013": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EF813-8007E015-FEDC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2016": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3CA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2018": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3CA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2019": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3CA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "C Class": {
      "1996": {
        "2.2L I4": {
          "Message": null,
          "PID": "BA3FC000-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.8L I6": {
          "Message": null,
          "PID": "BA3FC000-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.6L I6": {
          "Message": null,
          "PID": "BA3FC000-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FF800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.8L I6": {
          "Message": null,
          "PID": "BE3FF800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.6L I6": {
          "Message": null,
          "PID": "BE3FF800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FF800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.3L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FF800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.3L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.3L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "2.6L V6": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "2.3L I4 Supercharged": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.6L V6": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L V6 Supercharged": {
          "Message": null,
          "PID": "BFBFF991-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "1.8L I4 Supercharged": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.6L V6": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L V6 Supercharged": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "1.8L I4 Supercharged": {
          "Message": null,
          "PID": "BE3FE810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.6L V6": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L V6 Supercharged": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "1.8L I4 Supercharged": {
          "Message": null,
          "PID": "BE3FE811-90000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.6L V6": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "2.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "2.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007B119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "2.5L V6": {
          "Message": null,
          "PID": "BFBFE893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFE893-A007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.5L V6": {
          "Message": null,
          "PID": "BFBFE893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFE893-A007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007B119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.5L V6": {
          "Message": null,
          "PID": "BFBFE893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFE893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.5L V6": {
          "Message": null,
          "PID": "BFBFE893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFE893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-9007E015-FED80C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE3EA813-9007E015-FED80C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFE893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-9007E015-FED80C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED0C500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-9007E015-FED80C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9CA893-8007F119-F7C08501-01180001-02080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Hybrid": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED09421-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9CA893-8007F119-F7C08501-01180001-02080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Hybrid": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED09421-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-01180001-02080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Hybrid": {
          "Message": null,
          "PID": "BE3CA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-01180001-02080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BABAAABB-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo (Including EQ Boost)": {
          "Message": null,
          "PID": "BABAAABB-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BABAAABB-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BABAAABB-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo (Including EQ Boost)": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo (Including EQ Boost)": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "C Class Coupe": {
      "2002": {
        "2.3L I4 Supercharged": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "1.8L I4 Supercharged": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "1.8L I4 Supercharged": {
          "Message": null,
          "PID": "BE3FE810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "1.8L I4 Supercharged": {
          "Message": null,
          "PID": "BE3FE811-90000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-9007E015-FED80C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-9007E015-FED80C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-9007E015-FED80C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-9007E015-FED80C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-01180001-02080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-01180001-02080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo (Including EQ Boost)": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo (Including EQ Boost)": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo (Including EQ Boost)": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "CL Class": {
      "1998": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.0L V12": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.0L V12": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.8L V12": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.8L V12": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.5L V12 Turbo": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.5L V12 Turbo": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "5.0L V8": {
          "Message": null,
          "PID": "BE3FF800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.5L V12 Turbo": {
          "Message": null,
          "PID": "BFBEF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.5L V12 Turbo": {
          "Message": null,
          "PID": "BFBEF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "5.5L V12 Turbo": {
          "Message": null,
          "PID": "BFBEF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "5.5L V12 Turbo": {
          "Message": null,
          "PID": "BFFFF997-B177E89F-FFF00886-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFF993-A007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "5.5L V12 Turbo": {
          "Message": null,
          "PID": "BFBFF993-A007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFF993-A007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007B119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "5.5L V12 Turbo": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "5.5L V12 Turbo": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFF993-A007E019-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V12 Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFF993-A007E019-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V12 Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFF993-A007E019-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V12 Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A005B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBEE893-8007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "CLA Class": {
      "2014": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007F011-FED0C401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BABAAABB-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "CLK Class": {
      "1998": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.3L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.3L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.3L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.3L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.3L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BE3FF800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007B119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "CLS Class": {
      "2006": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEB89B-AD1FF919-FFD89D18-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A005B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.0L I6 Turbo EQ Boost": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "3.0L I6 Turbo EQ Boost": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08421-61000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "3.0L I6 Turbo EQ Boost": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08421-61000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "E Class": {
      "1996": {
        "3.0L I6 Diesel": {
          "Message": null,
          "PID": "983A8010-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L I6": {
          "Message": null,
          "PID": "BA3FC000-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L V6": {
          "Message": null,
          "PID": "983A8010-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "3.0L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983B8010-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L I6": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "3.0L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983B8010-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.3L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "3.0L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983B8010-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.3L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.3L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.3L V8": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.3L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L V6 (Wagon)": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "3.2L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983B2013-B001A001-40000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "3.2L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983B2013-B001A001-40000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B003A015-44D00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007B119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFE893-A007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B003A015-44D00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFFFFCF7-80FFF5FD-FEFD54E4-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B01BA015-CCD80000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE89B-A007F119-FED00509-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B003A015-CCD8001D-CF9BAB53-A2000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B01BA015-CCD8001D-CF1BAB53-A2000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "9838A013-B003A001-CCD8801D-CFBBA353-AB200000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08520-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.1L I4 Turbo Diesel": {
          "Message": null,
          "PID": "98392013-B003A015-CCD0801D-CFBB2B53-AB220000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08520-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Turbo": {
          "Message": null,
          "PID": "98392013-B003A015-CCD0801D-CFBB2B53-AB220000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A005B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.1L I4 Turbo Diesel": {
          "Message": null,
          "PID": "981AE4F3-B001E4E1-C4C0E4FD-EFBB2143-AB2264E0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08520-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.1L I4 Turbo Diesel": {
          "Message": null,
          "PID": "9818A013-9001A001-C4C0801D-EFBB2343-A9220000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo (Including EQ Boost)": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L I6 Turbo EQ Boost": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo (Including EQ Boost)": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L I6 Turbo EQ Boost": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo (Including EQ Boost)": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L I6 Turbo EQ Boost": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "981AA013-B001A001-C4C0801D-EFBB2143-AB220000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "981AA013-B001A001-C4C0801D-EFBB2143-AB220000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "981AA013-B001A001-C4C0801D-EFBB2143-AB220000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "981AA013-B001A001-C4C0801D-EFBB2143-AB220000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "E Class Coupe": {
      "2010": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED0C500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "3.0L I6 Turbo EQ Boost": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "3.0L I6 Turbo EQ Boost": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08421-61000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08421-61000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "3.0L I6 Turbo EQ Boost": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08421-61000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "EQB Class": {
      "2022": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2023": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2024": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "EQE Class SUV": {
      "2023": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2024": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "EQE Class Sedan": {
      "2023": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2024": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "EQS Class SUV": {
      "2023": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2024": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "EQS Class Sedan": {
      "2022": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2023": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2024": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "G Class": {
      "2002": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "5.0L V8": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "5.0L V8": {
          "Message": null,
          "PID": "BE3FF800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFF993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFF993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFF993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFF993-8007E019-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A005B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "5.5L V8": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9CA893-8007F119-F7C08501-01180001-02080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBEE893-8007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-01180001-02080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-01180001-02080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-01180001-02080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-01180001-02080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-01180001-02080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-01180001-FFFFFF00",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-61180001-020C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-61180001-020C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBFE893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "GL Class": {
      "2007": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B003A015-44D00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B003A015-44D00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B01BA015-CCD80000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBFE893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B01BA015-CCD8001D-CD1BAB53-A2000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBFE893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B003A015-CCD8001D-CF9BAB53-A2000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBFE893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B01BA015-CCD8001D-CF1BAB53-A2000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "983BA013-B01BA015-CCD8001D-CF1BAB53-A2000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "9838A013-B003A001-CCD8801D-CFBBA353-AB200000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "9838A013-B003A001-CCD8801D-CFBBA353-AB220000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B003A001-CCD8801D-EFBBA353-AB200000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "981AA013-B001A001-C4C0801D-EFBBA143-AB220000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "GLA Class": {
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BABAAABB-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "GLB Class": {
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "GLC Class": {
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Hybrid": {
          "Message": null,
          "PID": "BE3CA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-01180001-02080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo (Including EQ Boost)": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo (Including EQ Boost)": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo (Including EQ Boost)": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "GLE Class": {
      "2016": {
        "2.1L I4 Turbo Diesel": {
          "Message": null,
          "PID": "9818A013-9001A001-C4C0801D-EFBB2343-A9220000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "981AA013-B001A001-C4C0801D-EFBB2143-AB200000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Hybrid": {
          "Message": null,
          "PID": "9818A013-9001A001-C4C0801D-EFBB2343-A9220000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.0L V6 Turbo Hybrid": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED09520-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.0L V6 Turbo Hybrid": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED09520-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L I6 Turbo EQ Boost": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08421-61000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L V8 Twin Turbo EQ Boost": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08521-61180001-020C004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L I6 Turbo EQ Boost": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08421-61000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L V8 Twin Turbo EQ Boost": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08521-61180001-020C004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "GLE Coupe": {
      "2016": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "981AA013-B001A001-C4C0801D-EFBB2143-AB200000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "GLK Class": {
      "2010": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.1L I4 Turbo Diesel": {
          "Message": null,
          "PID": "981AA013-B001A001-C4C0801D-EFBB2143-AB200000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.1L I4 Turbo Diesel": {
          "Message": null,
          "PID": "98392013-B003A015-CCD0801D-CFBB2B53-AB220000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.1L I4 Turbo Diesel": {
          "Message": null,
          "PID": "981AA013-B001A001-C4C0801D-EFBB2143-AB200000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "GLS Class": {
      "2017": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "9818A013-9003A001-C4C0801D-EFBBA343-E9A00000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "3.0L I6 Turbo EQ Boost": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08421-61000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L V8 Twin Turbo EQ Boost": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08521-61180001-020C004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "3.0L I6 Turbo EQ Boost": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08421-61000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L V8 Twin Turbo EQ Boost": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08521-61180001-020C004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Maybach": {
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFBEE893-8007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFBEE893-8007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "M Class": {
      "1998": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.3L V8": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.3L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.3L V8": {
          "Message": null,
          "PID": "A2BAAABB-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BE3FF800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B003A015-44D00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007B119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B003A015-44D00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B01BA015-CCD80000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007B119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B003A015-CCD8001D-CF9BAB53-A2000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "983BA013-B003A015-CCD8001D-CF9BAB53-A2000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B01BA015-CCD8001D-CD1BAB53-A2000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "983BA013-B01BA015-CCD8001D-CD1BAB53-A2000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B003A015-CCD8001D-CF9BAB53-A2000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED0C500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.1L I4 Turbo Diesel": {
          "Message": null,
          "PID": "981AA013-B001A001-C4C0801D-EFBB2143-AB200000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "9838A013-B003A001-CCD8801D-CFBBA353-AB200000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED0C500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "9838A013-B003A001-CCD8801D-CFBBA353-AB220000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Turbo": {
          "Message": null,
          "PID": "9838A013-B003A001-CCD8801D-CFBBA353-AB220000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A005B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.1L I4 Turbo Diesel": {
          "Message": null,
          "PID": "981AA013-B001A001-C4C0801D-EFBB2143-AB200000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B003A001-CCD8801D-EFBBA353-AB200000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Metris": {
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "FEFEAEFF-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "R Class": {
      "2006": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B003A015-44D00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007B119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B003A015-44D00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B01BA015-CCD80000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B01BA015-CCD8001D-CD1BAB53-A2000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B01BA015-CCD8001D-CD1BAB53-A2000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B01BA015-CCD8001D-CF1BAB53-A2000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "9838A013-B003A001-CCD8801D-CFBBA353-AB200000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "S Class": {
      "1996": {
        "3.2L I6": {
          "Message": null,
          "PID": "BA3FC000-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.0L V12": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "3.2L I6": {
          "Message": null,
          "PID": "BE3FF800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.0L V12": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "3.2L I6": {
          "Message": null,
          "PID": "BE3FF800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.0L V12": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "3.2L I6": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.0L V12": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "4.3L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "4.3L V8": {
          "Message": null,
          "PID": "A2BAAABB-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.8L V12": {
          "Message": null,
          "PID": "A2BAAABB-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "4.3L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.8L V12": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "4.3L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.5L V12 Turbo": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "4.3L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.5L V12 Turbo": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "4.3L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.5L V12 Turbo": {
          "Message": null,
          "PID": "BFBEF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.3L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.5L V12 Turbo": {
          "Message": null,
          "PID": "BFBEF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "5.5L V12 Turbo": {
          "Message": null,
          "PID": "BFBEF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFF993-A007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "4.7L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.5L V12 Turbo": {
          "Message": null,
          "PID": "BFBFF993-A007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFF993-A007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "4.7L V8": {
          "Message": null,
          "PID": "BFBFE893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.5L V12 Turbo": {
          "Message": null,
          "PID": "BFBFF993-A007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-A007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFF993-A007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007B119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BFBFE893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBFE893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V12 Turbo": {
          "Message": null,
          "PID": "BFBFE893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFE893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BFBFE893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBFE893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V12 Turbo": {
          "Message": null,
          "PID": "BFBFE893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFF993-A007E019-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B003A015-CCD8001D-CF9BAB53-A2000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "983BA013-B003A015-CCD8001D-CF9BAB53-A2000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8 Turbo": {
          "Message": null,
          "PID": "983BA013-B003A015-CCD8001D-CF9BAB53-A2000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V12 Turbo": {
          "Message": null,
          "PID": "983BA013-B003A015-CCD8001D-CF9BAB53-A2000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFF993-A007E019-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "9838A013-B003A001-CCD8801D-CFBBA353-AB200000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08520-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V12 Turbo": {
          "Message": null,
          "PID": "9838A013-B003A001-CCD8801D-CFBBA353-AB200000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFF993-A007E019-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "4.7L V8 Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A005B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.0L V6 Turbo Hybrid": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBEE893-8007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.0L V6 Turbo Hybrid": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBEE893-8007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.0L V6 Turbo Hybrid": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED09520-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED09520-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED09520-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.0L I6 Turbo EQ Boost": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Twin Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "S Class Coupe": {
      "1996": {
        "3.2L I6": {
          "Message": null,
          "PID": "BA3FC000-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.0L V12": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "3.2L I6": {
          "Message": null,
          "PID": "BE3FF800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.0L V12": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FFFFFFFF-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBEE893-8007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBEE893-8007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-01180001-02080000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-01180001-FFFFFF00",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-01180001-FFFFFF00",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-61180001-020C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08501-61180001-020C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "SL Class": {
      "1996": {
        "3.2L I6": {
          "Message": null,
          "PID": "BA3FC000-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.0L V12": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "3.2L I6": {
          "Message": null,
          "PID": "BE3FF800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.0L V12": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.0L V12": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.0L V12": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.0L V12": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.0L V12": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.0L V12": {
          "Message": null,
          "PID": "BFBFF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "5.0L V8": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.5L V12 Turbo": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "5.0L V8": {
          "Message": null,
          "PID": "BE3FF800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.5L V12 Turbo": {
          "Message": null,
          "PID": "BFBEF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "5.0L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "5.5L V12 Turbo": {
          "Message": null,
          "PID": "BFBEF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "5.5L V12 Turbo": {
          "Message": null,
          "PID": "BFBEF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFF993-A007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "5.5L V12 Turbo": {
          "Message": null,
          "PID": "BFBFF993-A007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFF993-A007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "5.5L V12 Turbo": {
          "Message": null,
          "PID": "BFBFF993-A007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFF993-A007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007B119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFF993-A007E019-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A005B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBEE893-8007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBEE893-8007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBEE893-8007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.0L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "SLC Class": {
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BABAAABB-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BABAAABB-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007F011-FED08400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "SLK Class": {
      "1998": {
        "2.3L I4 Supercharged": {
          "Message": null,
          "PID": "BE3FF800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "2.3L I4 Supercharged": {
          "Message": null,
          "PID": "BE3FF800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "2.3L I4 Supercharged": {
          "Message": null,
          "PID": "BE3FF800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "2.3L I4 Supercharged": {
          "Message": null,
          "PID": "BE3FF800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "2.3L I4 Supercharged": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L V6 Supercharged": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "2.3L I4 Supercharged": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L V6 Supercharged": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "2.3L I4 Supercharged": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L V6 Supercharged": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007B119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFE893-A007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFE893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.4L V8": {
          "Message": null,
          "PID": "BFBFE893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFE893-A007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-9007E015-FED80C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BF3EA81B-BD1FE81D-FFD80C98-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-9007E015-FED80C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BFBFE893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-9007E015-FED80C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BE3EA813-9007E015-FED80C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEA893-A007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.5L V8": {
          "Message": null,
          "PID": "BE3CA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "SLR": {
      "2005": {
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFF993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "5.4L V8 Supercharged": {
          "Message": null,
          "PID": "BFBFF993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "SLS": {
      "2011": {
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "6.2L V8": {
          "Message": null,
          "PID": "BFFFE893-8007F119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Sprinter": {
      "2010": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B003A015-CCD8001D-CF9BAB53-A2000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B003A015-CCD8001D-CF9BAB53-A2000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B003A015-CCD8001D-CF9BAB53-A2000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B003A001-CCD8801D-EFBBA353-AB200000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.1L I4 Turbo Diesel": {
          "Message": null,
          "PID": "981AA013-B001A001-C4C0801D-EFBB2143-AB200000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B003A001-CCD8801D-EFBBA353-AB200000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.1L I4 Turbo Diesel": {
          "Message": null,
          "PID": "981AA013-B001A001-C4C0801D-EFBB2143-AB200000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-B003A001-CCD8801D-EFBBA353-AB200000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.1L I4 Turbo Diesel": {
          "Message": null,
          "PID": "981AA013-B001A001-C4C0801D-EFBB2143-AB200000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "981AA013-B001A001-C4C0801D-EFBB2143-AB200000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.1L I4 Turbo Diesel": {
          "Message": null,
          "PID": "9818A013-9001A001-C4C0801D-EFBB2343-A9220000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "9818A013-9003A001-C4C0801D-EFBBA343-E9A00000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "9818A013-9003A001-C4C0801D-EFBBA343-E9A00000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED09401-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "9818A013-9003A001-C4CC801D-EDBBA343-E926402D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.1L I4 Turbo Diesel": {
          "Message": null,
          "PID": "BE3CA813-A007B011-FED08405-61000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "9818A013-9003A001-C4CC801D-EDBBA343-E926402D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "98188013-8003A001-E4CC801D-EDBBE343-E9B6423D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "98188013-8003A001-E4CC801D-EDBBE343-E9B6423D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "98188013-8003A001-E4CC801D-EDBBE343-E9B6423D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    }
  },
  "Mercury": {
    "Cougar": {
      "1996": {
        "3.8L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.8L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3CB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Grand Marquis": {
      "1996": {
        "4.6L V8": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "4.6L V8": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "4.6L V8": {
          "Message": null,
          "PID": "B81FA010-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB991-C0000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2004": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB991-C0000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB993-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB993-C007E019-FEF00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Marauder": {
      "2003": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB991-C0000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2004": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB991-C0000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Mariner": {
      "2005": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB813-C017E011-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB813-C017E011-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.3L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FB813-C017E011-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB813-8017E011-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.3L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FB813-C017E011-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB993-801FE019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB813-C017E011-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.3L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FB813-C017E011-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FB813-8017E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB993-8017E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFA893-8017F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFA893-8017F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Milan": {
      "2006": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB813-8017E011-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB993-C01FA019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FFC13-8017E011-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB993-801FE019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB813-C017E011-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB993-801FE019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB813-8017E011-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB993-8017E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFA893-8017F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8017F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFA893-8017F119-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Montego": {
      "2005": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF40000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF40000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Monterey": {
      "2004": {
        "4.2L V6": {
          "Message": null,
          "PID": "BFBFB991-C0000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "4.2L V6": {
          "Message": null,
          "PID": "BFBFB991-C0000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "4.2L V6": {
          "Message": null,
          "PID": "BFBFB993-801FE019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "4.2L V6": {
          "Message": null,
          "PID": "BFBFB993-801FE019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Mountaineer": {
      "1997": {
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "1998": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "1999": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2000": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2001": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB8E9-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "4.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "4.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "4.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB993-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "4.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB993-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "4.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB993-C007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "4.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FB993-C007E019-FEF00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "4.0L V6": {
          "Message": null,
          "PID": "BFBFB993-C01FE019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Mystique": {
      "1996": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Sable": {
      "1996": {
        "3.0L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "1997": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "1998": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "1999": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFDFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFDFB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFDFB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB993-C01FA019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB993-C01FA019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-8007F119-FEF00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Tracer": {
      "1996": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.9L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Villager": {
      "1996": {
        "3.0L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.0L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.0L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    }
  },
  "Mitsubishi": {
    "3000GT": {
      "1996": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Diamante": {
      "1996": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Eclipse": {
      "1996": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE3EB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.4L I4": {
          "Message": null,
          "PID": "BFBFB993-8017E001-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8017E001-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.4L I4": {
          "Message": null,
          "PID": "BFBFB993-8017E001-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8017E001-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.4L I4": {
          "Message": null,
          "PID": "BFBFB993-8017E001-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8017E001-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB813-8017E001-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8017E001-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8017E001-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.4L I4": {
          "Message": null,
          "PID": "BFBFB993-8017E001-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8017E001-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8017E001-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Eclipse Cross": {
      "2018": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "1.5L I4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3DA813-9007E001-FED08CC1-61014001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3DA813-9007E001-FED08CC1-61014001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3DA813-9007E001-FED08CC1-61014001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3DA813-9007E001-FED08CC1-61014001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Endeavor": {
      "2004": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8017E001-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8017E001-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8017E001-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8017E001-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8017E001-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Galant": {
      "1996": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.4L I4": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.4L I4": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.4L I4": {
          "Message": null,
          "PID": "BFBFB993-8017E001-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8017E001-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.4L I4": {
          "Message": null,
          "PID": "BFBFB993-8017E001-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8017E001-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.4L I4": {
          "Message": null,
          "PID": "BFBFB993-8017E001-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8017E001-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB813-8017E001-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB993-8017E001-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.4L I4": {
          "Message": null,
          "PID": "BFBFB993-8017E001-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.4L I4": {
          "Message": null,
          "PID": "BFBFB993-8017E001-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Lancer": {
      "2002": {
        "2.0L I4": {
          "Message": null,
          "PID": "BFBFB994-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB010-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB010-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB010-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FBC13-8017E001-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB813-8007E001-FED00001-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FBC13-8017E001-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB813-8007E001-FED00041-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB813-8017E001-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB813-8007E001-FED00041-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FAC13-9017E001-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB013-8007E001-FED00041-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB813-8007E001-FED00041-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB813-8007E001-FED00041-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB813-8007E001-FED00041-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB013-8007E001-FED00041-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-9007E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Mighty Max Pickup": {
      "1996": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Mirage": {
      "1996": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "1.5L I4": {
          "Message": null,
          "PID": "BFDFB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BFDFB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "1.5L I4": {
          "Message": null,
          "PID": "BFDFB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BFDFB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "1.2L I3": {
          "Message": null,
          "PID": "BE3FA813-9007E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.2L I3": {
          "Message": null,
          "PID": "BE3FA813-9007E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.2L I3": {
          "Message": null,
          "PID": "BE3FA813-9007E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.2L I3": {
          "Message": null,
          "PID": "BE3FA813-9007E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.2L I3": {
          "Message": null,
          "PID": "BE3FA813-9007E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "1.2L I3": {
          "Message": null,
          "PID": "BE3FA813-9007E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "1.2L I3": {
          "Message": null,
          "PID": "BE3FA813-9007E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-9007E001-FED08C41-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-9007E001-FED08C41-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Montero": {
      "1996": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.0L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.0L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.0L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.8L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Montero Sport": {
      "1997": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.0L V6": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Outlander": {
      "2003": {
        "2.4L I4": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB993-8017E001-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB813-8017E001-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB993-8017E001-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB813-8017E001-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB993-8017E001-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB813-8017E001-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB993-8017E001-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB993-8017E001-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB993-8017E001-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFA893-9117E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-9007E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFA893-9117E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFA893-9117E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-9007E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFA893-9117E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-9007E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFA893-9117E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFA893-9117E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "981A8013-80018001-C0800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "981A8013-80018001-C0800000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-901FE011-FED88011-60080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-901FE011-FED88011-60080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-901FE011-FED88011-60080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-901FE011-FED88011-60080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-901FE011-FED88011-60080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "RVR/Outlander Sport": {
      "2011": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED00040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED08C41-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED08C41-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-9017E001-FED08040-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Raider": {
      "2006": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "i-MiEV": {
      "2012": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2013": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2014": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2015": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2016": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2017": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    }
  },
  "Mitsubishi Fuso": {
    "All": {
      "1996": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    }
  },
  "Nissan": {
    "200SX": {
      "1996": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": null
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": null
        }
      },
      "1997": {
        "1.6L I4": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": null
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": null
        }
      },
      "1998": {
        "1.6L I4": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": null
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": null
        }
      }
    },
    "240SX": {
      "1996": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": null
        }
      },
      "1997": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": null
        }
      },
      "1998": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": null
        }
      }
    },
    "300ZX": {
      "1996": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": null
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": null
        }
      }
    },
    "350Z": {
      "2003": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "370Z": {
      "2009": {
        "3.7L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FEDC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FED88001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FED88001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FED88001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FED88001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BFBEA893-9107E019-FED88001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "ARIYA": {
      "2023": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2024": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "Altima": {
      "1996": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.4L I4": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.5L I4": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BFDFAC17-97D7E017-FFDC0017-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FAC13-9007E011-FEDC0020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FAC13-9007E011-FEDC0020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FAC13-9007E011-FEDC0020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.5L I4": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FAC13-9007E011-FEDC0020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9EA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "98188013-80000001-CA008000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FEDC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.5L I4": {
          "Message": null,
          "PID": "98188013-80000001-CA008000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FEDC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-9007E011-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-00080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3CA813-A007F011-FED08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-901FE011-FED88001-60080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-901FE011-FED88001-60080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-901FE011-FED88001-60080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-901FE011-FED88001-60080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-901FE011-FED88001-60080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-901FE011-FED88001-60080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-901FE011-FED88001-60080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-901FE011-FED88001-60080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Armada": {
      "2004": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADCC000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FEDCC000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "5.6L V8": {
          "Message": null,
          "PID": "BFBFA893-91058019-FED88001-00080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-00080180-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-00080180-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-00080180-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-60080181-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-60080181-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-60080181-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-60080181-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-60080181-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "B-Series Truck": {
      "1996": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Cube": {
      "2009": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-90058011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Frontier": {
      "1998": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.5L I4": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "2.5L I4": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.5L I4": {
          "Message": null,
          "PID": "98188013-80000001-CA008000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-9007E011-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED8C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.5L I4": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-60080181-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-60080181-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-60080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-60080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-60080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-60080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "GT-R": {
      "2009": {
        "3.8L V6 Turbo": {
          "Message": null,
          "PID": "BF9FE893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "3.8L V6 Turbo": {
          "Message": null,
          "PID": "BF9FE893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "3.8L V6 Turbo": {
          "Message": null,
          "PID": "BF9FE893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "3.8L V6 Turbo": {
          "Message": null,
          "PID": "BF9EE893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "3.8L V6 Turbo": {
          "Message": null,
          "PID": "BF9EE893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.8L V6 Turbo": {
          "Message": null,
          "PID": "BF9EE893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.8L V6 Turbo": {
          "Message": null,
          "PID": "BF9EE893-9107E019-FEDC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.8L V6 Turbo": {
          "Message": null,
          "PID": "BF9EE893-9107E019-FEDC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.8L V6 Turbo": {
          "Message": null,
          "PID": "BF9EE893-9107E019-FEDC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.8L V6 Turbo": {
          "Message": null,
          "PID": "BF9EE893-9107E019-FEDC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.8L V6 Turbo": {
          "Message": null,
          "PID": "BF9EE893-9107E019-FEDC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.8L V6 Turbo": {
          "Message": null,
          "PID": "BF9EE893-9107E019-FEDC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BF9EE893-9107E019-FED88001-64000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BF9EE893-9107E019-FED88001-64000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BF9EE893-9107E019-FED88001-64000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Juke": {
      "2011": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE1DA813-9007E011-FADC8001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE1DA813-9007E011-FADC8001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE1DA813-9007E011-FEDC8001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE1DA813-9007E011-FEDC8001-01080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3DA813-901FE011-FED88001-01088000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Kicks": {
      "2017": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3DA813-901FE011-FED88001-01088000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-9005A011-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3DA813-901FE011-FED88001-01088000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3DA813-901FE011-FED88001-01088000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FED88001-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FED88001-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FED88001-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FED88001-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FED88001-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Leaf": {
      "2011": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2012": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2013": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2014": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2015": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2016": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2017": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2018": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2019": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2020": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2021": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2022": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2023": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2024": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "Maxima": {
      "1996": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFBFB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FF991-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.0L V6": {
          "Message": null,
          "PID": "BFDFB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9EA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9EA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9EA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "3.5L V6": {
          "Message": null,
          "PID": "98188013-80000001-CA008000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FEDC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-00080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FEDC8001-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FEDC8001-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FEDC8001-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Micra": {
      "2015": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Murano": {
      "2003": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "3.5L V6": {
          "Message": null,
          "PID": "98188013-80000001-CA008000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FEDC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC0021-01080100-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FEDC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-00080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Murano Cross Cabriolet": {
      "2011": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9EA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "3.5L V6": {
          "Message": null,
          "PID": "98188013-80000001-CA008000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "NV": {
      "2012": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FAA93-B107E299-FADC8280-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FEDCC000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-00080180-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-00080180-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-00080180-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-60080181-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-60080181-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "NV200": {
      "2013": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8001-00000100-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FED88001-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Pathfinder": {
      "1996": {
        "3.3L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.3L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.3L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.3L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.3L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADCC000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC0021-01080100-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "98188013-80000001-CA008000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC0021-01080100-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FEDC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-00080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-60080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FEDC8001-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88041-60080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88041-60080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88041-60080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88041-60080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Quest": {
      "1996": {
        "3.0L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.0L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.3L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-911FE019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9EA893-9107E019-FADC8001-04000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.5L V6": {
          "Message": null,
          "PID": "98188013-80000001-CA008000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FEDC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Rogue": {
      "2008": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9047E011-FADE8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.5L I4": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FED88001-00080100-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FED88001-00080100-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-9007E011-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FED88021-00080101-00000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-9007E011-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE3FA813-901FE011-FED88001-60080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BE3DA813-901FE011-FED88011-61388001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3DA813-901FE011-FED88011-61388001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3DA813-901FE011-FED88011-61388001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3DA813-901FE011-FED88011-61388001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3DA813-901FE011-FED88011-61388001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Rogue Select": {
      "2014": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Rogue Sport/Qashqai": {
      "2017": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Sentra": {
      "1996": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "1.6L I4": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "1.6L I4": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "1.8L I4": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "1.8L I4": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.0L I4": {
          "Message": null,
          "PID": "FE1F8803-9007E011-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.0L I4": {
          "Message": null,
          "PID": "FE1FAC13-F007EC11-FADC8C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB813-80058001-7E100000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-90058011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB813-80058011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-90058011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3DA813-901FE011-FED88001-01088000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-90058011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3DA813-901FE011-FED88001-01088000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-90058011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.6L I4 Turbo": {
          "Message": null,
          "PID": "BE3DA813-901FE011-FED88001-01088000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-90058011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-901FE011-FED88001-60080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-901FE011-FED88001-60080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-901FE011-FED88001-60080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-901FE011-FED88001-60080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-901FE011-FED88001-60080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Titan": {
      "2004": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADCC000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FEDCC000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-00080180-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-00080180-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-00080180-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-00080180-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-60080181-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-60080181-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-60080181-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-60080181-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Titan XD": {
      "2016": {
        "5.0L V8 Turbo-Diesel": {
          "Message": null,
          "PID": "981B0013-8003A001-C0CC804D-F8A9BB43-EBF44100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.6L V8": {
          "Message": null,
          "PID": "BFBFA893-9107E019-FED88001-00080180-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "5.0L V8 Turbo-Diesel": {
          "Message": null,
          "PID": "99BB0013-91A3A001-D1EC804D-F9A9BB43-FBF44100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-00080180-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "5.0L V8 Turbo-Diesel": {
          "Message": null,
          "PID": "981B0013-8003A001-C0CC804D-F8A9BB43-EBF64100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-00080180-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "5.0L V8 Turbo-Diesel": {
          "Message": null,
          "PID": "981B0013-8003A001-C4CC8049-F8A9BB43-EBF6412D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-00080180-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "5.6L V8": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FED88001-00080180-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Versa Hatchback": {
      "2007": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Versa Note": {
      "2014": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Versa Sedan": {
      "2007": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB813-80058011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-90058011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FED88000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "X-Trail": {
      "2005": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.5L I4": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Xterra": {
      "2000": {
        "2.4L I4": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": null
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": null
        }
      },
      "2001": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9117E019-FADE8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Z": {
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFBCA893-9107E019-FED88001-65089001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFBCA893-9107E019-FED88001-65089001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFBCA893-9107E019-FED88001-65089001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    }
  },
  "Oldsmobile": {
    "88": {
      "1996": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFFD10-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "98": {
      "1996": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": null
        }
      }
    },
    "Achieva": {
      "1996": {
        "2.4L I4": {
          "Message": null,
          "PID": "BFBFFD10-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.1L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Alero": {
      "1999": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.4L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.4L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.4L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.4L V6": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.4L V6": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.4L V6": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Aurora": {
      "1996": {
        "4.0L V8": {
          "Message": null,
          "PID": "BFBFBD10-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": null
        }
      },
      "1997": {
        "4.0L V8": {
          "Message": null,
          "PID": "BFBFBD10-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "4.0L V8": {
          "Message": null,
          "PID": "BFBFBD10-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "4.0L V8": {
          "Message": null,
          "PID": "BFBFBD10-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FF811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V8": {
          "Message": null,
          "PID": "BE3FF811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FF811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V8": {
          "Message": null,
          "PID": "BE3FF811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "4.0L V8": {
          "Message": null,
          "PID": "BFBFF910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Bravada": {
      "1996": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFBD10-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFBD14-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "4.3L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFB514-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "4.3L V6": {
          "Message": null,
          "PID": "BFBFF914-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "4.2L I6": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "4.2L I6": {
          "Message": null,
          "PID": "BE3EB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "4.2L I6": {
          "Message": null,
          "PID": "BE3EF811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Ciera": {
      "1996": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": null
        },
        "3.1L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": null
        }
      }
    },
    "Cutlass": {
      "1996": {
        "3.1L V6": {
          "Message": null,
          "PID": "BFBFF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": null
        }
      },
      "1997": {
        "3.1L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.1L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.1L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Cutlass Supreme": {
      "1996": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": null
        }
      }
    },
    "Intrigue": {
      "1998": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FF811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FF811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "LSS": {
      "1996": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Regency": {
      "1997": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Silhouette": {
      "1996": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    }
  },
  "Peterbilt": {
    "All": {
      "1996": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    }
  },
  "Plymouth": {
    "Breeze": {
      "1996": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Grand Voyager": {
      "1996": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "3.0L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "3.0L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Neon": {
      "1996": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3CB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3CB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Prowler": {
      "1997": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FB991-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": null,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": null,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": null,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Voyager": {
      "1996": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "2.4L I4": {
          "Message": null,
          "PID": "BF9FB993-C01FA019-FC000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BE3CB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    }
  },
  "Polestar": {
    "PS1": {
      "2020": {
        "2.0L I4 Twincharged Plug-In Hybrid": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "2.0L I4 Twincharged Plug-In Hybrid": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "PS2": {
      "2021": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2023": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2024": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "PS3": {
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "PS4": {
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    }
  },
  "Pontiac": {
    "Aztek": {
      "2001": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Bonneville": {
      "1996": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Firebird": {
      "1996": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFBD10-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFBD10-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB510-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB510-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB510-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB510-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBFB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "G3/Wave": {
      "2005": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB811-80000001-08080000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB813-801FE011-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "G5/Pursuit": {
      "2005": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "G6": {
      "2005": {
        "3.5L V6": {
          "Message": null,
          "PID": "BFBFB993-801FE019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.9L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.9L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.9L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.9L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "G8": {
      "2008": {
        "3.6L V6": {
          "Message": null,
          "PID": "BE1FA813-8007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BE1FA813-8007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.2L V8": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "GTO": {
      "2004": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "6.0L V8": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Grand Am": {
      "1996": {
        "2.4L I4": {
          "Message": null,
          "PID": "BFBFFD10-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.1L V6": {
          "Message": null,
          "PID": "BFBFFD10-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.1L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.1L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.4L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.4L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.4L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.4L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.4L V6": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.4L V6": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.4L V6": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Grand Prix": {
      "1996": {
        "3.1L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.1L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.1L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.1L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.1L V6": {
          "Message": null,
          "PID": "BE3FF810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FF810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.1L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.1L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.1L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FF813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3FF813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.8L V6": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Montana": {
      "1999": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.9L V6": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.9L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.9L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.9L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Solstice": {
      "2006": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Sunfire": {
      "1996": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Torrent": {
      "2006": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Trans-Sport": {
      "1996": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Vibe": {
      "2003": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "1.8L I4": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA811-90000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA811-90000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB813-8007E011-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB813-8007E011-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB813-8007E011-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    }
  },
  "Porsche": {
    "718 Boxster": {
      "2018": {
        "2.0L H4 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "2.0L H4 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "2.0L H4 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L H6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-FED08511-61080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-FED08511-61080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-FED08511-61080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-FED08511-61080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "718 Cayman": {
      "2018": {
        "2.0L H4 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "2.0L H4 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "2.0L H4 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "2.0L H4 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L H6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-FED08511-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-FED08511-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-FED08511-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-FED08511-63080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "718 Spyder": {
      "2020": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-FED08511-61080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "4.0L H6": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-FED08511-61080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-FED08511-61080001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "911": {
      "1996": {
        "3.6L H6": {
          "Message": null,
          "PID": "BF9FF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.6L H6 Twin Turbo": {
          "Message": null,
          "PID": "BF9FF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "3.6L H6": {
          "Message": null,
          "PID": "BF9FF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.6L H6 Twin Turbo": {
          "Message": null,
          "PID": "BF9FF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "3.6L H6": {
          "Message": null,
          "PID": "BF9FF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "3.4L H6": {
          "Message": null,
          "PID": "BF9FF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "3.4L H6": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "3.4L H6": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.6L H6 Twin Turbo": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "3.6L H6": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.6L H6 Twin Turbo": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "3.6L H6": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.6L H6 Twin Turbo": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "3.6L H6": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.6L H6 Twin Turbo": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "3.6L H6": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L H6": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "3.6L H6": {
          "Message": null,
          "PID": "BF9FE891-80001101-00000500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L H6": {
          "Message": null,
          "PID": "BF9FE891-80001101-00000500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "3.6L H6": {
          "Message": null,
          "PID": "BF9FE891-80001101-00000500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.6L H6 Twin Turbo": {
          "Message": null,
          "PID": "BF9FE891-80001101-00000500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L H6": {
          "Message": null,
          "PID": "BF9FE891-80001101-00000500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "3.6L H6": {
          "Message": null,
          "PID": "BF9FE891-80001101-00000500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.6L H6 Twin Turbo": {
          "Message": null,
          "PID": "BF9FE891-80001101-00000500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L H6": {
          "Message": null,
          "PID": "BF9FE891-80001101-00000500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "3.6L H6": {
          "Message": null,
          "PID": "BF9FA893-A007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.6L H6 Twin Turbo": {
          "Message": null,
          "PID": "BF9FA893-A007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L H6": {
          "Message": null,
          "PID": "BF9FA893-A007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "3.6L H6": {
          "Message": null,
          "PID": "BF9FA893-A007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L H6": {
          "Message": null,
          "PID": "BF9FA893-A007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L H6 Twin Turbo": {
          "Message": null,
          "PID": "BF9FA893-A007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "3.6L H6": {
          "Message": null,
          "PID": "BF9FE893-8007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.6L H6 Twin Turbo": {
          "Message": null,
          "PID": "BF9FE893-8007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L H6": {
          "Message": null,
          "PID": "BF9FE893-8007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L H6 Twin Turbo": {
          "Message": null,
          "PID": "BF9FE893-8007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L H6": {
          "Message": null,
          "PID": "BF9FE893-8007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "3.4L H6": {
          "Message": null,
          "PID": "BFBEE893-A007B119-FEDC0500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.6L H6": {
          "Message": null,
          "PID": "BFBEE893-A007B119-FEDC0500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L H6": {
          "Message": null,
          "PID": "BFBEE893-A007B119-FEDC0500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L H6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEE893-A007B119-FEDC0500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "3.4L H6": {
          "Message": null,
          "PID": "BE3FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L H6": {
          "Message": null,
          "PID": "BE3FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L H6 Twin Turbo": {
          "Message": null,
          "PID": "BE3FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "3.4L H6": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L H6": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L H6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "3.4L H6": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L H6": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L H6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "3.4L H6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L H6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L H6 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L H6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "3.0L H6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED48511-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.4L H6": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED48511-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L H6": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED48511-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L H6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED48511-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "3.0L H6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED48511-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L H6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED48511-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L H6": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED48511-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "3.0L H6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEE893-8005B119-FED38501-00080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L H6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEE893-8005B119-FED38501-00080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L H6": {
          "Message": null,
          "PID": "BFBEE893-8005B119-FED38501-00080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "3.0L H6 Twin Turbo": {
          "Message": null,
          "PID": "BFBCA893-8007B119-FED08511-61090201-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "3.0L H6 Twin Turbo": {
          "Message": null,
          "PID": "BFBCA893-8007B119-FED08511-61090201-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L H6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEE893-8005B119-FED38501-00080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-FED08511-63090201-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-FED08511-63090201-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-FED08511-63090201-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-FED08511-63090201-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "918": {
      "2015": {
        "4.6L V8 Hybrid": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Boxster": {
      "1997": {
        "2.5L H6": {
          "Message": null,
          "PID": "BF9FF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "2.5L H6": {
          "Message": null,
          "PID": "BF9FF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "2.5L H6": {
          "Message": null,
          "PID": "BF9FF980-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "2.7L H6": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L H6": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "2.7L H6": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L H6": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "2.7L H6": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L H6": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "2.7L H6": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L H6": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "2.7L H6": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L H6": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "2.7L H6": {
          "Message": null,
          "PID": "BF9FE891-80001101-00000500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L H6": {
          "Message": null,
          "PID": "BF9FE891-80001101-00000500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "2.7L H6": {
          "Message": null,
          "PID": "BF9FE891-80001101-00000500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L H6": {
          "Message": null,
          "PID": "BF9FE891-80001101-00000500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "2.7L H6": {
          "Message": null,
          "PID": "BF9FE891-80001101-00000500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.4L H6": {
          "Message": null,
          "PID": "BF9FE891-80001101-00000500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "2.7L H6": {
          "Message": null,
          "PID": "BF9FE891-80001101-40000500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.4L H6": {
          "Message": null,
          "PID": "BF9FE891-80001101-40000500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "2.9L H6": {
          "Message": null,
          "PID": "BF9FA893-A005B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.4L H6": {
          "Message": null,
          "PID": "BF9FA893-A005B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "2.9L H6": {
          "Message": null,
          "PID": "BF9FA893-A007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.4L H6": {
          "Message": null,
          "PID": "BF9FA893-A007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "2.9L H6": {
          "Message": null,
          "PID": "BF9FE893-8007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.4L H6": {
          "Message": null,
          "PID": "BF9FE893-8007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "2.9L H6": {
          "Message": null,
          "PID": "BF9FE893-8007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.4L H6": {
          "Message": null,
          "PID": "BF9FE893-8007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "2.7L H6": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.4L H6": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "2.7L H6": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.4L H6": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "2.7L H6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.4L H6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "2.7L H6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.4L H6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L H6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "2.0L H4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Carrera GT": {
      "2004": {
        "5.7L V10": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "5.7L V10": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "5.7L V10": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Cayenne": {
      "2003": {
        "4.5L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "3.2L V6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.5L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "3.2L V6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.5L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "3.2L V6": {
          "Message": null,
          "PID": "BF9FE891-80001101-C0000500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.5L V8": {
          "Message": null,
          "PID": "BF9FE891-80001101-C0000500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.5L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9FE891-80001101-C0000500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-A005B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BF9FA893-A005B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9FA893-A005B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "3.6L V6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.8L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "3.6L V6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.8L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "3.0L V6 Supercharged Hybrid": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.6L V6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.8L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "3.0L V6 Supercharged Hybrid": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.6L V6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.8L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "3.0L V6 Supercharged Hybrid": {
          "Message": null,
          "PID": "981BA013-9001A015-CCD2801D-EAA98143-E9220000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "981BA013-9001A015-CCD2801D-EAA98143-E9220000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.6L V6": {
          "Message": null,
          "PID": "981BA013-9001A015-CCD2801D-EAA98143-E9220000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.8L V8": {
          "Message": null,
          "PID": "981BA013-9001A015-CCD2801D-EAA98143-E9220000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "981BA013-9001A015-CCD2801D-EAA98143-E9220000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "3.0L V6 Supercharged Hybrid": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.6L V6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.8L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "3.0L V6 Supercharged Hybrid": {
          "Message": null,
          "PID": "BF9CE893-A005B119-FED08521-03030000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "BF9CE893-A005B119-FED08521-03030000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.6L V6 Twin Turbo": {
          "Message": null,
          "PID": "BF9CE893-A005B119-FED08521-03030000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9CE893-A005B119-FED08521-03030000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "3.0L V6 Supercharged Hybrid": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.6L V6 Twin Turbo": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "3.0L V6 Supercharged Hybrid": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.6L V6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.6L V6 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "3.0L V6 Supercharged Hybrid": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.6L V6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.6L V6 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "2.9L V6 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo Hybrid": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "2.9L V6 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo Hybrid": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L V8 Twin Turbo Hybrid": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "2.9L V6 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08505-63190201-020C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08505-63190201-020C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08505-63190201-020C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08505-63190201-020C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Cayman": {
      "2006": {
        "3.4L H6": {
          "Message": null,
          "PID": "BF9FE891-80001101-00000500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "2.7L H6": {
          "Message": null,
          "PID": "BF9FE891-80001101-00000500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.4L H6": {
          "Message": null,
          "PID": "BF9FE891-80001101-00000500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "2.7L H6": {
          "Message": null,
          "PID": "BF9FE891-80001101-00000500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.4L H6": {
          "Message": null,
          "PID": "BF9FE891-80001101-00000500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "2.9L H6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.4L H6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "2.9L H6": {
          "Message": null,
          "PID": "BF9FE893-8007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.4L H6": {
          "Message": null,
          "PID": "BF9FE893-8007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "2.9L H6": {
          "Message": null,
          "PID": "BF9FA893-A007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.4L H6": {
          "Message": null,
          "PID": "BF9FA893-A007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "2.9L H6": {
          "Message": null,
          "PID": "BF9FA893-A007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.4L H6": {
          "Message": null,
          "PID": "BF9FA893-A007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "2.7L H6": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.4L H6": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "2.7L H6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.4L H6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L H6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "2.7L H6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.4L H6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.8L H6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "2.0L H4 Turbo": {
          "Message": null,
          "PID": "BFBEA813-A007B111-FED08511-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BFBEA813-A007B111-FED08511-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Macan": {
      "2015": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEE893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.6L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEE893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.6L V6 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BFBEE893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEE893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.6L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEE893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BFBEE893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEE893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.6L V6 Twin Turbo": {
          "Message": null,
          "PID": "BFBEE893-A007B119-FED08500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-68010001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-68010001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.9L V6 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.9L V6 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBCA893-8007B119-FED08505-63090201-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFBCA893-8007B119-FED08505-63090201-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFBCA893-8007B119-FED08505-63090201-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFBCA893-8007B119-FED08505-63090201-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Panamera": {
      "2010": {
        "4.8L V8": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "BFBEA893-A007B119-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "3.0L V6 Supercharged Hybrid": {
          "Message": null,
          "PID": "BF9CE893-A005B119-FED38501-03030200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9CE893-A005B119-FED38501-03030200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BF9CE893-A005B119-FED38501-03030200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9CE893-A005B119-FED38501-03030200-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "3.0L V6 Supercharged Hybrid": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.6L V6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.8L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "3.0L V6 Supercharged Hybrid": {
          "Message": null,
          "PID": "BF9CE893-A007B119-FED08521-03030000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BF9CE893-A007B119-FED08521-03030000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9CE893-A007B119-FED08521-03030000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BF9CE893-A007B119-FED08521-03030000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "BF9CE893-A007B119-FED08521-03030000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "3.0L V6 Supercharged Hybrid": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.8L V8": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "3.0L V6 Supercharged Hybrid": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.6L V6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.8L V8": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.8L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "2.9L V6 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L V8 Twin Turbo Hybrid": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "2.9L V6 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.9L V6 Twin Turbo Hybrid": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L V8 Twin Turbo Hybrid": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "2.9L V6 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.9L V6 Twin Turbo Hybrid": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L V8 Twin Turbo Hybrid": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "2.9L V6 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.9L V6 Twin Turbo Hybrid": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L V8 Twin Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.0L V8 Twin Turbo Hybrid": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08505-61190201-020C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08505-61190201-020C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08505-61190201-020C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08505-61190201-020C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BF9CA893-8007B119-F7C08505-61190201-020C000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Taycan": {
      "2020": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2021": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2022": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2023": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2024": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    }
  },
  "RAM": {
    "1500": {
      "2013": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFFEB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB997-801FE019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFFEB997-801FE019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFFEB997-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "98392013-9001A011-C4C2801D-E9EBA343-E9A20000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "98392013-9001A011-C4C2801D-E9EBA343-E9A20000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFFEB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFFEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "98392013-9001A011-C4C2801D-E9EBA343-E9220000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFFEB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFFEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "9839207F-BA01A07D-C4C2807D-E9EBA37F-FBA2007C",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFFEB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFFEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "98392013-9001A011-C4C2801D-E9EBA343-E9A20000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFFEB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFFEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.6L V6 Mild Hybrid": {
          "Message": null,
          "PID": "BFFEB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6 Mild Hybrid": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08001-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6 Mild Hybrid": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "1500 Classic": {
      "2019": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "98392013-9001A011-C4C2801D-E9EBA343-E9A20021",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFFEB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.6L V6": {
          "Message": null,
          "PID": "98392013-9001A011-C4C2801D-E9EBA343-E9A20021",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "98392013-9001A011-C4C2801D-E9EBA343-E9A20021",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "3.6L V6": {
          "Message": null,
          "PID": "98392013-9001A011-C4C2801D-E9EBA343-E9A20021",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "98392013-9001A011-C4C2801D-E9EBA343-E9A20021",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "2500": {
      "2012": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB997-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981B0013-8003A001-C4CC004D-F8B9BB43-EBE44100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-00200000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981B0013-8003A001-C4CC004D-F8B9BB43-EBE44100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-EF07E03B-FFD0802A-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-00200000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981B0013-8003A001-C4CC804D-F8B9BB43-EBE44100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-00200000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981B0013-8003A001-C4CC804D-F8B9BB43-EBE44100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-00200000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981B0013-8003A001-C4CC804D-F8B9BB43-EBE64100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-00200000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981B0013-8003A001-C4CC804D-F8B9BB43-EBE64100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "6.4L V8": {
          "Message": null,
          "PID": "BE3DB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981B0013-8003A001-C4CC8049-F8B9BB43-EBE6412D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "6.4L V8": {
          "Message": null,
          "PID": "BE3DB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "BE3DB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "6.4L V8": {
          "Message": null,
          "PID": "BE3DB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "BE3DB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "3500": {
      "2011": {
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "983B8017-A01BA015-CC9C8007-5BFE5FFF-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981B0013-8003A001-C4CC004D-F8B9B94F-EBE44100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981B0013-8003A001-C4CC004D-F8B9BB43-EBE44100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "5.7L V8": {
          "Message": null,
          "PID": "981B0013-8003A001-C4CC004D-F8B9BB43-EBE44100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-00200000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981B0013-8003A001-C4CC004D-F8B9BB43-EBE44100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-00200000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-00200000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981B0013-8003A001-C4CC804D-F8B9BB43-EBE64100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-00200000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981B0013-8003A001-C4CC804D-F8B9BB43-EBE44100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "5.7L V8": {
          "Message": null,
          "PID": "981B0013-8003A001-C4CC804D-F8B9BB43-EBE64100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "981B0013-8003A001-C4CC804D-F8B9BB43-EBE64100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981B0013-8003A001-C4CC804D-F8B9BB43-EBE64100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "5.7L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-00200000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981B0013-8003A001-C4CC804D-F8B9BB43-EBE64100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "6.4L V8": {
          "Message": null,
          "PID": "BE3DB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981B0013-8003A001-C4CC8049-F8B9BB43-EBE6412D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "6.4L V8": {
          "Message": null,
          "PID": "BE3DB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "BE3DB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "6.4L V8": {
          "Message": null,
          "PID": "BE3DB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "BE3DB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "4500/5500": {
      "2012": {
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981B0013-8003A001-C4CC004D-F8B9B94F-EBE44100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981B0013-8003A001-C4CC004D-F8B9B94F-EBE44100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB997-801FE019-FED08005-00200002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981B0013-8003A001-C4CC004D-F8B9B94F-EBE44100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08005-00200002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981B0013-8003A001-C4CC804D-F8B9B94F-EBE44100",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08001-00200000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981B0013-8003A001-C4CC804D-F8B9B94F-EBE64120",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981B0013-8003A001-C4CC804D-F8B9B94F-EBE64120",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "6.4L V8": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08005-00200002-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981B0013-8003A001-C4CC804D-F8B9B94F-EBE64125",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "6.4L V8": {
          "Message": null,
          "PID": "981B0013-8003A001-C4CC8049-F8B9B94F-EBE6412D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981B0013-8003A001-C4CC8049-F8B9B94F-EBE6412D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "6.4L V8": {
          "Message": null,
          "PID": "981B0013-8003A001-C4CC8049-F8B9B94F-EBE6412D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981B0013-8003A001-C4CC8049-F8B9B94F-EBE6412D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "6.7L I6 Turbo Diesel": {
          "Message": null,
          "PID": "981B0013-8003A001-C4CC8049-F8B9B94F-EBE6412D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "CV": {
      "2012": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007A019-FED0C000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Dakota": {
      "2011": {
        "3.7L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Promaster": {
      "2014": {
        "3.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "9839A013-9003A011-C4C2800D-E9EB8343-E9220000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "3.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "9839A013-9003A011-C4C2800D-E9EB8343-E9220000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "3.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "9839A013-9003A011-C4C2800D-E9EB8343-E9220000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "3.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "9839A013-9003A011-C4C2800D-E9EB8343-E9220000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08005-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08005-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08005-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFBEB993-801FE019-FED08005-60200001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": false,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Promaster City": {
      "2015": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE7EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE7EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE7EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE7EA813-8007F011-FED08000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE7EA813-8007F011-FED08005-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    }
  },
  "Rivian": {
    "All": {
      "2022": {
        "All": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    }
  },
  "Rolls Royce": {
    "Corniche": {
      "2001": {
        "6.75L V8 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "6.75L V8 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Cullinan": {
      "2019": {
        "6.75L V12 Twin Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "6.75L V12 Twin Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "6.75L V12 Twin Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Dawn": {
      "2016": {
        "6.6L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "6.6L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "6.6L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08511-67000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "6.6L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08511-67000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "6.6L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08511-67000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "6.6L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08511-67000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Ghost": {
      "2010": {
        "6.6L V12 Twin Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "6.6L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "6.6L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "6.6L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "6.6L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "6.6L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "6.6L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "6.6L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "6.6L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08511-67000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "6.6L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08511-67000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "6.6L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08511-67000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "6.6L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08511-67000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Park Ward": {
      "2001": {
        "5.4L V12": {
          "Message": null,
          "PID": "BF9FF991-80000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "5.4L V12": {
          "Message": null,
          "PID": "BF9FF991-80000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Phantom": {
      "2004": {
        "6.75L V12": {
          "Message": null,
          "PID": "BF9FE891-20001101-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "6.75L V12": {
          "Message": null,
          "PID": "BF9FE891-20001101-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "6.75L V12": {
          "Message": null,
          "PID": "BF9FE891-20001101-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "6.75L V12": {
          "Message": null,
          "PID": "BF9FE891-20001101-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "6.75L V12": {
          "Message": null,
          "PID": "BF9FE891-20001101-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "6.75L V12": {
          "Message": null,
          "PID": "BF9FE891-20001101-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "6.75L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "6.75L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "6.75L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "6.75L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "6.75L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "6.75L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "6.75L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "6.75L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": null,
              "Airbags and Restraints": null,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "6.75L V12 Twin Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "6.75L V12 Twin Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "6.75L V12 Twin Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Phantom Coupe": {
      "2009": {
        "6.75L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "6.75L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "6.75L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "6.75L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "6.75L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "6.75L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "6.75L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "6.75L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Phantom Drophead Coupe": {
      "2008": {
        "6.75L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "6.75L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "6.75L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "6.75L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "6.75L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "6.75L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "6.75L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "6.75L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "6.75L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "6.75L V12": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Silver Seraph": {
      "2000": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "5.4L V12": {
          "Message": null,
          "PID": "BF9FF991-80000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "5.4L V12": {
          "Message": null,
          "PID": "BF9FF991-80000001-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Silver Spur": {
      "1997": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Spectre": {
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Wraith": {
      "2014": {
        "6.6L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "6.6L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "6.6L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "6.6L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B11F-FED08F00-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "6.6L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08511-67000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "6.6L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08511-67000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "6.6L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08511-67000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "6.6L V12 Twin Turbo": {
          "Message": null,
          "PID": "BFBFA893-A007B119-FED08511-67000001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    }
  },
  "Saab": {
    "9-2X": {
      "2005": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA811-10001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA811-10001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA811-10000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FA811-10000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "9-3": {
      "1999": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EB811-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3EB811-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FF811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2004": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.8L V6 Turbo": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.8L V6 Turbo": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.8L V6 Turbo": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.8L V6 Turbo": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "9-4X": {
      "2011": {
        "2.8L V6 Turbo": {
          "Message": null,
          "PID": "BE5FF813-8007E011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE5FF813-8007E011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "9-5": {
      "1999": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6 Turbo": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB813-8007E001-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB813-8007E001-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "2.8L V6 Turbo": {
          "Message": null,
          "PID": "BE5FF813-8007E011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L V6 Turbo": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "9-7X": {
      "2005": {
        "4.2L I6": {
          "Message": null,
          "PID": "BE3EF811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3EF811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "4.2L I6": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "4.2L I6": {
          "Message": null,
          "PID": "BE3FF811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3FF811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "4.2L I6": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "4.2L I6": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.3L V8": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L V8": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "900": {
      "1996": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EB811-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.3L I4": {
          "Message": null,
          "PID": "BE3EB811-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE3EB811-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EB811-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.3L I4": {
          "Message": null,
          "PID": "BE3EB811-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L V6": {
          "Message": null,
          "PID": "BE3EB811-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.8L V6 Turbo": {
          "Message": null,
          "PID": "BE3EB811-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EB811-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.3L I4": {
          "Message": null,
          "PID": "BE3EB811-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.8L V6 Turbo": {
          "Message": null,
          "PID": "BE3EB811-00000001-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "9000": {
      "1996": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "2.3L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    }
  },
  "Saturn": {
    "Astra": {
      "2008": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB813-8007E011-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB813-8007E011-FEDC0C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Aura": {
      "2007": {
        "2.4L I4 BAS Hybrid": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4 BAS Hybrid": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4 BAS Hybrid": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE3FF813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Ion": {
      "2003": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.2L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.2L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.2L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.2L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "L-Series": {
      "2000": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EF811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE3EF811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FA891-00001100-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Outlook": {
      "2007": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBFB993-8007E019-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFDFB993-A007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Relay": {
      "2005": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.9L V6": {
          "Message": null,
          "PID": "BE3FB813-801FE011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.9L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "S-Series": {
      "1996": {
        "1.9L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": null
        }
      },
      "1997": {
        "1.9L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": null
        }
      },
      "1998": {
        "1.9L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": null
        }
      },
      "1999": {
        "1.9L I4": {
          "Message": null,
          "PID": "BE3EF810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false,
          "Systems": null
        }
      },
      "2000": {
        "1.9L I4": {
          "Message": null,
          "PID": "BE3EF810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "1.9L I4": {
          "Message": null,
          "PID": "BE3EF810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "1.9L I4": {
          "Message": null,
          "PID": "BE3EF810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Sky": {
      "2007": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FA813-A007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Vue": {
      "2002": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE3EB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I4 BAS Hybrid": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4 BAS Hybrid": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4 BAS Hybrid": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE7FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED04000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": false,
              "Doors and Windows": false,
              "Driver Assist and Active Safety": false,
              "Driver Information and Control": false,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": false,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": false,
              "Security & Keyless Entry": false,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    }
  },
  "Scion": {
    "FR-S": {
      "2013": {
        "2.0L H4": {
          "Message": null,
          "PID": "BE3FA813-B007B011-FEDC8041-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L H4": {
          "Message": null,
          "PID": "BE3FA813-B007B011-FEDC8041-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L H4": {
          "Message": null,
          "PID": "BE3FA813-B007B011-FEDC8041-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L H4": {
          "Message": null,
          "PID": "BE3FA813-9007B011-FEDCA051-08080001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "iA": {
      "2016": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDCA000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "iM": {
      "2016": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "iQ": {
      "2012": {
        "1.3L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.3L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2014": {
        "1.3L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.3L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "tC": {
      "2005": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B001-5ADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "xA": {
      "2004": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "xB": {
      "2004": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FB813-8005A015-F80C2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-7ADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "xD": {
      "2008": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    }
  },
  "Smart": {
    "ForTwo": {
      "2005": {
        "0.8L I3 Turbo Diesel": {
          "Message": null,
          "PID": "BE3DB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "0.8L I3 Turbo Diesel": {
          "Message": null,
          "PID": "983A0011-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "1.0L I3": {
          "Message": null,
          "PID": "BE3EE813-8007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "1.0L I3": {
          "Message": null,
          "PID": "BE3EE813-8007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "1.0L I3": {
          "Message": null,
          "PID": "BE3EE813-8007F011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "1.0L I3": {
          "Message": null,
          "PID": "BE3EE813-8007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3EE813-8007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2012": {
        "1.0L I3": {
          "Message": null,
          "PID": "BE3EE813-8007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.0L I3": {
          "Message": null,
          "PID": "BE3EE813-8007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3EE813-8007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2014": {
        "1.0L I3": {
          "Message": null,
          "PID": "BE3EE813-8007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3EE813-8007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2015": {
        "1.0L I3": {
          "Message": null,
          "PID": "BE3EE813-8007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3EE813-8007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2016": {
        "0.9L I3 Turbo": {
          "Message": null,
          "PID": "BE3EE813-8007F011-FFD08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "1.0L I3": {
          "Message": null,
          "PID": "BE3EE813-8007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3EE813-8007F011-FED00400-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2017": {
        "0.9L I3 Turbo": {
          "Message": null,
          "PID": "BE3EE813-8007F011-FFD08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "1.0L I3": {
          "Message": null,
          "PID": "BE3EE813-8007F011-FFD08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3EE813-8007F011-FFD08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2018": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3EE813-8007F011-FFD08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2019": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": "BE3EE813-8007F011-FFD08401-01000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    }
  },
  "Sterling": {
    "All": {
      "1996": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    }
  },
  "Subaru": {
    "Ascent": {
      "2019": {
        "2.4L H4 Turbo": {
          "Message": null,
          "PID": "BE3DA813-901FB011-FEDCA051-09080000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.4L H4 Turbo": {
          "Message": null,
          "PID": "BE3DA813-901FB011-FEDCA051-09080000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.4L H4 Turbo": {
          "Message": null,
          "PID": "BE3DA813-901FB011-FEDCA051-09080000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE1DA813-901FB011-FEDCA051-69084001-0204000D",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE1DA813-901FB011-FEDCA051-69084001-0204000D",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE1DA813-901FB011-FEDCA051-69084001-0204000D",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE1DA813-901FB011-FEDCA051-69084001-0204000D",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "BRZ": {
      "2013": {
        "2.0L H4": {
          "Message": null,
          "PID": "BE3FA813-B007B011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L H4": {
          "Message": null,
          "PID": "BE3FA813-B007B011-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L H4": {
          "Message": null,
          "PID": "BE3FA813-B007B011-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L H4": {
          "Message": null,
          "PID": "BE3FA813-9007B011-FEDCA051-08080001-00000002",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-08080000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L H4": {
          "Message": null,
          "PID": "BE3FA813-9007B011-FEDC8051-08080001-00000002",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L H4": {
          "Message": null,
          "PID": "BE3FA813-9007B011-FEDC8051-08080001-00000002",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Baja": {
      "2003": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA811-10000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3EA811-10000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3EA811-10000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3EA811-10000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3EA811-10000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA811-10000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FA811-10000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Crosstrek": {
      "2013": {
        "2.0L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L H4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA071-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L H4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA071-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L H4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA071-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-08080000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-68080001-0004000D",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L H4 Hybrid": {
          "Message": null,
          "PID": "98188013-80018001-C00C0000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-68080001-0004000D",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L H4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-68080001-0004000D",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.0L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-68080001-0004000D",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L H4": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-68080001-0004000D",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-68080001-0004000D",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-68080001-0004000D",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-68080001-0004000D",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Forester": {
      "1998": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3DB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3DB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA811-10000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA811-10000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3EA811-10000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3EA811-10000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA811-90001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FA811-90001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA811-90001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FE811-10001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FF011-FEDC8040-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-9007F011-FEDC8040-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FF011-FEDC8040-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FF011-FEDC8040-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-9007F011-FEDC8040-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FF011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-9007F011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-9007F011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-9007F011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-9007B011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "2.0L H4 Turbo": {
          "Message": null,
          "PID": "BE3DA813-901FB011-FEDCA051-09080000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L H4 Turbo": {
          "Message": null,
          "PID": "BE3DA813-901FB011-FEDCA051-09080000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L H4 Turbo": {
          "Message": null,
          "PID": "BE3DA813-901FB011-FEDCA051-09080000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L H4 Turbo": {
          "Message": null,
          "PID": "BE3DA813-901FB011-FEDCA051-09080000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L H4 Turbo": {
          "Message": null,
          "PID": "BE3DA813-901FB011-FEDCA051-09080000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-0A080000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-0A080000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-0A080000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-901FF011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-901FF011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-901FF011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-901FF011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Impreza": {
      "1996": {
        "1.8L H4": {
          "Message": null,
          "PID": "BE3DB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.2L H4": {
          "Message": null,
          "PID": "BE3DB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "1.8L H4": {
          "Message": null,
          "PID": "BE3DB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.2L H4": {
          "Message": null,
          "PID": "BE3DB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "2.2L H4": {
          "Message": null,
          "PID": "BE3DB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L H4": {
          "Message": null,
          "PID": "BE3DB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.2L H4": {
          "Message": null,
          "PID": "BE3FA811-10000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA811-10000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.2L H4": {
          "Message": null,
          "PID": "BE3FA811-10000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA811-10000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.2L H4": {
          "Message": null,
          "PID": "BE3FA811-10000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA811-10000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA811-10000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA811-10000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.5L H4": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA811-90001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA811-90001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA811-10001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FF011-FEDC8040-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FF011-FEDC8040-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FF011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FF011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "2.0L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "2.0L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "2.0L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-08080000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-08080000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-68080001-0004000D",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-68080001-0004000D",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.0L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-68080001-0004000D",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-68080001-0004000D",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-68080001-0004000D",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-68080001-0004000D",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-68080001-0004000D",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Legacy": {
      "1996": {
        "2.2L H4": {
          "Message": null,
          "PID": "BE3DB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L H4": {
          "Message": null,
          "PID": "BE3DB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "2.2L H4": {
          "Message": null,
          "PID": "BE3DB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L H4": {
          "Message": null,
          "PID": "BE3DB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "2.2L H4": {
          "Message": null,
          "PID": "BE3DB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L H4": {
          "Message": null,
          "PID": "BE3DB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.2L H4": {
          "Message": null,
          "PID": "BE3DB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L H4": {
          "Message": null,
          "PID": "BE3DB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA811-10000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.5L H4": {
          "Message": null,
          "PID": "BFBEB990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA811-10000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA811-10000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.5L H4": {
          "Message": null,
          "PID": "BFBFAC91-11001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FA811-10001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA811-90001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FA811-10001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FF011-FEDC8040-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-9007F011-FEDC8040-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.5L H4": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-9007F011-FEDC8040-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L H6": {
          "Message": null,
          "PID": "BFBFA893-911FF119-FEDC8040-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FF011-FEDC8040-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-9007F011-FEDC8040-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L H6": {
          "Message": null,
          "PID": "BFBFA893-911FF119-FEDC8040-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FF011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-9007F011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L H6": {
          "Message": null,
          "PID": "BFBFA893-911FF119-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FF011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-9007F011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L H6": {
          "Message": null,
          "PID": "BFBFA893-911FF119-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FF011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-9007B011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L H6": {
          "Message": null,
          "PID": "BFBFA893-911FF119-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L H6": {
          "Message": null,
          "PID": "BFBFA893-911FB119-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L H6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L H6": {
          "Message": null,
          "PID": "BFBFA893-911FB119-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L H6": {
          "Message": null,
          "PID": "BFBFA893-911FB119-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L H6": {
          "Message": null,
          "PID": "BFBFA893-911FB119-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L H6": {
          "Message": null,
          "PID": "BFBFA893-911FB119-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L H6": {
          "Message": null,
          "PID": "BFBFA893-911FB119-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.4L H4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.4L H4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-6A080001-0004000D",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-6A080001-0004000D",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-6A080001-0004000D",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-6A080001-0004000D",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Outback": {
      "2000": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA811-10000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA811-10000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L H6": {
          "Message": null,
          "PID": "BE3FA811-10000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L H6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA811-10000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L H6": {
          "Message": null,
          "PID": "BE3FA811-10000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA811-10000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L H6": {
          "Message": null,
          "PID": "BE3FA811-10000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.5L H4": {
          "Message": null,
          "PID": "BFBFAC91-91001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FA811-90001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L H6": {
          "Message": null,
          "PID": "BFBFA891-91001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA811-90001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FA811-90001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L H6": {
          "Message": null,
          "PID": "BFBFA891-91001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FF011-FEDC8040-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-9007F011-FEDC8040-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L H6": {
          "Message": null,
          "PID": "BFBFA893-9107F119-FEDC8040-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FF011-FEDC8040-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-9007F011-FEDC8040-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L H6": {
          "Message": null,
          "PID": "BFBFA893-911FF119-FEDC8040-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FF011-FEDC8040-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-9007F011-FEDC8040-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L H6": {
          "Message": null,
          "PID": "BFBFA893-911FF119-FEDC8040-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FF011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L H6": {
          "Message": null,
          "PID": "BFBFA893-911FF119-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FF011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L H6": {
          "Message": null,
          "PID": "BFBFA893-911FF119-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FF011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L H6": {
          "Message": null,
          "PID": "BFBFA893-911FF119-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L H6": {
          "Message": null,
          "PID": "BFBFA893-911FB119-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L H6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L H6": {
          "Message": null,
          "PID": "BFBFA893-911FB119-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L H6": {
          "Message": null,
          "PID": "BFBFA893-911FB119-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L H6": {
          "Message": null,
          "PID": "BFBFA893-911FB119-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L H6": {
          "Message": null,
          "PID": "BFBFA893-911FB119-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L H6": {
          "Message": null,
          "PID": "BFBFA893-911FB119-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.4L H4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.4L H4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L H4": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE1DA813-901FB011-FEDCA051-69084001-0204000D",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE1DA813-901FB011-FEDCA051-69084001-0204000D",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE1DA813-901FB011-FEDCA051-69084001-0204000D",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE1DA813-901FB011-FEDCA051-69084001-0204000D",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "SVX": {
      "1996": {
        "3.3L H6": {
          "Message": null,
          "PID": "BFBDB910-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.3L H6": {
          "Message": null,
          "PID": "BFBDB910-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Solterra": {
      "2023": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Tribeca": {
      "2006": {
        "3.0L H6": {
          "Message": null,
          "PID": "BFBFA891-91001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.0L H6": {
          "Message": null,
          "PID": "BFBFA893-9107F119-FEDC8040-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.6L H6": {
          "Message": null,
          "PID": "BFBFA893-911FF119-FEDC8040-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.6L H6": {
          "Message": null,
          "PID": "BFBFA893-911FF119-FEDC8040-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "3.6L H6": {
          "Message": null,
          "PID": "BFBFA893-911FF119-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "3.6L H6": {
          "Message": null,
          "PID": "BFBFA893-911FF119-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "3.6L H6": {
          "Message": null,
          "PID": "BFBFA893-911FF119-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "3.6L H6": {
          "Message": null,
          "PID": "BFBFA893-911FB119-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.6L H6": {
          "Message": null,
          "PID": "BFBEB991-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": false,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "WRX/STI": {
      "2002": {
        "2.0L H4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.0L H4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.0L H4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.0L H4 Turbo": {
          "Message": null,
          "PID": "BE3FA811-10001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FA811-10001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FE811-10001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FE811-10001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-9007F011-FEDC8040-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-9007F011-FEDC8040-00000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-9007F011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-9007F011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-9007B011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-9007B011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-9007B011-FEDC8041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "2.0L H4 Turbo": {
          "Message": null,
          "PID": "BE3DA813-901FB011-FEDCA051-09080000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-9007B011-FEDCA041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L H4 Turbo": {
          "Message": null,
          "PID": "BE3DA813-901FB011-FEDCA051-09080000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-9007B011-FEDCA041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L H4 Turbo": {
          "Message": null,
          "PID": "BE3DA813-901FB011-FEDCA051-09080000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-9007B011-FEDCA041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L H4 Turbo": {
          "Message": null,
          "PID": "BE3DA813-901FB011-FEDCA051-09080000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-9007B011-FEDCA041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L H4 Turbo": {
          "Message": null,
          "PID": "BE3DA813-901FB011-FEDCA051-09080000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-9007B011-FEDCA041-08000000-00000000",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L H4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L H4 Turbo": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-68080001-0004000D",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-68080001-0004000D",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-68080001-0004000D",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-68080001-0004000D",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-901FB011-FEDCA051-68080001-0004000D",
          "Restrictions": [
            "United States"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    }
  },
  "Suzuki": {
    "Aerio": {
      "2002": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "2.3L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Equator": {
      "2009": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "2.5L I4": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9007E011-FADC8000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9107E019-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Esteem": {
      "1996": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Forenza": {
      "2004": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB811-80000001-08080000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB811-80000001-08080000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-801FE011-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Grand Vitara": {
      "1999": {
        "2.5L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "2.5L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "2.5L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "2.5L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "2.5L V6": {
          "Message": null,
          "PID": "BFBFB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "2.5L V6": {
          "Message": null,
          "PID": "BFBFB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "2.5L V6": {
          "Message": null,
          "PID": "BFBFB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "2.7L V6": {
          "Message": null,
          "PID": "BFBFA891-80001100-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "2.7L V6": {
          "Message": null,
          "PID": "BFBFA891-80001100-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "2.7L V6": {
          "Message": null,
          "PID": "BFBFA891-80001100-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "2.4L I4": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA813-8007F001-FAD00800-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BE1FA813-8007F001-FAD00800-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA813-8007F001-FAD00800-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA813-8007F001-FAD00800-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA813-8007F001-FAD08800-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Kizashi": {
      "2010": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA813-8007F001-FAD00800-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA813-8007F001-FAD00800-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA813-8007F001-FAD00800-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA813-8007F001-FAD00800-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Reno": {
      "2005": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB811-80000001-08080000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "SX4": {
      "2007": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-8007F001-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-8007F001-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-8007F001-FAD00800-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-8007F001-FAD00800-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-8007F001-FAD00800-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-8007F001-FAD00800-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FA813-8007F001-FAD08800-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Sidekick": {
      "1996": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Swift": {
      "1996": {
        "1.3L I4": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "1.3L I4": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "1.3L I4": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "1.3L I4": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "1.3L I4": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "1.3L I4": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB811-C0000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB811-C0000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "1.6L I4": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "1.6L I4": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "1.6L I4": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Swift+": {
      "2004": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB811-C0000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB811-80000001-08080000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB813-8007E011-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB813-801FE011-FAD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3FB813-8007E011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Verona": {
      "2004": {
        "2.5L I6": {
          "Message": null,
          "PID": "BFBFB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "2.5L I6": {
          "Message": null,
          "PID": "BFBFB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "2.5L I6": {
          "Message": null,
          "PID": "BFBFB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Vitara": {
      "1999": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "2.0L I4": {
          "Message": null,
          "PID": "BFBEB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "2.5L V6": {
          "Message": null,
          "PID": "BFBFB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "X-90": {
      "1996": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "XL7": {
      "2001": {
        "2.7L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "2.7L V6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "2.7L V6": {
          "Message": null,
          "PID": "BFBFB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "2.7L V6": {
          "Message": null,
          "PID": "BFBFB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "2.7L V6": {
          "Message": null,
          "PID": "BFBFB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "2.7L V6": {
          "Message": null,
          "PID": "BFBFA891-80001100-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FB993-8007E019-FED00500-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    }
  },
  "Tesla": {
    "All": {
      "2010": {
        "All": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2011": {
        "All": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2012": {
        "All": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2013": {
        "All": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2014": {
        "All": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2015": {
        "All": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2016": {
        "All": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2017": {
        "All": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2018": {
        "All": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2019": {
        "All": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2020": {
        "All": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2021": {
        "All": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    }
  },
  "Toyota": {
    "4Runner": {
      "1996": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.4L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.4L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.4L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.4L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.4L V6": {
          "Message": null,
          "PID": "BE1FB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2004": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FE893-9105A01F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105A01F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-91058001-5ADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FEDCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BF9FE893-9107B11F-FEDCAF01-68000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BF9FE893-9107B11F-FEDCAF01-68000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BF9FE893-9107B11F-FEDCAF01-68000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BF9FE893-9107B11F-FEDCAF01-68000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "86/GR86": {
      "2017": {
        "2.0L H4": {
          "Message": null,
          "PID": "BE3FA813-9007B011-FEDCA051-08080001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L H4": {
          "Message": null,
          "PID": "BE3FA813-9007B011-FEDCA051-08080001-00000002",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L H4": {
          "Message": null,
          "PID": "BE3FA813-9007B011-FEDCA051-68080001-0004000E",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L H4": {
          "Message": null,
          "PID": "BE3FA813-9007B011-FEDCA051-68080001-0004000E",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Avalon": {
      "1996": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.0L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FA811-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.0L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.0L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FA811-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105A01F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDC2021-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDC2021-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-7ADC8001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDCA021-08000001-00000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDCA021-08000001-00000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDCA021-08000001-00000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-08880001-02000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-68880001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107B11F-FEDCAF01-68080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-68880001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-68880001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.5L I4": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-68880001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-68880001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-68880001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "bZ4X": {
      "2023": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "C-HR": {
      "2018": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3FA813-9007B015-FEDCAC11-68000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Camry": {
      "1996": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.2L I4 CNG": {
          "Message": null,
          "PID": "BE3EA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FA811-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BE3FF810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FAC11-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDC3000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-7ADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDC3000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B001-5ADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDC3000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.4L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9005B015-FEDC2020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.4L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDC3020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDC2021-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDC2021-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDC2021-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-7ADC8001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDCA021-08000001-00000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDCA021-08000001-00000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDCA021-08000001-00000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCAC11-08880001-02000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-08880001-02000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA013-8007B815-FEDCAC11-68880001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-68880001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107B11F-FEDCAF01-68080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA013-8007B815-FEDCAC11-68880001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA013-8007B815-FEDCAC11-68880001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE1FA013-8007B815-FEDCAC11-68880001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA013-8007B815-FEDCAC11-68880001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA013-8007B815-FEDCAC11-68880001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE1FA013-8007B815-FEDCAC11-68880001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Celica": {
      "1996": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Corolla": {
      "1996": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "1.6L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-7ADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "1.8L I4": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA811-90000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA811-90000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA811-90000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3FA813-9005B015-FADCA011-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3FA813-9007B015-FEDCAC11-68000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3FA813-9007B015-FEDCAC11-68000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDCBC21-68800001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE3FA813-9007B015-FEDCAC11-68000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9007B015-FEDCAC11-68000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FA813-9007B015-FEDCAC11-68000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE1FA013-8007B815-FEDCAC15-68090201-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE1FA013-8007B815-FEDCAC15-68090201-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE1FA013-8007B815-FEDCAC15-68090201-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE1FA013-8007B815-FEDCAC15-68090201-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Corolla Cross": {
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Corolla Hatchback": {
      "2019": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Corolla iM": {
      "2017": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Crown": {
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Echo": {
      "2000": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "FJ Cruiser": {
      "2007": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "GR Corolla": {
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Highlander": {
      "2001": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FA811-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.4L I4": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FA811-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.4L I4": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.3L V6 Hybrid": {
          "Message": null,
          "PID": "BF9FA893-9105A01F-FEDC3000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.3L V6 Hybrid": {
          "Message": null,
          "PID": "BF9FA893-9105A01F-FEDC3000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": false,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.3L V6 Hybrid": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FEDC3000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.3L V6 Hybrid": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FEDC3000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.3L V6 Hybrid": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FEDC3020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FE813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FEDC3020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.3L V6 Hybrid": {
          "Message": null,
          "PID": "BFBFA893-9115B11F-FEDC3020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.3L V6 Hybrid": {
          "Message": null,
          "PID": "BFBFA893-9115B11F-FEDC3020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FE813-9005B015-FADCA000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.3L V6 Hybrid": {
          "Message": null,
          "PID": "BFBFA893-9115B11F-FEDCB021-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FE813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.3L V6 Hybrid": {
          "Message": null,
          "PID": "BFBFA893-9115B11F-FEDCB021-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.3L V6 Hybrid": {
          "Message": null,
          "PID": "BFBFA893-9115B11F-FEDCB021-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FE813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BFBFA893-B115B11F-FEDCB021-08080001-00000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FE813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BFBFA893-B115B11F-FEDCB021-08080001-00000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FE813-9005B015-FEDCAC01-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FEDCAF01-68080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6 Hybrid": {
          "Message": null,
          "PID": "BFBFA893-B115B11F-FEDCBF21-08080001-0000004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": true,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-68880001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE1FE813-9005B015-FEDCAC01-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCAC35-68880001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE1FE813-9005B015-FEDCAC01-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE1FA013-8007B815-FEDCAC11-6A090201-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE1FA013-8007B815-FEDCAC11-6A090201-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE1FA013-8007B815-FEDCAC11-6A090201-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE1FA013-8007B815-FEDCAC11-6A090201-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Landcruiser": {
      "1996": {
        "4.5L I6": {
          "Message": null,
          "PID": "BE1FB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "4.5L I6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2004": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105A01F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9107B11F-FADC6001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9107B11F-FADCE001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FEDCAF01-68000001-00040009",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FEDCAF01-68000001-00040009",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FEDCAF01-68000001-00040009",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "MR2": {
      "2000": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2001": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2002": {
        "1.8L I4": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2003": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2004": {
        "1.8L I4": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2005": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA811-90000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Matrix": {
      "2003": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "1.8L I4": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA811-90000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA811-90000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.8L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Mirai": {
      "2016": {
        "Hydrogen Fuel Cell": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2017": {
        "Hydrogen Fuel Cell": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2018": {
        "Hydrogen Fuel Cell": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2019": {
        "Hydrogen Fuel Cell": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2020": {
        "Hydrogen Fuel Cell": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2021": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2022": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2023": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "Paseo": {
      "1996": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE3EB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Previa": {
      "1996": {
        "2.4L I4 Supercharged": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "2.4L I4 Supercharged": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Prius": {
      "2001": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2002": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2003": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2004": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA813-9005E015-FEDC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA813-9005E015-FEDC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA813-9005E015-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA813-9005E015-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA813-9005E015-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA813-9005E015-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "1.8L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDC2020-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "1.8L I4 Hybrid": {
          "Message": null,
          "PID": "BE7FF87B-FF7DFFFD-FFFE7DF8-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "1.8L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDC2021-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDC2021-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.8L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDC2021-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDC2021-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.8L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDCA021-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDCA021-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.8L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDCA021-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDCA021-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.8L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDCB021-08800001-02000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.8L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDCB021-08800001-02000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDCB021-08800001-02000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.8L I4 Hybrid": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.8L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDCBC21-68800001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDCBC21-68800001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "1.8L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDCBC21-68800001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDCBC21-68800001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "1.8L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDCBC21-68800001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDCBC21-68800001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Prius C": {
      "2012": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDC2021-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDC2021-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FA1C2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FF813-9015F015-FEDCF021-08000001-423E3C42",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDCA021-08000001-00000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDCA021-08000001-00000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDCAC21-08000001-00000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDC8C21-08000001-00000041",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "1.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDC8C21-08000001-00000041",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Prius V": {
      "2012": {
        "1.8L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDC2021-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.8L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDC2021-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.8L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDCA021-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.8L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDCA021-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.8L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDCB021-08800001-02000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.8L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDCA021-08000001-00000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.8L I4 Hybrid": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Rav4": {
      "1996": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.0L I4": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.0L I4": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2003": {
        "2.0L I4": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2013": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2014": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2015": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDCA021-08000001-00000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE3FA813-9015B015-FEDCA021-08000001-00000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-08880001-02000040",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA013-8007B815-FEDCAC11-68880001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-68880001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA013-8007B815-FEDCAC11-68880001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA013-8007B815-FEDCAC11-68880001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.5L I4": {
          "Message": null,
          "PID": "BE1FA013-8007B815-FEDCAC11-68880001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": "BE1FA013-8007B815-FEDCAC11-68880001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I4 Plug-In Hybrid": {
          "Message": null,
          "PID": "BE1FA013-8005B815-FEDCBC31-68880001-0204004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE1FA013-8007B815-FEDCAC11-68880001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE1FA013-8007B815-FEDCAC11-68880001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE1FA013-8007B815-FEDCAC11-68880001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE1FA013-8007B815-FEDCAC11-68880001-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Sequoia": {
      "2001": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105A01F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFE893-9115B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FEDC6000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9FA893-B105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "4.6L V8": {
          "Message": null,
          "PID": "BF9CA893-B105B11F-FEDC2001-05000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-910DB17F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9107B11F-FADC6001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9107B11F-FADCE001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FEDCAF01-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FEDCAF01-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FEDCAF01-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Sienna": {
      "1998": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FA811-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FA811-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.0L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FA811-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.3L V6": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.3L V6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.3L V6": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FE813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08008000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B101-7EDC8F01-08080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9107B11F-FEDCAF01-68080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Solara": {
      "1999": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.2L I4": {
          "Message": null,
          "PID": "BE3EA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FA811-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FA811-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L V6": {
          "Message": null,
          "PID": "BF9FA811-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-7ADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.3L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Supra": {
      "1996": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BF9FB910-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "3.0L I6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-A007B011-FED08411-61000001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "T100": {
      "1996": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.4L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.4L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.4L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Tacoma": {
      "1996": {
        "2.4L I4": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L I4": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.4L V6": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.4L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L I4": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.4L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.4L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.4L V6": {
          "Message": null,
          "PID": "BE1FB811-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.4L V6": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.4L V6": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.4L V6": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "2.4L I4": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.7L I4": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.4L V6": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FE813-9005A015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9105A01F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FE813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FE813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FE813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FE813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FE813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FE813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FE813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2013": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2014": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FE813-9005B015-FADCA000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2015": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FE813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2016": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FE813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2017": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FE813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2018": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FE813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FEDCAF01-08080000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2019": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FE813-9005B015-FEDCAC01-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FEDCAF01-68080001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2020": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FE813-9005B015-FEDCAC01-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE1FE813-9005B015-FEDCAC01-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FE813-9005B015-FEDCAC01-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BE1FE813-9005B015-FEDCAC01-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE1FA013-8007B815-FEDCAC15-6B090201-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE1FA013-8007B815-FEDCAC15-6B090201-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE1FA013-8007B815-FEDCAC15-6B090201-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE1FA013-8007B815-FEDCAC15-6B090201-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Tercel": {
      "1996": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE3EB800-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1997": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1998": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "1999": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Tundra": {
      "2000": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "3.4L V6": {
          "Message": null,
          "PID": "BE1FA811-10000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9105A01F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105A01F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADC0000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFE893-9115B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADCA000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFE893-9115B11F-FEDCA000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BF9CA893-B105B11F-FEDC2001-05000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9107B11F-FADC6001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFE893-9115B11F-FEDCA000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9107B11F-FADC6001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "4.0L V6": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFE893-9115B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9107B11F-FADCE001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFE893-9115B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9107B11F-FADCE001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFE893-9115B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFE893-9115B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9107B11F-FADCE001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFE893-9115B11F-FADCAF01-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FEDCAF01-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "4.6L V8": {
          "Message": null,
          "PID": "BFBFE893-9115B11F-FADCAF01-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FE893-9105B11F-FEDCAF01-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "5.7L V8": {
          "Message": null,
          "PID": "BF9FB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BF9EA013-8007B99F-FEDCAF11-6D090201-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BF9EA013-8007B99F-FEDCAF11-6D090201-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BF9EA013-8007B99F-FEDCAF11-6D090201-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BF9EA013-8007B99F-FEDCAF11-6D090201-0204000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Venza": {
      "2009": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FFDD2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FE813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FE813-9005B015-FADCA000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FE813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.7L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.5L V6": {
          "Message": null,
          "PID": "BF9FA893-9105B11F-FADCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.5L I4 Hybrid": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Yaris": {
      "2006": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FADC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2011": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDC2000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDCA000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDCA000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDCA000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": false,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Yaris iA/Sedan": {
      "2016": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDCA000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.5L I4": {
          "Message": null,
          "PID": "BE1FA813-9005B015-FEDCA001-08000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    }
  },
  "Vinfast": {
    "All": {
      "2023": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    }
  },
  "Volkswagen": {
    "Arteon": {
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-68010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-A007B011-FED08401-6A010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-A007B011-FED08401-6A010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE1EA813-A007B011-FED08401-62010001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE1EA813-A007B011-FED08401-62010001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Atlas": {
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED08501-6A080001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-68010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED08501-6A080001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-68010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED08501-6A080001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-68010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-68010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE1EA813-A007B011-FED08401-62010001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE1EA813-A007B011-FED08401-62010001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE1EA813-A007B011-FED08401-62010001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE1EA813-A007B011-FED08401-62010001-0204000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Beetle": {
      "1998": {
        "1.9L I4 Turbo Diesel": {
          "Message": null,
          "PID": "983F8010-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FE810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.9L I4 Turbo Diesel": {
          "Message": null,
          "PID": "983F8010-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FE810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.9L I4 Turbo Diesel": {
          "Message": null,
          "PID": "983F8010-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "88180010-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.9L I4 Turbo Diesel": {
          "Message": null,
          "PID": "983F8010-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.9L I4 Turbo Diesel": {
          "Message": null,
          "PID": "983F8011-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FE810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.9L I4 Turbo Diesel": {
          "Message": null,
          "PID": "983F8011-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FE811-00001001-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FE811-80001001-C0000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.9L I4 Turbo Diesel": {
          "Message": null,
          "PID": "983B8019-90000001-00020000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FE811-00001001-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FEC11-80001001-C0000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.9L I4 Turbo Diesel": {
          "Message": null,
          "PID": "983B8019-90000001-00020000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FE811-80001001-C0000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "1.9L I4 Turbo Diesel": {
          "Message": null,
          "PID": "983B8019-90000001-80020000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.5L I5": {
          "Message": null,
          "PID": "BE3FE811-80001001-C0000400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "2.5L I5": {
          "Message": null,
          "PID": "BE3FE813-8005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2008": {
        "2.5L I5": {
          "Message": null,
          "PID": "BE3FE813-8005B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2009": {
        "2.5L I5": {
          "Message": null,
          "PID": "BE3FE813-8005B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2010": {
        "2.5L I5": {
          "Message": null,
          "PID": "BE3FEC13-8005B015-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2012": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FEC13-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I5": {
          "Message": null,
          "PID": "BE3EA813-8005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FEC13-A005B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "98192013-9801A011-C4D2800D-EAA9A343-C0A00000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I5": {
          "Message": null,
          "PID": "BE3EEC13-8005B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FEC13-A005B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "98192013-9801A011-C4D2800D-EAA9A343-C0A00000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I5": {
          "Message": null,
          "PID": "BE3EEC13-8005B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007B011-FED08401-00080000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "98192013-9801A011-C4D2800D-EAA9A343-C0A00000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-8007B011-FED08401-00080000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-8007B011-FED08401-00080000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A007B015-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-A007B011-FED08401-02010001-00040009",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-A007B011-FED08401-02010001-00040009",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "CC": {
      "2009": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FEC13-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-00018001-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FEC13-A005B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-A005B119-FED08500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FEC13-A005B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-A005B119-FED08500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A007B015-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED08501-00080000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A007B015-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED08501-00080000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A007B015-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED08501-00080000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED08501-00080000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Eos": {
      "2007": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BF9FE893-8005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BF9FE893-8005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FEC13-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FEC13-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FEC13-A005B015-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FEC13-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FEC13-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FEC13-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FEC13-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Eurovan": {
      "1996": {
        "2.4L I5 Diesel": {
          "Message": null,
          "PID": "BE1FF800-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "2.4L I5 Diesel": {
          "Message": null,
          "PID": "BE1FF800-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BE1FF800-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "2.8L V6": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "2.8L V6": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "2.8L V6": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "2.8L V6": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "2.8L V6": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "2.8L V6": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "2.8L V6": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": false,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Golf City": {
      "2006": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FE813-0001B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FE813-0001B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Golf Convertible": {
      "1996": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FF800-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FF800-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "Golf/Rabbit/GTI": {
      "1996": {
        "1.9L I4 Turbo Diesel": {
          "Message": null,
          "PID": "983F8010-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FF800-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FF800-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FF800-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "1.9L I4 Turbo Diesel": {
          "Message": null,
          "PID": "983F8010-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BE1FE811-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.9L I4 Turbo Diesel": {
          "Message": null,
          "PID": "983F8010-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BE1FE810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.9L I4 Turbo Diesel": {
          "Message": null,
          "PID": "983F8011-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BE1FE810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.9L I4 Turbo Diesel": {
          "Message": null,
          "PID": "983F8011-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BE1FE810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.9L I4 Turbo Diesel": {
          "Message": null,
          "PID": "983F8011-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.9L I4 Turbo Diesel": {
          "Message": null,
          "PID": "983B8019-90000001-00020000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FE811-00001001-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BF9FA891-80001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.9L I4 Turbo Diesel": {
          "Message": null,
          "PID": "983B8019-90000001-00020000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.9L I4 Turbo Diesel": {
          "Message": null,
          "PID": "983F8010-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I5": {
          "Message": null,
          "PID": "BE3FE813-8005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I5": {
          "Message": null,
          "PID": "BE3FE813-8005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I5": {
          "Message": null,
          "PID": "BE3FE813-8005B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.2L V6": {
          "Message": null,
          "PID": "BF9FE893-8005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I5": {
          "Message": null,
          "PID": "BE3EEC13-8005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "98192013-9801A011-C4D2800D-EAA9A343-C0A00000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I5": {
          "Message": null,
          "PID": "BE3EA813-8005B011-FED30400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "98192013-9801A011-C4D2800D-EAA9A343-C0A00000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I5": {
          "Message": null,
          "PID": "BE3FA811-10000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FEC13-A005B015-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo (Golf R)": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "98192013-9801A011-C4D2800D-EAA9A343-C0A00000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I5": {
          "Message": null,
          "PID": "BE3EEC13-8005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FEC13-A005B015-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo (Golf R)": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "98192013-9801A011-C4D2800D-EAA9A343-C0A00000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I5": {
          "Message": null,
          "PID": "BE3EEC13-8005B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FEC13-A005B015-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "98192013-9801A011-C4D2800D-EAA9A343-C0A00000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I5": {
          "Message": null,
          "PID": "BE3EEC13-8005B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": null,
          "PID": "BE1FEC13-A005B015-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-A001B001-CCD20001-02800301-29200000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": null,
          "PID": "98188011-80018001-E4C08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo (Golf R)": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-A001B001-CCD20001-02800301-29200000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": null,
          "PID": "BFBFF991-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo (Golf R)": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": null,
          "PID": "98180011-80018001-E4C08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-A007B011-FED08401-68010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo (Golf R)": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": null,
          "PID": "98180011-80018001-E4C08000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-8007B011-FED08401-6A090A01-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-A007B011-FED08401-00010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-A007B011-FED08401-68010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo (Golf R)": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08401-68010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "EV": {
          "Message": null,
          "PID": "BE3EE813-8007B011-FED08401-6A090A01-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-8007B011-FED08401-6A090A01-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-8007B011-FED08401-6A090A01-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "EV": {
          "Message": null,
          "PID": "BE3EE813-8007B011-FED08401-6A090A01-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": null,
              "Transmission and Drivetrain": null,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-8007B011-FED08401-6A090A01-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-8007B011-FED08401-6A090A01-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "ID.4": {
      "2021": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "ID.Buzz": {
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "Jetta City": {
      "2007": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FE813-0001B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Jetta/GLI": {
      "1996": {
        "1.9L I4 Turbo Diesel": {
          "Message": null,
          "PID": "983F8010-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FF800-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BE1FF800-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "1.9L I4 Turbo Diesel": {
          "Message": null,
          "PID": "983F8010-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FF800-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "1.9L I4 Turbo Diesel": {
          "Message": null,
          "PID": "983F8010-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "1.9L I4 Turbo Diesel": {
          "Message": null,
          "PID": "983F8010-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BE1FE810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2000": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.9L I4 Turbo Diesel": {
          "Message": null,
          "PID": "D983F801-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FF810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.9L I4 Turbo Diesel": {
          "Message": null,
          "PID": "D983F801-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "88180010-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BE1FE810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.9L I4 Turbo Diesel": {
          "Message": null,
          "PID": "983F8011-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BE1FE810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.9L I4 Turbo Diesel": {
          "Message": null,
          "PID": "983F8011-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FE811-00001001-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "1.9L I4 Turbo Diesel": {
          "Message": null,
          "PID": "983B8011-10000001-40020000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FE811-00001001-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.9L I4 Turbo Diesel": {
          "Message": null,
          "PID": "983B8019-90000001-80020000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I5": {
          "Message": null,
          "PID": "BE3FE811-80001001-C0000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2006": {
        "1.9L I4 Turbo Diesel": {
          "Message": null,
          "PID": "983B8019-90000001-00020000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I5": {
          "Message": null,
          "PID": "BE3FE813-8005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I5": {
          "Message": null,
          "PID": "BE3FEC13-8005B015-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I5": {
          "Message": null,
          "PID": "BE3FEC13-8005B015-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FE813-0001B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "98192013-9801A011-C4D2800D-EAA9A343-C0A00000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I5": {
          "Message": null,
          "PID": "BE3EE813-8005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FEC13-A005B015-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "98192013-9801A011-C4D2800D-EAA9A343-C0A00000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I5": {
          "Message": null,
          "PID": "BE3EA813-8005B011-FED30400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-8005B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "98192013-9801A011-C4D2800D-EAA9A343-C0A00000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I5": {
          "Message": null,
          "PID": "BE3EA813-8005B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-8005B011-FED30400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B015-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "98192013-9801A011-C4D2800D-EAA9A343-C0A00000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I5": {
          "Message": null,
          "PID": "BE3EEC13-8005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "1.4L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3EE813-8007B011-FED09421-00090A00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-8005B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B015-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "98192013-9801A011-C4D2800D-EAA9A343-C0A00000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I5": {
          "Message": null,
          "PID": "BE3EEC13-8005B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.4L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3EE813-8007B011-FED09421-00090A00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-8005B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "98192013-9801A011-C4D2800D-EAA9A343-C0A00000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I5": {
          "Message": null,
          "PID": "BE3EEC13-8005B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.4L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3EE813-8007B011-FED09421-00090A00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-8007B011-FED08401-00080000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE3EA813-8005B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007B011-FED08401-00080000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "9819A013-8001B015-CCD2800D-EAA9A343-E9A00000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007B011-FED08401-02090A00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.4L I4 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BE3EE813-8007B011-FED09421-00090A00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007B011-FED08401-00080000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007B011-FED08401-00080000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "983BA013-A001B001-CCD20001-02800301-29200000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007B011-FED08401-02090A00-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-8007B011-FED08401-00080000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007B011-FED08401-00080000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-8007B011-FED08401-6A090A01-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-8007B011-FED08401-00080000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-A007B011-FED08401-68010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-8007B011-FED08401-6A090A01-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-A007B011-FED08401-68010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-8007B011-FED08401-6A090A01-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-8007B011-FED08401-6A090A01-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "1.4L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-8007B011-FED08401-6A090A01-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-8007B011-FED08401-6A090A01-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": null,
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Passat": {
      "1996": {
        "1.9L I4 Turbo Diesel": {
          "Message": null,
          "PID": "983F8010-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4": {
          "Message": null,
          "PID": "BE1FF800-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BF9DB990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "1.9L I4 Turbo Diesel": {
          "Message": null,
          "PID": "983F8010-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BF9DB990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE3EB811-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BF9FF991-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2001": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2002": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L W8": {
          "Message": null,
          "PID": "BF9FE891-00001101-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2003": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L W8": {
          "Message": null,
          "PID": "BF9FE891-00001101-40000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": false,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2004": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "983B8019-90000001-00020000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.0L W8": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE1FE811-00001000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "983B8019-90000001-00020000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "2.8L V6": {
          "Message": null,
          "PID": "BF9FF990-00000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": null,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2007": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "9819A013-9001A015-CCD2800D-EAA9A343-A9200000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I5": {
          "Message": null,
          "PID": "BE3EEC13-8005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-A005B119-FED08500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "9819A013-9001A015-CCD2800D-EAA9A343-A9200000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I5": {
          "Message": null,
          "PID": "BE3EEC13-8005B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-A005B119-FED08500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-A007B015-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "9819A013-9001A015-CCD2800D-EAA9A343-E9200000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.5L I5": {
          "Message": null,
          "PID": "BE3EA813-8005B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED08501-00080000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE3EA813-8007B011-FED08401-00080000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "9819A013-8001B015-CCD2800D-EAA9A343-E9A00000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED08501-00080000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-8007B011-FED08401-00080000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "2.0L I4 Turbo Diesel": {
          "Message": null,
          "PID": "9819A013-8001B015-CCD2800D-EAA9A343-E9A00000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED08501-00080000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "1.8L I4 Turbo": {
          "Message": null,
          "PID": "BE3EE813-8007B011-FED08401-00080000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED08501-00080000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-A007B011-FED08401-02010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED08501-00080000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-A007B011-FED08401-62010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-A007B011-FED08401-62010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-A007B011-FED08401-62010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3EEC13-8005B011-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Phaeton": {
      "2004": {
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE891-00001101-00000500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "6.0L W12": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L W12": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": false,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE891-00001101-00000500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "6.0L W12": {
          "Message": null,
          "PID": "BF9FCAB9-00001541-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": null,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Routan": {
      "2009": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.8L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.0L V6": {
          "Message": null,
          "PID": "BFBEB993-801FA019-FED00000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.6L V6": {
          "Message": null,
          "PID": "BFBEB993-8007E019-FED0C000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    },
    "Taos": {
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3EE813-8007B011-FED0B411-6B09A001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3EE813-8007B011-FED0B411-6B09A001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3EE813-8007B011-FED0B411-6B09A001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3EE813-8007B011-FED0B411-6B09A001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Tiguan": {
      "2009": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B015-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B015-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A005B015-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A007B015-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A007B015-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE1FA813-A007B015-FED08400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-A007B011-FED08401-02010000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-A007B011-FED08401-6A010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-A007B011-FED08401-6A010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FE813-A007B011-FED08401-6A010001-0004000D",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE1FA813-A005B011-FED00400-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": null,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": null,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      }
    },
    "Touareg": {
      "2004": {
        "3.2L V6": {
          "Message": null,
          "PID": "95002013-80018001-F0000500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE891-00001100-00000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V10 Turbo Diesel": {
          "Message": null,
          "PID": "983B8019-91000001-00020000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2005": {
        "3.2L V6": {
          "Message": null,
          "PID": "BF9FE891-80001101-C0000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE891-80001101-C0000000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": null,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2006": {
        "3.2L V6": {
          "Message": null,
          "PID": "BF9FE891-80001101-C0000500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE891-80001101-C0000500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        },
        "5.0L V10 Turbo Diesel": {
          "Message": null,
          "PID": "983B8019-94000001-C0020000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": false,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": null,
              "Driver Assist and Active Safety": null,
              "Driver Information and Control": true,
              "Entertainment and Navigation": null,
              "Heat and Air Conditioning": true,
              "Lights": null,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": null,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": null,
              "Vehicle Control and Suspension": null
            }
          }
        }
      },
      "2007": {
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA891-A0001101-00000500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE891-80001101-C0000500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V10 Turbo Diesel": {
          "Message": null,
          "PID": "983B8019-94000001-C0020000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2008": {
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "5.0L V10 Turbo Diesel": {
          "Message": null,
          "PID": "983B8019-94000001-C0020000-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2009": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "981B2013-9001A015-C4D2000D-EA898141-20000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "4.2L V8": {
          "Message": null,
          "PID": "BF9FE893-A005B119-FED00500-00000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2010": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "981B2013-9001A015-C4D2000D-EA898143-E9000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-A005B119-FED30501-02000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": null,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2011": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "981B2013-9001A015-C4D2000D-EA898143-E9000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BF9CE893-A005B119-FED38501-03030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-A005B119-FED30501-02000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2012": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "981B2013-9001A015-C4D2000D-EA898143-E9000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BF9CE893-A005B119-FED08521-03030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-A005B119-FED08501-02000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2013": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "981BA013-9001A015-CCD2801D-EAA98143-E9220000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BF9CE893-A005B119-FED08521-03030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-A005B119-FED08501-02000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2014": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "981BA013-9001A015-CCD2801D-EAA98143-E9220000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BF9CE893-A005B119-FED08521-03030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-A005B119-FED08501-02000000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2015": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "981BA013-9001A015-CCD2801D-EAA98143-E9220000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.0L V6 Turbo Plug-In Hybrid": {
          "Message": null,
          "PID": "BF9CE893-A005B119-FED08521-03030200-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": true
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED08501-00080000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2016": {
        "3.0L V6 Turbo Diesel": {
          "Message": null,
          "PID": "981BA013-9001A015-CCD2801D-EAA98143-E9220000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        },
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED08501-00080000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      },
      "2017": {
        "3.6L V6": {
          "Message": null,
          "PID": "BF9FA893-8007B119-FED08501-00080000-00000000",
          "Restrictions": [
            "United States",
            "Canada"
          ],
          "Other": {
          },
          "OBD": true,
          "Enhanced": true,
          "Systems": {
            "Primary": {
              "Engine": true,
              "Transmission and Drivetrain": true,
              "ABS and Brakes": true,
              "Airbags and Restraints": true,
              "Tire Pressure": true,
              "4WD/AWD": true,
              "Hybrid and EV": null
            },
            "Secondary": {
              "Battery and Power": true,
              "Doors and Windows": true,
              "Driver Assist and Active Safety": true,
              "Driver Information and Control": true,
              "Entertainment and Navigation": true,
              "Heat and Air Conditioning": true,
              "Lights": true,
              "Premium Vehicle Options": null,
              "Seats and Mirrors": true,
              "Security & Keyless Entry": true,
              "Trailer and Auxiliary Equipment": true,
              "Vehicle Control and Suspension": true
            }
          }
        }
      }
    }
  },
  "Volvo": {
    "850": {
      "1996": {
        "2.3L I5 Turbo": {
          "Message": null,
          "PID": "BE1DB000-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5": {
          "Message": null,
          "PID": "BE1DB000-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "2.3L I5 Turbo": {
          "Message": null,
          "PID": "BE1DB000-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5": {
          "Message": null,
          "PID": "BE1DB000-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5 Turbo": {
          "Message": null,
          "PID": "BE1DB000-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "960": {
      "1996": {
        "2.9L I6": {
          "Message": null,
          "PID": "BE1DF000-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "2.9L I6": {
          "Message": null,
          "PID": "BE1DF81D-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "C30": {
      "2007": {
        "2.4L I5": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BF9FB991-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "2.4L I5": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "2.4L I5": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "2.4L I5": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "C40": {
      "2022": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2023": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      },
      "2024": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "C70": {
      "1998": {
        "2.3L I5 Turbo": {
          "Message": null,
          "PID": "BE1FF81D-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5 Turbo": {
          "Message": null,
          "PID": "BE1FF81D-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "2.3L I5 Turbo": {
          "Message": null,
          "PID": "BE1FA810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5 Turbo": {
          "Message": null,
          "PID": "BE1FA810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "2.3L I5 Turbo": {
          "Message": null,
          "PID": "BE1FA811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5 Turbo": {
          "Message": null,
          "PID": "BE1FA811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "2.3L I5 Turbo": {
          "Message": null,
          "PID": "BE1FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5 Turbo": {
          "Message": null,
          "PID": "BE1FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "2.3L I5 Turbo": {
          "Message": null,
          "PID": "BE1FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5 Turbo": {
          "Message": null,
          "PID": "BE1FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "2.3L I5 Turbo": {
          "Message": null,
          "PID": "BE1FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5 Turbo": {
          "Message": null,
          "PID": "BE1FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "2.3L I5 Turbo": {
          "Message": null,
          "PID": "BE1FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5 Turbo": {
          "Message": null,
          "PID": "BE1FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE5FA813-8005B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE5FA813-8005B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE5FA813-8005B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE5FA813-8005B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE5FA813-8005B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "EC40": {
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "EX30": {
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "EX90": {
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        }
      }
    },
    "S40": {
      "2000": {
        "1.9L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "1.9L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "1.9L I4 Turbo": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "1.9L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "1.9L I4 Turbo": {
          "Message": null,
          "PID": "88180011-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5": {
          "Message": null,
          "PID": "88180011-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "88180011-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "2.4L I5": {
          "Message": null,
          "PID": "BE7FAC13-8007B011-FFD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE7FAC13-8007B011-FFD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "2.4L I5": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FFD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FFD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "2.4L I5": {
          "Message": null,
          "PID": "BE5FA813-8005B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE5FA813-8005B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "2.4L I5": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FFD00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FFD00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "2.4L I5": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "2.4L I5": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "S60": {
      "2001": {
        "2.3L I5 Turbo": {
          "Message": null,
          "PID": "BE1FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5": {
          "Message": null,
          "PID": "BE1FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5 Turbo": {
          "Message": null,
          "PID": "BE1FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "2.3L I5 Turbo": {
          "Message": null,
          "PID": "BE1FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5": {
          "Message": null,
          "PID": "BE1FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5 Turbo": {
          "Message": null,
          "PID": "BE1FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "2.3L I5 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "2.3L I5 Turbo": {
          "Message": null,
          "PID": "BE1FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5": {
          "Message": null,
          "PID": "BE1FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE1FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "2.4L I5": {
          "Message": null,
          "PID": "BE5FA813-8005B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5 Turbo": {
          "Message": null,
          "PID": "BE5FA813-8005B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE5FA813-8005B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "2.4L I5 Turbo": {
          "Message": null,
          "PID": "BE5FA813-8005B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE5FA813-8005B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "2.4L I5 Turbo": {
          "Message": null,
          "PID": "BE5FA813-8005B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE5FA813-8005B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "2.4L I5 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "2.4L I5 Turbo": {
          "Message": null,
          "PID": "BE5FA813-8005B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE5FA813-8005B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FAC13-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged": {
          "Message": null,
          "PID": "BE3FAC13-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE3FAC13-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FAC13-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FAC13-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged": {
          "Message": null,
          "PID": "BE3FAC13-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE3FAC13-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FAC13-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FAC13-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged": {
          "Message": null,
          "PID": "BE3FAC13-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged Hybrid": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08481-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08481-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08481-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08481-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08481-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08481-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3FAC13-8007B011-FED084A5-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3FAC13-8007B011-FED084A5-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3FAC13-8007B011-FED084A5-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3FAC13-8007B011-FED084A5-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "S70": {
      "1998": {
        "2.3L I5 Turbo": {
          "Message": null,
          "PID": "BE1FF81D-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5": {
          "Message": null,
          "PID": "BE1FF81D-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5 Turbo": {
          "Message": null,
          "PID": "BE1FF81D-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "2.3L I5 Turbo": {
          "Message": null,
          "PID": "BE1FA810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5": {
          "Message": null,
          "PID": "BE1FA810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5 Turbo": {
          "Message": null,
          "PID": "BE1FA810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "2.3L I5 Turbo": {
          "Message": null,
          "PID": "BE1FA811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5": {
          "Message": null,
          "PID": "BE1FA811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5 Turbo": {
          "Message": null,
          "PID": "BE1FA811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "S80": {
      "1999": {
        "2.8L I6 Twin Turbo": {
          "Message": null,
          "PID": "BF9FA890-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.9L I6": {
          "Message": null,
          "PID": "BF9FA890-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "2.8L I6 Twin Turbo": {
          "Message": null,
          "PID": "BF9FA891-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.9L I6": {
          "Message": null,
          "PID": "BF9FA891-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "2.8L I6 Twin Turbo": {
          "Message": null,
          "PID": "BF9FA891-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.9L I6": {
          "Message": null,
          "PID": "BF9FA891-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "2.9L I6": {
          "Message": null,
          "PID": "BF9FA891-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.9L I6 Twin Turbo": {
          "Message": null,
          "PID": "BF9FA891-80001100-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "2.9L I6": {
          "Message": null,
          "PID": "BF9FA891-80001100-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.9L I6 Twin Turbo": {
          "Message": null,
          "PID": "BF9FA891-80001100-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE1FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.9L I6": {
          "Message": null,
          "PID": "BE1FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.9L I6 Twin Turbo": {
          "Message": null,
          "PID": "BE1FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE5FA813-8005B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.9L I6 Twin Turbo": {
          "Message": null,
          "PID": "BE5FA813-8005B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE5FA813-8005B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "3.2L I6": {
          "Message": null,
          "PID": "BFFFA893-8007B111-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BFFFA893-8007B111-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BFFFA893-8007B111-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L I6": {
          "Message": null,
          "PID": "BFFFA893-8007B111-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BFFFA893-8007B111-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L I6": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L I6": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L I6": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L I6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L I6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L I6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FAC13-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FAC13-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "S90": {
      "1998": {
        "2.9L I6": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged Hybrid": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "2.0L I4 Twincharged": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08481-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08481-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "2.0L I4 Twincharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged Hybrid": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3FAC13-801FB011-FED084A5-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3FAC13-801FB011-FED084A5-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3FAC13-801FB011-FED084A5-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3FAC13-801FB011-FED084A5-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "V40": {
      "2000": {
        "1.9L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "1.9L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "1.9L I4 Turbo": {
          "Message": null,
          "PID": "88180011-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "1.9L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "1.9L I4 Turbo": {
          "Message": null,
          "PID": "BE3FB811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "V50": {
      "2005": {
        "2.4L I5": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FFD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FFD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "2.4L I5": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FFD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FFD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "2.4L I5": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "2.4L I5": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "2.4L I5": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "2.4L I5": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "V60": {
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FAC13-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE3FAC13-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FAC13-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08481-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08481-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged Hybrid": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08481-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE3FAC13-8007B011-FED094A5-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE3FAC13-8007B011-FED094A5-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE3FAC13-8007B011-FED094A5-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE3FAC13-8007B011-FED094A5-60000001-0004004D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "V70": {
      "1998": {
        "2.3L I5 Turbo": {
          "Message": null,
          "PID": "BE1FF81D-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5": {
          "Message": null,
          "PID": "BE1FF81D-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5 Turbo": {
          "Message": null,
          "PID": "BE1FF81D-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "2.3L I5 Turbo": {
          "Message": null,
          "PID": "BE1FA810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5": {
          "Message": null,
          "PID": "BE1FA810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5 Turbo": {
          "Message": null,
          "PID": "BE1FA810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "2.3L I5 Turbo": {
          "Message": null,
          "PID": "BE1FA811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5": {
          "Message": null,
          "PID": "BE1FA811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5 Turbo": {
          "Message": null,
          "PID": "BE1FA811-80000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "2.3L I5 Turbo": {
          "Message": null,
          "PID": "BE1FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5": {
          "Message": null,
          "PID": "BE1FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5 Turbo": {
          "Message": null,
          "PID": "BE1FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "2.3L I5 Turbo": {
          "Message": null,
          "PID": "BE1FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5": {
          "Message": null,
          "PID": "BE1FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5 Turbo": {
          "Message": null,
          "PID": "BE1FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "2.3L I5 Turbo": {
          "Message": null,
          "PID": "BE7FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5": {
          "Message": null,
          "PID": "BE7FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5 Turbo": {
          "Message": null,
          "PID": "BE7FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE7FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "2.3L I5 Turbo": {
          "Message": null,
          "PID": "BE1FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5": {
          "Message": null,
          "PID": "BE1FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE1FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "2.4L I5": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FFD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.4L I5 Turbo": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FFD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FFD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "2.4L I5": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FFD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FFD00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "2.4L I5": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "3.2L I6": {
          "Message": null,
          "PID": "BFFFA893-8007B111-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "3.2L I6": {
          "Message": null,
          "PID": "BFFFA893-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "3.2L I6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "V90": {
      "1998": {
        "2.9L I6": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "2.0L I4 Twincharged": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08481-60000001-00040009",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08481-60000001-00040009",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08481-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08481-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "2.0L I4 Twincharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "XC40": {
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08481-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08481-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "EV": {
          "Message": "EVs are exempt from OBDII regulations and manufactures are permitted to use a proprietary/closed diagnostic system.",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": false,
          "Enhanced": false
        },
        "All Except EV": {
          "Message": null,
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "XC60": {
      "2010": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L I6": {
          "Message": null,
          "PID": "BE3EB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L I6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L I6": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L I6": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L I6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FAC13-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged": {
          "Message": null,
          "PID": "BE3FAC13-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE3FAC13-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FAC13-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L I6": {
          "Message": null,
          "PID": "BE3FAC13-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08481-60000001-00040009",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08481-60000001-00040009",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08481-60000001-00040009",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08481-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08481-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08481-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged Hybrid": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08481-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08481-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08481-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED08C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "XC70": {
      "2003": {
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE1FB810-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE1FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE5FA813-8005B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE1FA813-8005B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE5FA813-8005B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "3.2L I6": {
          "Message": null,
          "PID": "BFFFA893-8007B111-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L I6": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE7FAC13-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L I6": {
          "Message": null,
          "PID": "BE7FAC13-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L I6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L I6": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L I6": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L I6": {
          "Message": null,
          "PID": "BE7FA813-8007B011-FED00C00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.0L I6 Turbo": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "3.2L I6": {
          "Message": null,
          "PID": "BFBFB990-00000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    },
    "XC90": {
      "2003": {
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.9L I6 Twin Turbo": {
          "Message": null,
          "PID": "BF9FA891-11000000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE1FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.9L I6 Twin Turbo": {
          "Message": null,
          "PID": "BE1FA811-80001000-00000000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BE5FA813-8005B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.9L I6 Twin Turbo": {
          "Message": null,
          "PID": "BE5FA813-8005B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BE5FA813-8005B011-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "2.5L I5 Turbo": {
          "Message": null,
          "PID": "BFFFA893-8007B11F-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BFFFA893-8007B11F-FED00000-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "3.2L I6": {
          "Message": null,
          "PID": "BFFFA893-8007B111-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BFFFA893-8007B111-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "3.2L I6": {
          "Message": null,
          "PID": "BFFFA893-8007B111-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BFFFA893-8007B111-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "3.2L I6": {
          "Message": null,
          "PID": "BFFFA893-8007B111-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BFFFA893-8007B111-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "3.2L I6": {
          "Message": null,
          "PID": "BFFFA893-8007B119-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BFFFA893-8007B119-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "3.2L I6": {
          "Message": null,
          "PID": "BFFFA893-8007B119-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "4.4L V8": {
          "Message": null,
          "PID": "BFFFA893-8007B119-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "3.2L I6": {
          "Message": null,
          "PID": "BFFFA893-8007B119-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "3.2L I6": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "3.2L I6": {
          "Message": null,
          "PID": "BFFFA893-8007B119-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08C80-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged Hybrid": {
          "Message": null,
          "PID": "0",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08481-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08481-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08481-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08481-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08481-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08481-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "2.0L I4 Turbo": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08481-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08481-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        },
        "2.0L I4 Twincharged Hybrid": {
          "Message": null,
          "PID": "BE3FA813-8007B011-FED08481-60000001-0004000D",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": null,
          "PID": "BFFFA893-8007B111-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": null,
          "PID": "BFFFA893-8007B111-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": null,
          "PID": "BFFFA893-8007B111-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": null,
          "PID": "BFFFA893-8007B111-FED00F00-00000000-00000000",
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    }
  },
  "Volvo Trucks": {
    "All": {
      "1996": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    }
  },
  "Workhorse": {
    "All": {
      "1996": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1997": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1998": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "1999": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2000": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2001": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2002": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2003": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2004": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2005": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2006": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2007": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2008": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2009": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2010": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2011": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2012": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2013": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2014": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2015": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2016": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2017": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2018": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2019": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2020": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2021": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2022": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2023": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2024": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      },
      "2025": {
        "All": {
          "Message": "16 Pin Connector and 12V Electrical System Only<br>Not Compatible with Round Connector<br>Repair Reports Not Available",
          "PID": null,
          "Restrictions": null,
          "Other": {
          },
          "OBD": true,
          "Enhanced": false
        }
      }
    }
  }
}